export default {
  // 导航菜单
  menu: {
    home: '官网',
    copilot: 'Copilot',
    sage: 'Sage',
    help: '帮助',
    show: '展示',
    price: '报价',
    account: '账户',
    calendar: '日历',
    updateTime: '更新时间',
    JANUS:'极态',
    JANUSCopilot: '极态 Copilot',
    version: 'V3.1.0',
    selectDate: '选择日期',
    placeholder: '请输入股票、行业、基金名称或代码'
  },
  sidebar: {
    home: '首页',
    aiBase: 'AI 基座',
    companyProfile: '公司简介',
    media: '媒体',
    zh: '中'
  },
  mainHeader: {
    industry: '行业',
    stock: '个股',
    fund: '基金',
    tradingRefreshSoon: '交易时间，页面即将刷新'
  },
  // 登录和注册页面
  login: {
    PasswordLogin: '密码登录',
    SmsLogin: '短信登录',
    username: '用户名',
    password: '密码',
    forgotPassword: '忘记密码',
    login: '登录',
    registerNewAccount: '注册新账号',
    contactInfo: '联系方式: inquiry＠jitai.ai',
    pleaseEnterUsernameOrPhone: '请输入用户名或手机号',
    phone: '手机号',
    verificationCode: '验证码',
    getVerificationCode: '获取验证码',
    confirmPassword: '密码确认',
    name: '姓名',
    email: '邮箱',
    company: '公司',
    job: '职务',
    referrer: '推荐人',
    howDidYouHearAboutUs: '哪里了解到极态',
    riskDisclaimer: '《风险提示和法律声明》',
    privacyPolicy: '《用户数据隐私政策》',
    termsOfService: '《用户服务协议》',
    register: '注册',
    alreadyHaveAccount: '已有帐号,登录',
    pleaseEnterUsername: '请输入用户名',
    pleaseEnterPassword: '请输入密码',
    pleaseConfirmPassword: '请再次输入密码',
    pleaseEnterFullName: '请输入姓名',
    pleaseEnterEmail: '请输入邮箱',
    pleaseEnterCompany: '请输入公司',
    pleaseEnterPosition: '请输入职务',
    pleaseEnterReferrer: '请输入推荐人',
    pleaseEnterHowYouHeard: '请输入哪里了解到我们',
    pleaseEnterPhone: '请输入手机号',
    pleaseEnterVerificationCode: '请输入验证码',
    pleaseAgreeToTerms: '请勾选协议',
    newPassword: '新密码',
    confirmNewPassword: '新密码确认',
    confirm: '确认',
    emailMsg: '请留意邮箱中的开通通知消息。若有任何疑问或问题，欢迎随时与我们取得联系。',
    ContinueBrowsing: '继续浏览',
  },

  // 错误信息
  errorMessage: {
    errorPassword: '密码错误',
    invalidPhoneNumber: '手机号格式不正确',
    invalidVerificationCode: '验证码错误',
    minLength: '密码长度至少为8位',
    uppercaseRequired: '密码必须包含大写字母',
    lowercaseRequired: '密码必须包含小写字母',
    digitRequired: '密码必须包含数字',
    specialCharRequired: '密码必须包含特殊字符',
    startWithAlphanumeric: '密码必须以字母或数字开头',
    VerificationCodeSentSuccessfully: '验证码获取成功！',
    passwordMismatch: '两次输入密码不同，请确认',
    invalidEmailFormat: '邮箱格式不正确',
    registerSuccess: '注册成功！请登录',
    ApplicationSubmittedSuccessfully: '申请成功！',
    PasswordResetFailed: '重置密码失败',
    VerificationCodeSentFailed: '验证码获取失败',
    AccountExistSignIn: '已有账号,登录'

  },

  // 定价页面
  pricing: {
    // 页面标题 & 模块标题
    versionComparison: '版本比较',
    getQuote: '报价获取',

    // 功能模块名称（左侧标签）
    accountType: '账号类型',
    aomPrediction: '全A预测',
    industryPrediction: '行业预测',
    stockPrediction: '个股预测',
    mutualFund: '公募基金',
    accountQuantity: '账号数量',

    // 账户类型
    ultimate: '至尊版',
    flagship: '旗舰版',
    enhanced: '增强版',
    standard: '标准版',
    basic: '基础版',

    // 数据映射中的标签
    aom: '全A',
    indus: '行业',
    ticker: '个股',
    fund: '基金',
    bond: '债券',
    commodity: '商品',

    // 文字
    longTermForecast: '长效预测',
    standardForecast: '标准预测',
    preciseForecast: '精确预测',
    trendForecast: '趋势预测',
    dailyForecast: '逐天预测',
    weeklyForecast: '逐周预测',

    preciseScoring: '精确评分',
    tierScoring: '档位评分',

    multiDimensional: '全维度',
    singleDimensional: '单维度',

    strength: '强弱度',
    consistency: '一致性',
    liquidity: '流动性',

    fineExtremeDistribution: '极值精细分布',
    extremeDistribution: '极值分布',

    nonNormal: '非正态',
    normal: '正态',
    day: '天',
    percentageScale: '百分制',
    tieredSystem: '档制',


    // 账号类型选项
    professionalEdition: '专业版',
    institutionalEdition: '机构版',

    // 支付周期选项
    quarterlyPayment: '季度付费',
    annualPayment: '年度付费',

    // 行业预测层级
    industryLevelL1: 'L1',
    industryLevelL1L2: 'L1 + L2',

    // 个股预测说明文字
    stockQueryVolume: '个股预测查询量',
    queriesPerDay: '只/天',
    sharedQueryVolume: '单机构内所有账号共享查询量',

    // 不需要选项
    Needed: '需要',
    notNeeded: '不需要',

    // 行业地图: 百分制; 5档制
    industryMap: '行业地图',
    percentile: '百分制',
    fiveLevel: '5档制',

    // 弹窗提示
    loginRequiredTitle: '注意： 获取报价，请先登录',
    atLeastOneModuleRequired: '注意： 至少选择一个预测模块',
    goToLogin: '去登录',

    // 报价结果页
    quoteResult: '报价',
    priceUnit: '万元',
    contactForDetails: '可联系工作人员详细咨询、购买copilot产品'
  },

  // copilot header: copilot 头标题
  copilotHeader: {
    macro: '宏观',
    commodityIndex: '商品指数',
    bondIndex: '债券指数',
    forex: '外汇',
    allMarket: '全市场',
    AShareMarket: '全A预测',
    indexPerformance: '指数表现',
    globalPerformance: '全球表现',
    industry: '行业',
    industryPerformance: '行业表现',
    multiDimensionalMap: '多维地图',
    trendForecast: '趋势预测',
    industryForecast: '行业预测',
    stockForecast: '个股预测',
    fund: '基金',
    fundEvaluation: '基金评测',
    fundManager: '基金经理',
    fundCompany: '基金公司',
    watchlist: '自选股',
  },

  // aom view
  aomView: {
    leverageMoney: '杠杆资金',
    reverseRepoMoney: '逆回购资金',
    shortSellingMoney: '做空资金（融券）',
    majorShareholderTrading: '大股东增减持',
    northSouthBoundMoney: '南北向资金',

    majorShareholderBuy: '大股东增持',
    majorShareholderSell: '大股东减持',

    fundInflow: '流入市场',
    fundOutflow: '流出市场',

    buy: '买入',
    sell: '卖出',

    newShortPosition: '做空新增',
    shortCovering: '做空回购',

    netInflowLeverage: '杠杆资金净流入',
    netInflowReverseRepo: '逆回购资金净流入',
    netInflowShortSelling: '做空资金（融券）净流入',

    netMajorShareholderBuy: '大股东净增持',
    southboundFunds: '南向资金',
    northboundFunds: '北向资金',

    billion: '亿',
    marketMean: '全市场均值',
    marketWeightedMean: '全市场加权均值',
    percentile: '百分位',
    tradingVolume: '成交额',

    strength: '强弱度',
    consistency: '一致性',
    liquidity: '流动性',
    day: '天',
    turnoverRate: '换手率',

    allATrendChart: '全A趋势图',
    selectOverlayIndicators: '选择叠加指标',
    entireMarketOverlay: '全市场叠加',
    indicatorSelection: '指标选择',
    noData: '暂无数据',
    extremeStateAiScore: '极态AI预测评分',
    timeWindowSelection: '时间窗口选择',
    pleasePurchasePermission: '请购买相关权限',
    coreMarketIndicators: '市场核心指标',
    predictDate: '预测日',
    mean: '均值',
    low: '低',
    q1: '25分位',
    q2: '50分位',
    q3: '75分位',
    high: '高',

  },

  // high chart
  highChart: {
    companyName: '极态科技',
    minute: '分钟',
    all: '全部',
    from: '从',
    to: '到',
    zoom: '缩',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    sunday: '星期日',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    viewFullscreen: '全屏查看',
    exitFullscreen: '退出全屏',
    year: '年',
    month: '月',
    month3: '3月',
    month6: '6月',
    yearToDate: '今年',
    year1: '1年',

  },

  // 汇率
  forexView:{
    unknownCurrency: '未知货币',
    exchangeRateQuery: '汇率查询',
    selectCurrency: '选择货币',
    viewTrend: '查看走势',
    majorWorldCurrencies: '国际主要货币',
    exchange: '兑换',
    currencySelector: '货币选择',

    continent: '大洲',
    asia: '亚洲',
    europe: '欧洲',
    africa: '非洲',
    northAmerica: '北美洲',
    southAmerica: '南美洲',
    oceania: '大洋洲',

    usd: '美元',
    eur: '欧元',
    cny: '人民币',
    world: '世界',
    pleaseSelectCurrencyFirst: '请先选择货币',
    bubble: '气泡',
    forexIndex: '外汇指数',
    index: '指数',
    price: '价格',
    turnover: '成交额',
  },

  commodityView: {
    commodityIndex: '商品指数',
    selectCommodityIndex: '选择商品指数',
    fiveYears: '五年',
    all: '全部',
    search: '查询',
    noSelectedData: '暂无所选数据',
    maxSelections: '最多只能选择 {count} 个',
    open: '开',
    high: '高',
    low: '低',
    close: '收',
  },

  bondView: {
    singleIndex: '单指数',
    multiIndexCompare: '多指数对比',
    bondIndex: '债券指数',
    selectBondIndex: '选择债券指数',
    bondType: '债券类型',
    selectIndexType: '请选择指数类型',
    compensationPeriod: '代偿期',
    selectTenor: '请选择指数代偿期',
    fiveYears: '五年',
    all: '全部',
    search: '查询',
    noSelectedData: '暂无所选数据',
    rateTrend: '利率走势',
    noDailyData: '暂无当日数据',
    maxSelections: '最多只能选择 {count} 个',
    wealth: '财富',
    fullPrice: '全价',
    cleanPrice: '净价',
    settlementVolume: '现券结算量(亿元)',
    marketValueDuration: '平均市值法-久期(年)',
    cashflowDuration: '平均现金流法-久期(年)',
    marketValueConvexity: '平均市值法-凸性',
    cashflowConvexity: '平均现金流法-凸性',
    marketValueYtm: '平均市值法-到期收益率(%)',
    cashflowYtm: '平均现金流法-到期收益率(%)',
    bpValue: '平均基点价值(元)',
    averageCompensationPeriod: '平均代偿期(年)',
    averageCouponRate: '平均派息率(%)',
    totalMarketValuePrevDay: '指数上日总市值(亿元)',
    wealthChangePct: '财富指数涨跌幅(%)',
    fullPriceChangePct: '全价指数涨跌幅(%)',
    cleanPriceChangePct: '净价指数涨跌幅(%)',
    total: '总值',
    over10Years: '10年以上',
    years7to10: '7-10年',
    years5to7: '5-7年',
    years3to5: '3-5年',
    years1to3: '1-3年',
    under1Year: '一年以下',
    months9to12: '9-12个月',
    months6to9: '6-9个月',
    months3to6: '3-6个月',
    months0to3: '0-3个月',
    szse: '深交所',
    interbankMarket: '银行间市场',
    otcCounter: '柜台',
    offshoreOtc: '离岸场外市场',
    sse: '上交所',
  },


  // 指数详情
  indexFilterView: {
    SSEC: '上证指数',
    SZI: '深证指数',
    gemIndex: '创业扳指',
    star50: '科创50',
    gemComposite: '创业板综',
    SSE50: '上证50',
    csi300: '沪深300',
    csi500: '中证500',
    csi1000: '中证1000',
    csiA500: '中证A500',
    '000001.SH': '上证指数',
    '399001.SZ': '深证成指',
    '399006.SZ': '创业板指',
    '000688.SH': '科创50',
    '399102.SZ': '创业板综',
    '000016.SH': '上证50',
    '399300.SZ': '沪深300',
    '000905.SH': '中证500',
    '000852.SH': '中证1000',
    '000510.SH': '中证A500',
    '000510.CSI': '中证A500',
    '000985.CSI': '中证全指',
    '931023.CSI': '北京50',

    majorChinaIndex: 'A股主要指数',
    majorWorldIndex: '国际主要指数',
    FTXIN9: '富时中国A50指数',
    DJSH: '道沪指数',
    HK50: '香港恒生指数',
    US500: '标普500指数',
    IXIC: '纳斯达克综合指数',
    US2000: '罗素2000小盘股',
    VIX: 'VIX恐慌指数',
    GSPTSE: '多伦多S&P/TSX',
    BVSP: '巴西IBOVESPA',
    MXX: '墨西哥S&P/BMV IPC',
    DE40: '德国DAX30',
    UK100: '英国富时100',
    FCHI: '法国CAC40',
    AEX: '荷兰AEX',
    ES35: '西班牙IBEX35',
    IT40: '意大利富时MIB',
    SWI20: '瑞士SWI20',
    PSI20: '葡萄牙PSI',
    BFX: '比利时BEL20',
    ATX: '奥地利ATX',
    OMXS30: '瑞典OMX30',
    IMOEX: '俄罗斯MOEX',
    IRTS: '俄罗斯市值加权指数',
    WIG20: '波兰WIG20',
    BUX: '匈牙利BUX',
    XU100: '土耳其ISE National-100',
    TA35: '以色列TA35',
    TASI: '沙特TASI',
    JP225: '日经225',
    AXJO: '澳大利亚S&P/ASX200',
    TWII: '台湾加权指数',
    SETI: '泰国SET',
    KS11: '韩国KOSPI',
    JKSE: '印尼综合指数',
    NSEI: '印度S&P CNX NIFTY',
    BSESN: '印度BSE SENSEX',
    VNI30: '越南VN30',
    HSCAHPI: '恒生沪深港通AH股溢价指数',
    HSTECH: '恒生科技指数',
    DJI: '道琼斯工业平均指数',
    SPTSX: '加拿大多伦多S&P/TSX 60指数期货',
    KLSE: '马来西亚吉隆坡综合股价指数',

    index: '指数',
    majorIndex: '主要指数'

  },

  // AomCorrelation.vue 全球表现
  AomCorrelationVue:{
    annualReturn: '年化收益',
    periodReturn: '区间收益',
    risk: '风险',
    sharpe: '夏普表现',
    sortino: 'Sortino表现',
    noDataTip: '无数据，请稍后再试',
    quarter: '季度',
    halfYear: '半年',
    oneYear: '1年',
    threeYear: '3年',
    globalPerformance: '全球表现',
    indexCorrelation: '指数相关性',
    china: '中国',
    northLatinAmerica: '北美&拉美',
    europe: '欧洲',
    asiaPacific: '亚太',
    timeWindow: '时间窗口',
    logarithmic: '对数',
    region: '地区',
    correlation: '相关性',
  },

  // 账户页面
  accountVue: {
    basic: '初级',
    available: '可用',
    notActivated: '未开通',
    notApplied: '未申请',
    applicationUnderReview: '系统正在审核申请',
    approved: '申请通过',
    rejected: '申请失败',
    accountInfo: '账户信息',
    username: '用户名:',
    phone: '电话号:',
    accountStatus: '账户状态:',
    accountTier: '账号版本:',
    companyAccount: '公司账号',
    start_time: '账号开始时间:',
    end_time: '账号结束时间:',
    sageRole: 'sage角色:',
    applicationInformation: '申请信息',
    nickname: '姓名:',
    email: '邮箱:',
    company: '公司:',
    position: '职务:',
    referrer: '推荐人:',
    trialStatus: '试用状态:',
    permission: '权限信息',
    activatedMenus: '已开通菜单:',
    activatedPredictionFeatures: '已开通预测:',
    aomPrediction: 'AOM预测',
    day: '天',
    week: '周',
    percentile: '百分制',
    fiveLevel: '五档制',
    noData: '暂无',
    nonNormalDistribution: '非正态分布',
    normalDistribution: '正态分布',
    strength: '强弱度',
    consistency: '一致性',
    liquidity: '流动性',
    industryPrediction: '行业预测',
    levelRestriction: '等级限制',
    stockPrediction: '股票预测',
    predictionLevel: '预测级别',
    scoreType: '评分类型',
    predictionWindow: '预测窗口',
    evd: '极值分布',
    scoreCategory: '评分种类',
    dailyQueryLimit: '每日查询限制',
    predictionTraceback: '预测追溯',
    number: '只',
    total: '共',
  },


  // 行业表现
  industryCorrelationVue: {
    annualReturn: '年化收益',
    periodReturn: '区间收益',
    risk: '风险',
    sharpe: '夏普表现',
    sortino: 'sortino表现',
    noDataTip: '无数据，请稍后再试',
    correlation: '相关性',
    industryCorrelation: '行业相关性',
    quarter: '季度',
    halfYear: '半年',
    oneYear: '1年',
    threeYear: '3年',
    logarithmic: '对数',
    industry: '产业',
    marketIndex: '市场指数',
    primaryIndustry: '第一产业',
    secondaryIndustry: '第二产业',
    tertiaryIndustry : '第三产业',
    to: '至',
    industryPerformance: '行业表现',
    timeWindow: '时间窗口',
    kpiTips1:
      '### 行业表现\nx 轴表示风险：\n- 定义：计量时间窗口收益的年化离散度\n- 年化离散度 = $\\sqrt{N_t} * std(r_t)$\n- $r_t$ = 日收益\n- $N_t$ = 年交易天数\n\n<br>\n\ny 轴表示收益：\n- 定义：计量时间窗口的年化收益\n- 年化收益：$r_{yr} = r_p * M_p$\n- $r_p$ = 区间回报\n- $M_p$ = 一年的区间数量',
    kpiTips2:
      '### Sharpe 表现\n- Sharpe 比率 = $(r_p - r_f)/\\sigma_p$\n- $r_p$ 代表时间窗口的年化收益率\n- $r_f$ 代表无风险利率，取用区间内 10 年期国债平均收益率\n- $\\sigma_p$ 代表行业回报的年化标准差，用于衡量其波动性或风险\n\n<br>\n\n### Sortino 表现\n- Sortino 比率 = $(r_p - r_f)/DR$\n- $r_p$ 代表时间窗口的年化收益率\n- $r_f$ 代表无风险利率，取用区间内 10 年期国债平均收益率\n- $DR$ 代表下行标准差\n- 下行风险是指投资回报低于无风险利率的幅度，只聚焦于负面回报，而忽略正向波动',
    kpiTips3:
      '### 行业相关性\n衡量两个行业或指数的价格变动相关性，计算使用日对数价格差作为计算基础。\n结果范围：[-1, +1]\n- 相关性 = +1：价格波动完全一致\n- 相关性 = 0：两个行业或指数的价格变动独立于彼此\n- 相关性 = -1：价格波动完全相反\n\n<br>\n\n计算提示：\n- 在估算相关性矩阵时，样本量（N）通常小于资产数量（P），因此估算结果容易对输入数据过度敏感，或出现 ill-conditioned estimate。\n- 为了解决这个问题，金融领域的标准方法是使用 Shrinkage 算法降低估计相关系数的波动，其中常见方法是 Ledoit-Wolf Method。\n- 极态提供的相关性矩阵基于改良的 Shrinkage method，相比 Ledoit-Wolf 在 N << P 条件下更加稳定，并且矩阵会进行估算后处理，通过主成分分析进一步降低市场噪声对估计值的影响。',
    kpiTips4: '- 点击行业层级按钮，可筛选并高亮对应行业或市场指数；再次点击可恢复全量展示。'
  },

  // 行业地图
  indusTreeMapVue: {
    comparedToPreviousDay: '较前一天',
    score: '分',
    turnover: '成交额',
    billion: '亿',
    mvFloat: '流通市值',
    trillion: '万亿',
    doubleClickHint: '(可双击)',
    all: '全部',
    predictionScoreMap: '预测评分地图',
    priceVolumeMap: '量价地图',
    valuationMetricsMap: '估值指标地图',
    fundFlowMap: '资金流地图',
    industry: '行业',
    filterPanel: '筛选面板',
    metricCategory: '指标分类',
    heatTreemap: '热力树图',
    mapArea: '地图面积',
    timeWindow: '时间窗口',
    day: '天',
    kpiTips1: '- 地图面积用于控制行业板块在热力树图中的面积基准。\n- 流通市值：按行业流通市值显示面积。\n- 成交额：按行业成交额显示面积。',
    kpiTips2: '- 行业预测评分地图展示行业在强弱度、流动性、拥挤度等维度上的评分分布。',
    kpiTips3: '- 行业估值指标地图展示行业在 PE、PB、PS、股息率等估值维度上的横向分布。',
    kpiTips4: '- 行业资金流地图展示行业在杠杆资金、做空资金、大股东增持与交易拥挤度等维度上的变化。',
    industryPredictionScoreMap: '行业预测评分地图',
    strengthWithTimeOption: '强弱度（时间可选）',
    liquidityWithTimeOption: '流动性（时间可选）',
    crowdingWithTimeOption: '拥挤度（时间可选）',
    timeOptional: '时间可选',
    industryPriceVolumeMap: '行业量价地图',
    changePercentWithTimeOption: '涨跌幅（时间可选）',
    turnoverRateWithTimeOption: '换手率（时间可选）',
    changePercent: '涨跌幅',
    turnoverRate: '换手率',
    industryValuationMetricsMap: '行业估值指标地图',
    pe: 'PE',
    peTtm: 'PE-TTM',
    pb: 'PB',
    ps: 'PS',
    psTtm: 'PS-TTM',
    dv: 'DV',
    dvTtm: 'DV-TTM',
    industryFundFlowMap: '行业资金流地图',
    leveragedFundFlowSpeedT1: '杠杆资金流速 T-1（时间可选）',
    leveragedPositionRatioT1: '杠杆资金持仓比例 T-1',
    shortSellingFundFlowSpeedT1: '做空资金流速 T-1（时间可选）',
    shortSellingPositionRatioT1: '做空资金持仓比例 T-1',
    majorShareholderNetIncrease: '大股东净增持',
    totalFundInflowSpeed: '资金总流入速度（时间可选）',
    largeFundInflowSpeed: '大资金流入速度（时间可选）',
    smallFundInflowSpeed: '小资金流入速度（时间可选）',
    tradingCrowding: '交易拥挤度（时间可选）',
    noData: '暂无数据',
    pleasePurchasePermission: '请购买相关权限',
    level: '档',
    times: '倍',
  },

  // 趋势预测
  industryTendencyVue:{
    title:'行业态势预测（周）',
    strength:'强弱度',
    crowding:'拥挤度',
    crowded:'拥挤',
    relaxed:'宽松',
    strong:'强势',
    weak:'弱势',
    marketValue:'市值',
    kpiTips1:'- 圆圈大小：log 市值；\n- 最亮圆：极态 AI 对未来一周申万 L1 行业的最新预测；\n- 较淡圆：以周为单位的预测历史，时间越久颜色越淡。\n- 鼠标悬停：高亮显示当前L1行业，并用线连接以显示预测历史走势。',
    kpiTips2:'- 极态 AI 对未来一周申万 L1 行业的预测强弱度排序。',
    kpiTips3:'- 极态 AI 对未来一周申万 L1 行业的预测拥挤度排序',
    noData:'无数据，请稍后再试',
    doubleClickHint: '(可双击)',
    trillion: '万亿',
  },

  // 行业筛选
  industryFilterVue: {
    primaryIndustry: '第一产业',
    secondaryIndustry: '第二产业',
    tertiaryIndustry: '第三产业',
    searchHint: '可在上方搜索L1、L2行业',
    noTopData: '暂无top数据',
    swL1: '申万一级',
    last: '近',
    day: '天',
    change: '涨幅',
    turnoverRate: '换手率',
  },

  // 行业详情
  industryViewVue: {
    mshInflowTotal: '大股东增持',
    mshOutflowTotal: '大股东减持',
    w: '万',
    buy: '买入',
    sell: '卖出',
    ssSellTotal: '做空新增',
    ssRepurchaseTotal: '做空回购',
    lb: '杠杆资金',
    ssFlow: '做空资金（融券）',
    mshFlow: '大股东增减持',
    snFlow: '资金流向',
    mfVelocity: '资金流速',
    tradeCongestionIndex: '交易拥挤度',
    lbPositionRatio: '杠杆资金持仓比例',
    lbFlow: '杠杆资金',
    lbFlowNet: '杠杆资金净流入',
    ssFlowNet: '做空资金（融券）净流入',
    mshFlowNet: '大股东净增持',
    mfDirectionLrg: '大单流向',
    mfDirectionSml: '小单流向',
    mfVelocityLrg: '大单流速',
    mfVelocitySml: '小单流速',
    MA5: '5日均线',
    MA14: '14日均线',
    priceChannel: '价格通道',
    BBands: '布林带(20,2)',
    marginBuyRepay: '融资买入、偿还',
    marginNetBuy: '融资净买入',
    noData: '无数据，请稍后再试',
    strength: '强弱度',
    conviction: '把握度',
    liquidity: '流动性',
    level: '档',
    day: '天',
    forecastDate: '预测日',
    industryIndex: '行业指数',
    open: '开',
    high: '高',
    low: '低',
    close: '收',
    turnover: '成交额',
    percentile: '百分位',
    predictedTurnover: '预测成交额',
    predictedPrice: '预测价格',
    ungrouped: '未分组',
    all: '全部',
    previousClose: '昨收',
    price: '价格',
    TimestampAlreadyExistsSkippingPush: '时间戳已存在，不执行 push 操作',
    prediction: '预测',
    constituents: '成分股',
    industry: '行业',
    IncludeL2: '包含二级行业',
    addToWatchlist: '加入自选',
    intraday: '分时',
    dailyKLine: '日k',
    selectOverlayIndicator: '选择叠加指标',
    selectIndustryOverlayIndicator: '选择行业叠加指标',
    color: '颜色',
    logarithmic: '对数',
    SelectIndicators: '指标选择',
    JANUSAIPredictionScore: '极态AI预测评分',
    NoData: '暂无数据',
    SelectTimeWindow: '时间窗口选择',
    pleasePurchasePermission: '请购买相关权限',
    tradeDate: '交易日期',
    mvTotal: '总市值',
    avgMvTotal: '平均公司总市值',
    dy: '分红率',
    pe: '市盈率',
    ps: '市销率',
    turnoverRateE: '自由流通股换手率',
    companyNumber: '公司个数',
    mvFloat: '流通总市值',
    avgMvFloat: '平均公司流通市值',
    dyTTM: 'TTM分红率',
    peTTM: 'TTM市盈率',
    psTTM: 'TTM市销率',
    pb: '市净率',
    times: '倍',
    billion: '亿',
    kpiTips: `
### AI相对强弱度指数
**定义：** 衡量公司或行业在未来跑赢市场概率的评分；
计算试用公司在当下截面日的预期回报（mean logged return）相对于A股同期间预期回报的差值评分。
大于50分： 预期未来区间跑赢市场
小于50分： 预期未来区间跑输市场
<br>
### AI相对趋势把握度指数
**定义：** 衡量AI对于公司或行业未来趋势把握度的评分；
计算基于预期波动率（波动率越大预测把握相对越低）和预期价格的极值分布区间（极值相差越大预测把握越不确定）。
大于50分： AI对于未来趋势的把握好于市场平均水平
小于50分： AI对于未来趋势的把握差于市场平均水平
<br>
### AI流动性预测指数
**定义：** 衡量AI对于未来公司或行业流动性的相对宽松和收紧的评分；
计算基于预期流动性相对于历史流动性的相对倍数计算（倍数越大未来流动性越好）。
大于50分： 预期未来流动性好于市场平均水平
小于50分： 预期未来流动性差于市场平均水平
<br>
### 评分后面的较小数字
表示：相较前一天的比分变化
`,
    kpiTips2: `
#### 杠杆资金：
  - 展示融资资金的流入与流出趋势。
  - <br/>

#### 逆回购资金：
  - 计算逻辑
  - 逆回购资金 = 当天到期回购资金总量 - 当天新增回购资金总量
  - 覆盖品类：上交所逆回购 GCXXX 系列和深交所R-XXX系列
  - 期限覆盖：1 - 28天
  - 正值：逆回购资金流入市场。
  - 负值：逆回购资金流出市场（用于购买逆回购）。
  - <br/>

#### 做空资金（融券）：
  - 展示融券资金的走势。
  - <br/>

#### 大股东增减持：
  - 0轴上方（红色）：大股东增持。
  - 0轴下方（绿色）：大股东减持。
  - <br/>
  
#### 南北向资金：
  - 蓝色：南向资金。
  - 橘黄色：北向资金。
  - 定义：
    - 南向资金：
      - 内地投资者通过沪、深港通买入香港联交所股票的资金。
      - 资金流动方向：北 → 南（进入港股市场）。
    - 北向资金：
      - 通过沪、深港通从香港市场流入 A 股的香港及国际资金。
      - 资金流动方向：南 → 北（进入 A 股市场）。
`,
  },

  // top 20
  industryTopVue: {
    kpiTips3: '### 目标价\n- 展示过去一年内评级机构给出的目标价区间与股价的对比\n- 目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
    kpiTips4: '### 评级分布\n- 展示过去三个月内，机构对当前个股的评级占比，并对比其所属二级行业内所有个股的平均评级占比\n- 将近百种不同评级名称统一为：强烈买入、买入、持有、卖出、强烈卖出',

    tableTitleTop20: 'TOP20成分股',

    columnName: '名称',
    mvTotal: '市值',
    mvTotalRatio: '市值占比',
    columnClose: '价格',
    pctChg: '表现',
    pctChg7: '一周表现',
    pctChg30: '一月表现',
    pctChg90: '一季表现',
    pctChg365: '一年表现',
    turnoverRateF: '换手率',
    pe: 'pe',
    peTtm: 'pe(ttm)',
    dvRatio: '股息收益率(div%)',
    dvTtm: '股息收益率(ttm)',
    billion: '亿',
  },


  // tickerFilter.vue
  tickerFilterVue: {
    turnoverRateFAvg: '换手率',
    pctChg: '收益率',
    pctChgAnnlzd: '年化收益率',
    ssFlowNetSum: '融资与融券',
    mfAmtAllSum: '资金流动',

    opIncome: '营业收入增长',
    netProfit: '净利润增长',
    roe: 'ROE增长',
    roa: 'ROA增长',

    volatility: '波动率',
    volatilityAnnlzd: '年化波动率',
    semiDev: '下行偏差',
    maxDrawDownType2: '区间最大回撤',
    sharpe: '夏普比率',
    sortino: 'Sortino比率',
    calmarType1: '卡玛比率',
    calmarType2: '区间卡玛比率',
    beta: 'Beta值',

    afaf: '农、林、牧、渔业',
    agriculture: '农业',
    forestry: '林业',
    animalHusbandry: '牧业',
    fishery: '渔业',
    marketValue: '市值',
    billion: '亿',
    billionDown: '亿以下',
    billionUp: '亿以上',
    rank: '排名',
    top: '前',
    bottom: '后',
    week: '周',
    pastWeek: '近一周',
    loss: '亏损',
    below: '以下',
    above: '以上',
    mvFloat: '流通市值',
    upcomingEarnings: '即将发布财报',
    mshFlow: '大股东增减持',
    past1m: '过去1个月',
    InstitutionalRating: '机构评级',
    ratingCount: '评级次数',
    Non: '无',
    times: '次',
    swIndustry: '申万行业',
    unlimited: '不限',
    swIndustryPlaceholder: '请选择申万行业',
    indexConstituents: '指数成分',
    marketBoard: '市场板块',
    crossSectionMetrics: '截面指标',
    stageSorting: '阶段排序',
    keyword: '关键字',
    keywordPlaceholder: '请输入关键字',
    selectedTags: '已选标签',
    clearAll: '清空',
    filterResult: '筛选结果',
    resultHint: '筛选结果随标签动态更新',
    pe: '市盈率',
    pb: '市净率',
    ps: '市销率',
    dividendYield: '股息率',
    stockName: '股票名称',
    industryBelonging: '行业归属',
    closePrice: '收盘价',
    change: '涨跌幅',
    dividendYieldTtm: '股息率TTM',
    totalMarketCap: '总市值',
    totalShares: '总股本',
    floatShares: '流通股本',
    shareUnit: '股',
    shareUnit10k: '万股',
    oneDay: '近1日',
    oneWeek: '近1周',
    oneMonth: '近1月',
    sixMonths: '近6月',
    oneYear: '近1年',
    avgTurnoverRate: '平均换手率',
    fundInOut: '资金流入流出',
    marginFinancingAndSecuritiesLending: '融资融券',
    maxDrawdownL2: '区间最大回撤',
    calmarL2: '区间卡玛比率',
    oneYearCagr: '1年复合增长',
    threeYearCagr: '3年复合增长',
    fetchLastTradingDayFailed: '获取最近交易日失败',
    fetchTickerDataFailed: '获取股票筛选数据失败',
  },

  // tickerViewVue
  tickerViewVue: {
    past2Y: '近 2 年',
    past5Y: '近 5 年',
    past10Y: '近 10 年',
    all: '全部',
    mshInflowTotal: '大股东增持',
    yuan: '元',
    mshOutflowTotal: '大股东减持',
    buy: '买入',
    sell: '卖出',
    ssSellTotal: '做空新增',
    ssRepurchaseTotal: '做空回购',
    lb: '杠杆资金',
    ssFlow: '做空资金（融券）',
    mshFlow: '大股东增减持',
    snFlow: '资金流向',
    mfVelocity: '资金流速',
    tradeCongestionIndex: '交易拥挤度',
    lbPositionRatio: '杠杆资金持仓比例',
    lbFlow: '杠杆资金',
    lbFlowNet: '杠杆资金净流入',
    ssFlowNet: '做空资金（融券）净流入',
    mshFlowNet: '大股东净增持',
    mfDirectionLrg: '大单流向',
    mfDirectionSml: '小单流向',
    mfVelocityLrg: '大单流速',
    mfVelocitySml: '小单流速',
    financing: '融资',
    billion: '亿',
    marginNetBuy: '融资净买入',
    l1: ' (一级)',
    l2: ' (二级)',
    scoreDeltaUnit: '分',
    strength: '强弱度',
    conviction: '把握度',
    liquidity: '流动性',
    level: '档',
    day: '天',
    NoFinancingData: '无融资数据',
    forecastDate: '预测日',
    price: '价格',
    predictedPrice: '预测价格',
    percentile: '百分位',
    event: '事件',
    trade: '交易',
    total: '共',
    records: '条(点击查看)',
    assets: '资产',
    sentiment: '舆情',
    financialReport: '财报',
    change: '涨跌',
    open: '开',
    high: '高',
    low: '低',
    close: '收',
    turnover: '成交额',
    predictedTurnover: '预测成交额',
    kpiTips: `
### AI相对强弱度指数
**定义：** 衡量公司在未来跑赢市场概率的评分。
计算公司在当前截面日期的预期回报（mean logged return）相对于A股同期预期回报的差值评分。
大于50分：预期未来区间跑赢市场
小于50分：预期未来区间跑输市场
<br>
### AI相对趋势把握度指数
**定义：** 衡量AI对公司未来趋势把握程度的评分。
计算基于预期波动率和预期价格极值分布区间的综合评分。
大于50分：AI对未来趋势的把握好于市场平均水平
小于50分：AI对未来趋势的把握差于市场平均水平
<br>
### AI流动性预测指数
**定义：** 衡量AI对未来公司流动性宽松或收紧程度的评分。
计算基于预期流动性相对于历史流动性的相对倍数评分。
大于50分：预期未来流动性好于市场平均水平
小于50分：预期未来流动性差于市场平均水平
<br>
### 评分后面的较小数字
表示：相较前一天的比分变化
`,
    kpiTips1: `
### 估值指标
- 展示当前个股估值与过去一年内的估值分布情况
- <br>

- 极值处理：
$ IQR = Q_{75} - Q_{25} $
$ \\text{上限} = Q_{75} + 3 \\times IQR $
$ \\text{下限} = Q_{25} - 3 \\times IQR $
`,
    kpiTips2: `
#### 杠杆资金：
  - 展示融资资金的流入与流出趋势。
  - <br/>

#### 逆回购资金：
  - 计算逻辑
  - 逆回购资金 = 当天到期回购资金总量 - 当天新增回购资金总量
  - 覆盖品类：上交所逆回购 GCXXX 系列和深交所 R-XXX 系列
  - 期限覆盖：1 - 28 天
  - 正数：逆回购资金流入市场。
  - 负数：逆回购资金流出市场（用于购买逆回购）。
  - <br/>

#### 做空资金（融券）：
  - 展示融券资金的走势。
  - <br/>

#### 大股东增减持：
  - 0 轴上方（红色）：大股东增持。
  - 0 轴下方（绿色）：大股东减持。
  - <br/>
  
#### 南北向资金：
  - 蓝色：南向资金。
  - 橙黄色：北向资金。
  - 定义：
    - 南向资金：
      - 内地投资者通过沪、深港通买入香港联交所股票的资金。
      - 资金流动方向：北 -> 南（进入港股市场）。
    - 北向资金：
      - 通过沪、深港通从香港市场流入A股的香港及国际资金。
      - 资金流动方向：南 -> 北（进入A股市场）。
`,
    ungrouped: '未分组',
    loss: '亏损',
    past1y: '过去一年',
    lowest: '最低',
    current: '当前',
    q75: '75分位',
    q50: '50分位',
    q25: '25分位',
    prevClose: '昨收',
    forecast: '预测',
    rating: '评级',
    shareholder: '股东',
    stock: '股票',
    highest: '最高',
    limitUp: '涨停',
    limitDown: '跌停',
    volume: '成交量',
    addToWatchlist: '加入自选',
    intraday: '分时',
    dailyKLine: '日k',
    selectOverlayIndicator: '选择叠加指标',
    selectIndustryOverlayIndicator: '选择行业叠加指标',
    color: '颜色',
    logarithmic: '对数',
    resetView: '重置',
    fullscreen: '全屏',
    selectIndicators: '指标选择',
    JANUSAIPredictionScore: '极态AI预测评分',
    NoData: '暂无数据',
    reachedLimit: '您的个股预测搜索量已达上限',
    selectTimeWindow: '时间窗口选择',
    pleasePurchasePermission: '请购买相关权限',
    mvTotal: '总市值',
    turnoverRate5d: '5日换手率',
    mvFloat: '流通市值',
    turnoverRate20d: '20日换手率',
    valuationMetrics: '估值指标',
    orderBook: '盘口信息',
    bid: '买盘',
    ask: '卖盘',
    bid1: '买',
    ask1: '卖',
    listingBoard: '上市板块',
    exchange: '交易所',
    listingDate: '上市日期',
    region: '区域',
    employeeCount: '员工数量',
    companyWebsite: '公司官网',
    actualController: '实控人',
    actualControllerType: '实控人性质',
    legalRep: '法人代表',
    generalManager: '总经理',
    boardSecretary: '董秘',
    mainBusiness: '主营业务',
    forward: '前复权',
    backward: '后复权',
    noAdjustment: '不复权',
    introduction: '简介',
    w: '10K',
    gu: '股',
    timestampAlreadyExistsSkippingPush: '时间戳已存在，不执行 push 操作',

  },
    highchartStockToolsVue: {
      indicator: '指标',
    sma: '简单移动平均线',
    ema: '指数移动平均线',
    bb: '布林带',
    period: '周期',
    add: '添加',
    color: '颜色',
    width: '宽度',
    save: '保存',
    shapes: '形状',
    label: '标签',
    circle: '圆形',
    rectangle: '矩形',
    ellipse: '椭圆',
    lines: '线条',
    segment: '线段',
    arrowSegment: '箭头线段',
    ray: '射线',
    arrowRay: '箭头射线',
    line: '直线',
    arrowLine: '箭头直线',
    horizontalLine: '水平线',
    verticalLine: '垂直线',
    crookedLines: '曲线',
    elliott3: '艾略特3',
    elliott5: '艾略特5',
    crooked3: '弯曲3',
    crooked5: '弯曲5',
    measure: '测量',
    measureXY: '测量XY',
    measureX: '测量X',
    measureY: '测量Y',
    advanced: '高级',
    fibonacci: '斐波那契',
    pitchfork: '叉形线',
    parallelChannel: '平行通道',
    seriesType: '线类型',
      lineChart: '线图',
      candlestick: '蜡烛图'
    },

    tickerRatingVue: {
      targetPrice: '目标价',
      targetPriceTip1: '展示过去一年内评级机构给出的目标价区间与股价的对比',
      targetPriceTip2: '目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
      ratingDistribution: '评级分布',
      ratingDistributionTip1: '展示过去三个月内，机构对当前个股的评级占比，并对比其所属二级行业内所有个股的平均评级占比',
      ratingDistributionTip2: '将近百种不同评级名称统一为：强烈买入、买入、持有、卖出、强烈卖出',
      strongBuy: '强烈买入',
      buy: '买入',
      hold: '持有',
      sell: '卖出',
      strongSell: '强烈卖出',
      industryAverage: '平均',
      targetPriceRange: '目标价区间',
      targetAveragePrice: '目标均价',
      price: '价格',
      past1Year: '（过去1年）',
      ratingDistributionPercent: '评级分布%',
      past3Months: '（过去3个月）',
      ratingChange: '评级变化',
      totalAnalystsFor: '共',
      analystsRated: '位分析师对',
      analystsRatedIndustry: '位分析师对行业内的公司给出评级',
      upgraded: '上调',
      downgraded: '下调',
      maintained: '维持',
      institutions: '家',
      ratingDetails: '评级详情',
      institutionName: '机构名称',
      analystName: '分析师名称',
      initialRating: '首次评级',
      targetPriceLower: '目标价下限',
      targetPriceUpper: '目标价上限',
      ratingChangeColumn: '评级变动',
      newRating: '新评级',
      previousRating: '前次评级',
      tradeDate: '交易日期'
    },

    tickerValuationVue: {
      valuation: '估值',
      valuationTip1: '展示当前个股估值与所属一级行业和二级行业估值的对比',
      valuationOutlierHandling: '估值极值处理',
      upperLimit: '上限',
      lowerLimit: '下限',
      targetPrice: '目标价',
      targetPriceTip1: '展示过去一年内评级机构给出的目标价区间与股价的对比',
      targetPriceTip2: '目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
      low: '低',
      percentile25: '25分位',
      percentile50: '50分位',
      percentile75: '75分位',
      high: '高',
      loss: '亏损',
      l2Average: 'L2均值',
      l2Valuation: 'L2估值',
      operation: '经营',
      growth: '成长',
      risk: '风险',
      l2Industry: 'L2行业',
      trendLine: '趋势线',
      observations: '观测点',
      powerDetails: '能力详情',
      investmentAmount: '投放金额',
      repaymentAmount: '还款金额',
      comparedWithIndustry: '（与所属行业比较）',
      level1Industry: '一级行业：',
      level2Industry: '二级行业：',
      valuationAnalysis: '估值分析',
      beforeAdjustment: '调整前',
      afterAdjustment: '调整后',
      enterpriseValue: '企业价值',
      past1Year: '（过去1年）',
      past3Months: '（过去3个月）',
      powerItems: '能力项',
      power: '能力',
      powerTrend: '能力趋势'
    },
  
  
    // tickerFrVue
    tickerFrVue: {
      overview: '概述',
      annualReport: '年报',
      quarterlyReport: '季报',
      profit: '利润',
      netProfitShort: '净利润',
      totalRevenueShort: '总营收',
      industryNetProfit: '行业净利润',
      industryTotalRevenue: '行业总营收',
      yoyGrowth: '同比增长',
      threeYearCagr: '3年CAGR',
      qoqGrowth: '环比增长',
      cashFlow: '现金流',
      operatingNetCashFlow: '经营净现金流',
      freeCashFlow: '自由现金流',
      industryOperatingNetCashFlow: '行业净现金流',
      industryFreeCashFlow: '行业自由现金流',
      assetsAndLiabilities: '资产负债',
      ownerEquity: '所有者权益',
      totalAssetsShort: '总资产',
      industryOwnerEquity: '行业所有者权益',
      industryTotalAssets: '行业总资产',
      incomeStatement: '利润表',
      cashFlowStatement: '现金流表',
      balanceSheet: '资产负债表',
      plsTrend: '利润表趋势',
      past5Years: '（过去5年）',
      past3Years: '（过去3年）',
      plsBreakdown: '利润拆解',
      revenueDistribution: '营收分布',
      annualOnly: '只支持年报查询',
      costDistribution: '成本分布',
      plsDetails: '利润表详情',
      subject: '科目',
      cashFlowTrend: '现金流趋势',
      cashFlowBreakdown: '现金流拆解',
      cashInDistribution: '现金流入分布',
      cashOutDistribution: '现金流出分布',
      cfsDetails: '现金流表详情',
      bssTrend: '资产负债趋势',
      bssBreakdown: '资产负债拆解',
      assetDistribution: '资产分布',
      liabilityDistribution: '负债分布',
      bssDetails: '资产负债表详情',
      dupontAnalysis: '杜邦分析',
      salesExpenseShort: '销售',
      rdExpenseShort: '研发',
      adminExpenseShort: '管理',
      financeExpenseShort: '财务',
      operatingCostShort: '营业成本',
      profitTrendTab: '盈利趋势',
      costTrendTab: '成本趋势',
      totalOperatingRevenue: '营业总收入',
      grossProfit: '毛利润',
      salesExpense: '销售费用',
      rdExpense: '研发费用',
      adminExpense: '管理费用',
      financeExpense: '财务费用',
      netCashFlowTab: '净现金流',
      essentialSpendingTab: '必要支出',
      singleFlowTab: '单项流入流出',
      investingNetCashFlow: '投资净现金流',
      financingNetCashFlow: '筹资净现金流',
      cashFlowNode: '现金流',
      operatingInflow: '经营流入',
      investingInflow: '投资流入',
      financingInflow: '筹资流入',
      exchangeRateCashEffect: '汇率影响现金',
      otherCashEffect: '其他原因对现金的影响',
      operatingOutflow: '经营流出',
      investingOutflow: '投资流出',
      financingOutflow: '筹资流出',
      netCashIncrease: '现金净增加',
      currentAssets: '流动资产',
      nonCurrentAssets: '非流动资产',
      currentLiabilities: '流动负债',
      nonCurrentLiabilities: '非流动负债',
      totalLiabilitiesShort: '总负债',
      assetsRoot: '资产',
      liabilitiesRoot: '负债',
      ownerEquityRoot: '所有者权益',
      details: '详情',
      mainBusiness: '营业收入',
      payGoodsAndServices: '支付商品和服务',
      salaryShort: '薪资',
      cashTaxRefund: '收到的税费返还',
      otherOperatingInflow: '其他经营流入',
      investmentRecovery: '回收投资',
      assetDisposalShort: '资产处置',
      disposeSubsidiary: '处置子公司',
      otherInvestment: '其他投资',
      receiveInvestment: '吸收投资',
      obtainBorrowing: '取得借款',
      otherFinancing: '其他筹资',
      bondIssuanceIncome: '发债收入',
      taxPayments: '支付的各项税费',
      otherOperatingExpense: '其他经营支出',
      purchaseAssets: '购买资产',
      investmentSpending: '投资支出',
      acquireSubsidiary: '取得子公司',
      otherInvestmentExpense: '其他投资支出',
      debtRepaymentShort: '债务偿还',
      dividendAndInterest: '分红和利息',
      otherFinancingExpense: '其他筹资支出',
      billion: '亿',
      w: '万',
    //  PLS
    totalOpIncomeY: '一、营业总收入(元)',
    oiGrossRevY: '其中：营业收入(元)',
    opCoreExpense: '二、营业总成本(元)',
    oeCogsY: '其中：营业成本(元)',
    oeSellingExpenseY: '销售费用(元)',
    oeRdExpenseY: '研发费用(元)',
    oeAdminExpenseY: '管理费用(元)',
    oeExplorationExpense: '勘探费用(元)',
    oeFinanceExpenseY: '财务费用(元)',
    oeFeInterestExpense2019: '其中：利息费用(2019-03-15新增)',
    oeFeTnterestIncome2019: '其中：利息收入(2019-03-15新增)',
    oeInterestExpense: '利息支出(元)',
    oeSalesTaxY: '营业税金及附加(元)',
    oeFeeCommissionExpense: '手续费及佣金支出(元)',
    opCapitalGainLoss: '三、其他经营收益',
    netFairValueGain: '加：公允价值变动净收益(元)',
    investmentIncomeY: '投资收益(元)',
    investmentIncome: '投资收益',
    investmentIncomeAssocJoint: '其中：对联营企业和合营企业的投资收益(元)',
    assetDisposalGain: '资产处置收益',
    assetImpairmentLoss: '资产减值损失-营业总成本(元)',
    assetImpairmentLoss2019: '资产减值损失（2019格式）',
    exchangeGain: '汇兑收益(元)',
    netHedgingGain: '净敞口套期收益',
    otherItemsOpProfit: '影响营业利润的其他科目(元)',
    oiNonMainBusiness: '非主营业务的其它收入',
    opProfitY: '四、营业利润(元)',
    subsidy: '加：补贴收入(元)',
    nonOpIncomeY: '营业外收入(元)',
    nonCurrAssetDisposalGain: '其中：非流动资产处置利得(元)',
    nonOpExpense: '减：营业外支出(元)',
    nonCurrAssetDisposalLoss: '其中：非流动资产处置损失(元)',
    otherItemsTotalProfit: '加：影响利润总额的其他科目(元)',
    ebtY: '五、税前总利润(元)',
    incomeTaxY: '减：所得税(元)',
    otherItemsNetProfit: '加：影响净利润的其他科目(元)',
    netProfitY: '六、净利润(元)',
    classificationByContinuityOfOperations: '(一)按经营持续性分类',
    continuousNetProfit: '持续经营净利润',
    discontinuedNetProfit: '终止经营净利润',
    classificationByOwnership: '(二)按所有权归属分类',
    netProfitParentCompany: '归属于母公司所有者的净利润(元)',
    minorityInterest: '扣除非经常性损益后的净利润(元)',
    eps: '七、每股收益',
    basicEps: '基本每股收益',
    dilutedEps: '稀释每股收益',
    netOtherIncome: '其他综合收益(元)',
    totalComprehensiveIncome: '综合收益总额(元)',
    cincomeParent: '其中：归属于母公司(元)',
    cincomeMinority: '其中：归属于少数股东(元)',

    // CFS
    CashFlowsFromOperatingActivities: '一、经营活动产生的现金流量',
    netCashOpActivity: '经营活动产生的现金流量净额(元)',
    totalCashinOpActivity: '经营活动现金流入小计(元)',
    cashinSales: '销售商品、提供劳务收到的现金(元)',
    cashinTaxRefundY: '收到的税费返还(元)',
    cashinOtherOpActivity: '收到其他与经营活动有关的现金(元)',
    totalCashoutOpActivity: '经营活动现金流出小计(元)',
    cashoutGoodsService: '购买商品、接受劳务支付的现金(元)',
    cashoutSalary: '支付给职工以及为职工支付的现金(元)',
    cashoutTaxesY: '支付的各项税费(元)',
    cashoutOtherOpActivity: '支付其他与经营活动有关的现金(元)',
    cashFlowsFromInvestingActivities: '二、投资活动产生的现金流量',
    netCashInvestment: '投资活动产生的现金流量净额(元)',
    totalCashinInvestment: '投资活动现金流入小计(元)',
    cashinDivestment: '收回投资收到的现金(元)',
    cashinInvestmentIncome: '取得投资收益收到的现金(元)',
    netCashAssetDisposal: '处置固定资产、无形资产和其他长期资产收回的现金净额(元)',
    netCashSubsidSale: '处置子公司收到的现金净额(元)',
    cashinOtherInvestment: '收到其他与投资活动有关的现金(元)',
    totalCashoutInvestment: '投资活动现金流出小计(元)',
    cashoutAssetPurchase: '购建固定资产、无形资产和其他长期资产支付的现金(元)',
    cashoutInvestment: '投资支付的现金(元)',
    netCashSubsidAcquire: '取得子公司及其他营业单位支付的现金净额(元)',
    cashoutOtherInvestment: '支付其他与投资活动有关的现金(元)',
    CashFlowsFromFinancingActivities: '三、筹资活动产生的现金流量',
    netCashFinancing: '筹资活动产生的现金流量净额(元)',
    totalCashinFinancing: '筹资活动现金流入小计(元)',
    cashinInvestors: '吸收投资收到的现金(元)',
    cashinInvestorsSubsidMinority: '其中：子公司吸收少数股东投资收到的现金(元)',
    cashinBorrowing: '取得借款收到的现金(元)',
    cashinBondIssuance: '发行债券收到的现金(元)',
    cashinOtherFinancing: '收到其他与筹资活动有关的现金(元)',
    totalCashoutFinancing: '筹资活动现金流出小计(元)',
    cashoutDebtRepayment: '偿还债务支付的现金(元)',
    cashoutDividendsInterest: '分配股利、利润或偿付利息支付的现金(元)',
    cashoutDividendsSubsidMinority: '其中：子公司支付给少数股东的股利、利润(元)',
    cashoutOtherFinancing: '支付其他与筹资活动有关的现金(元)',

    exchangeRateEffect: '四、汇率变动对现金及现金等价物的影响(元)',
    otherReasonsEffectY: '五、其他原因对现金的影响(元)',
    netIncCash: '六、现金及现金等价物净增加额(元)',
    beginCash: '加：期初现金及现金等价物余额(元)',
    endCash: '期末现金及现金等价物余额(元)',

    // BSS
    totalAsset: '一、资产总计',
    currAssetTotal: '流动资产合计(元)',
    cashY: '货币资金(元)',
    cash: '货币资金',
    currMarketableSecurities: '交易性金融资产',
    derivativeAsset: '衍生金融资产',
    notesAccountReceivable: '应收票据及应收账款',
    notesReceivable: '其中：应收票据',
    accountReceivable: '其中：应收账款',
    accountReceivableFinancing: '应收款项融资',
    prepayment: '预付款项',
    otherReceivable: '其他应收款',
    inventory: '存货',
    inventoryBioConsumables: '其中：消耗性生物资产',
    receivableRelatedComp: '应收关联公司款',
    receivableRelatedCompInterest: '其中：应收利息',
    receivableRelatedCompDividend: '其中：应收股利',
    assetForSale: '划分为持有待售的资产',
    currLoans: '发放贷款及垫款-流动资产',
    ncurrAssetDueOneyear: '一年内到期的非流动资产',
    contractAsset: '合同资产',
    currAssetOther: '其它流动资产',

    ncurrAssetTotal: '非流动资产合计（元）',
    ncurrLoan: '可供出售发放贷款及垫款-非流动资产',
    ncurrMarketableSecurities: '可供出售金融资产',
    finAssetHeldMaturity: '持有至到期投资',
    ncurrReceivable: '长期应收款',
    ncurrEquity: '长期股权投资',
    ncurrInvestmentProperty: '投资性房地产',
    fixedAssets: '固定资产',
    constructionInProgress: '在建工程',
    engineeringMaterial: '工程物资',
    fixedAssetLiquidation: '固定资产清理',
    bioAsset: '生产性生物资产',
    oilGas: '油气资产',
    intangibleAsset: '无形资产',
    use_rightAsset: '试用权资产',
    useRightAsset: '试用权资产',
    devExpenditure: '开发支出',
    goodwill: '商誉',
    ncurrDeferredExpense: '长期待摊费用',
    deferredTaxAsset: '递延所得税资产',
    debtInvestment: '债权投资',
    otherDebtInvestment: '其他债权投资',
    otherEquityInvestment: '其他权益工具投资',
    ncurrOtherFinAsset: '其他非流动金融资产',
    ncurrOtherAsset: '其他非流动资产',

    totalLiabilityY: '二、负债合计',
    currLiabilityTotal: '流动负债合计（元）',
    shortTermLoan: '短期借款',
    derivativeLiability: '衍生金融负债',
    notesAccountPayable: '应付票据及应付账款',
    notesPayable: '其中：应付票据',
    accountPayable: '其中：应付账款',
    advancePayment: '预收款项',
    commissionPayable: '应付手续费及佣金',
    salaryPayable: '应付职工薪酬',
    taxesPayable: '应交税费',
    payableRelatedComp: '应付关联公司款',
    payableRelatedCompInterest: '其中：应付利息',
    payableRelatedCompDividend: '其中：应付股利',
    otherPayable: '其他应付款',
    liabilitiesForSale: '划分为持有待售的负债',
    ncurrLiabilityDueOneyear: '一年内到期的非流动负债',
    currLiabilityProvision: '预计负债-流动负债',
    deferredIncome: '递延收益-流动负债',
    tradingLiability: '交易性金融负债',
    contractLiability: '合同负债',
    currOtherLiability: '其他流动负债',

    ncurrLiabilityTotal: '非流动负债合计(元)',
    ncurrDebt: '长期借款',
    leaseLiabilities: '租赁负债',
    bondPayable: '应付债券',
    preferredStock: '其中：优先股-非流动负债',
    perpetualBonds: '永续债-非流动负债',
    ncurrPayable: '长期应付款',
    ncurrSalaryPayable: '长期应付职工薪酬',
    ncurrSpecialPayable: '专项应付款',
    ncurrProvision: '预计负债',
    ncurrDeferredIncome: '递延收益-非流动负债',
    ncurrTaxLiability: '递延所得税负债',
    ncurOtherLiability: '其他非流动负债',
    ncurrOtherLiability: '其他非流动负债',

    totalOwnerEquity: '三、所有者权益（或股东权益）合计',
    paidInCapital: '实收资本（或股本）',
    otherEquityInstrument: '其他权益工具',
    preferredStockOwnerEquity: '其中：优先股-所有者权益',
    perpetualBondOwnerEquity: '永续债-所有者权益',
    capitalSurplus: '资本公积',
    lessTreasuryStock: '减：库存股',
    otherComprehensiveIncome: '其他综合收益',
    specialReserve: '专项储备',
    surplusReserve: '盈余公积',
    undistributedProfit: '未分配利润',
    currencyConversionDiff: '外币报表折算价差',
    minorityInterests: '少数股东权益',
    ownerEquityParentCompany: '归属于母公司所有者权益',
    totalOwnerLiabilityEquity: '四、负债和所有者（或股东权益）合计',

    netProfit: '净利润',
    oiGrossRev: '营业收入',
    oeCogs: '营业成本',
    oeSalesTax: '营业税金及附加',
    opProfit: '营业利润',
    otherOpProfit: '其他营业收益',
    nonOpIncome: '营业外收入',
    ebt: '税前总利润',
    incomeTax: '所得税',

    grossProfit: '毛利润',
    expenses: '费用',
    sales: '销售',
    RD: '研发',
    administrative: '管理',
    financial: '财务',

    wy: '万元',
    profitTrend: '盈利趋势',
    costTrend: '成本趋势',
    totalOpIncome: '营业总收入',
    oeSellingExpense: '销售费用',
    oeRdExpense: '研发费用',
    oeAdminExpense: '管理费用',
    oeFinanceExpense: '财务费用',
    operatingInflow: '经营流入',
    investmentInflow: '投资流入',
    financingCashInflow: '筹资流入',
    effectOfExchangeRateChangesOnCash: '汇率影响现金',
    otherReasonsEffect: '其他原因对现金的影响',
    operatingCashOutflow: '经营流出',
    investingCashOutflow: '投资流出',
    financingCashOutflow: '筹资流出',
    netIncreaseInCash: '现金净增加',
    cashFlow: '现金流',
    cashinTaxRefund: '收到的税费返还',
    otherOperatingInflow: '其他经营流入',
    returnOfInvestment: '回收投资',
    // 今天 到 这里
    assetDisposal: '资产处置',
    disposalOfASubsidiary: '处置子公司',
    otherInvestments: '其他投资',
    equityInfusion: '吸收投资',
    proceedsFromBorrowings: '取得借款',
    otherFinancingActivities: '其他筹资',
    bondProceeds: '发债收入',
    paymentsForGoodsAndServices: '支付商品和服务',
    salariesAndWages: '薪资',
    cashoutTaxes: '支付的各项税费',
    acquisitionOfAssets: '购买资产',
    investmentExpenditure: '投资支出',
    acquisitionOfSubsidiaries: '取得子公司',
    otherInvestingOutflow: '其他投资支出',
    debtRepayment: '债务偿还',
    dividendsAndInterestPaid: '分红和利息',
    otherFinancingOutflow: '其他筹资支出',
    operatingNetCashFlow: '经营净现金流',
    investingNetCashFlow: '投资净现金流',
    financingNetCashFlow: '筹资净现金流',
    debtRepaymentOutflow: '偿还债务流出',
    ownerEquity: '所有者权益',
    details: '详情',
    totalLiability: '总负债',
    currLiability: '流动负债',
    ncurrLiability: '非流动负债',
    // 资产
    generalRiskReserve: '一般风险准备',
    interestIncome: '利息收入',
    averageInterest: '平均利息',
    loanBalance: '贷款余额',
    disbursementAmount: '投放金额',
    repaymentAmount: '还款金额',
    repaymentTerm: '还款期限',
    totalRevenue: '总营收',
    industryNetProfit: '行业净利润',
    industryTotalRevenue: '行业总营收',
    yearOverYearGrowth: '同比增长',
    cagr3: '3年CAGR',
    quarterOverQuarterGrowth: '环比增长',
    freeCashFlow: '自由现金流',
    industryNetCashFlow: '行业净现金流',
    industryFreeCashFlow: '行业自由现金流',
    assetsAndLiabilities: '资产负债',
    totalAssets: '总资产',
    industryEquity: '行业所有者权益',
    industryTotalAssets: '行业总资产',
    incomeStatement: '利润表',
    cashFlowStatement: '现金流表',
    balanceSheet: '资产负债表',
    incomeStatementTrend: '利润表趋势',
    past5Years: '（过去5年）',
    past3Years: '（过去3年）',
    annualReport: '年报',
    quarterlyReport: '季报',
    profitBreakdown: '利润拆解',
    revenueDistribution: '营收分布',
    annualReportOnly: '只支持年报查询',
    costDistribution: '成本分布',
    incomeStatementDetails: '利润表详情',
    accountItem: '科目',
    cashFlowTrend: '现金流趋势',
    cashFlowBreakdown: '现金流拆解',
    cashInflowDistribution: '现金流入分布',
    cashOutflowDistribution: '现金流出分布',
    cashFlowStatementDetails: '现金流表详情',
    balanceSheetTrend: '资产负债趋势',
    balanceSheetBreakdown: '资产负债拆解',
    assetDistribution: '资产分布',
    liabilityDistribution: '负债分布',
    balanceSheetDetails: '资产负债表详情',
    dupontAnalysis: '杜邦分析',
    otherOperatingExpenses: '其他经营支出',
    profit: '利润',

    assets: '资产',
    currAsset: '流动资产',
    ncurrAsset: '非流动资产',
    liability: '负债',

  },

  // tickerRating
  tickerRating: {
    avg: '平均',
    strongBuy: '强烈买入',
    buy: '买入',
    hold: '持有',
    sell: '卖出',
    strongSell: '强烈卖出',
    targetPriceRange: '目标价区间',
    targetPriceAvg: '目标均价',
    price: '价格',
    targetPrice: '目标价',
    past1Year: '(过去1年)',
    ratingDistributionPct: '评级分布%',
    past3Months: '(过去3个月)',
    ratingChange: '评级变化',
    total: '共',
    analystsCovered: '位分析师对',
    ratingGiven: '给出评级',
    upgrades: '上调',
    firmsUpgraded: '家',
    downgrades: '下调',
    maintains: '维持',
    industryCoverage: '行业内的公司给出评级',
    ratingDetails: '评级详情',
    institutionName: '机构名称',
    analystName: '分析师名称',
    initialRating: '首次评级',
    targetPriceLower: '目标价下限',
    targetPriceUpper: '目标价上限',
    ratingChg: '评级变动',
    ratingNew: '新评级',
    previousRating: '前次评级',
    tradeDate: '交易日期',
  },

  // tickerShareholderVue
  tickerShareholderVue: {
    details: '详情',
    price: '价格',
    top10HoldingRatio: '前十大股东持仓比例',
    clickToViewDetails: '点击查看详情',
    shareholderCount: '股东人数',
    unchanged: '不变',
    decreased: '减少',
    increased: '增加',
    newEntry: '新进',
    top10FloatShareholdersAndCount: 'Top10流通股东 & 股东人数',
    past3Years: '（过去3年）',
    top10FloatShareholders: 'Top10流通股东',
    top10FloatShareholdersDetails: 'Top10流通股东详情',
    shareholderName: '股东名称',
    holdingQuantity: '持仓量（股）',
    floatHoldingRatio: '持仓流通占比',
    holdingChange: '持仓变化',
    holdingRatio: '持仓占比',
    shareholderCountDetails: '股东人数详情',
    totalShareholderCount: '股东总人数',
    shareholderCountChange: '股东人数变化',
    avgSharesPerHolder: '户均持股(股)',
    avgHoldingRatio: '户均持股比例',
    avgHoldingChange: '户均持股变化',
    top10FloatShareholdersDistribution: 'Top10流通股东分布',
    others: '其他',
    tipsOverview:
      '### Top10流通股东\n- 展示过去三年内前十大流通股东持仓比例与股价的对比\n- <br>\n\n### 股东人数\n- 展示过去三年股东人数与股价的对比',
    tipsTop10Details:
      '### Top10流通股东详情\n- 展示指定公告日期（可在上方线图上点击详情切换）的 Top10 流通股东持仓详情',
    tipsShareholderCountDetails:
      '### 股东人数详情\n- 展示指定公告日期（可在上方线图上点击详情切换）的股东人数、户均持股变化',
    tipsTop10Distribution:
      '### Top10流通股东分布\n- 展示指定公告日期（可在上方线图上点击详情切换）的 Top10 流通股东持仓占比'

  },

  // tickerEventVue
  tickerEventVue: {
    reduceHoldings: '减持',
    increaseHoldings: '增持',
    tickerCodeP: '证券代码',
    stockSymbol: '证券简称',
    annDate: '公告日期',
    deadlineForSharePurchaseAndSale: '增（减）持截止日',
    shareholderName: '股东名称',
    shareholderId: '股东ID',
    changeVol: '变动数量',
    changeRatioTotalShare: '变动数量占总股本比例（%）',
    postChangeRatio: '变动后占比（%）',
    changePriceUpperLimit: '增（减）持价格上限',
    postChangeShareTotal: '变动后持股数量',
    postChangeShareFloat: '变动后持有流通股数量',
      shares: '股',
      wanShares: '万股',
      percent: '%',

    reportDetails: '报告详情',
    reportingPeriod: '报告期',
    recordTime: '发布预报时间',
    explanationOfTheReportingPeriod: '报告期解释',
    rptDateActual: '真实发布时间',
    rptDateEstimate: '预告时间',

    pledgor: '质押方',
    numberOfPledgedShares: '质押数量',
    releaseOfPledge: '收回质押',
    cumulative_plg_mvt_pct: '累计比例',
    plg_mvt_pct: '本次比例',
    lender: '出借方',
    details: '详情',

    shareholdingDetails: '持股详情',
    expReleaseDate: '预计解除限售日期',
    expReleaseVol: '预计解除限售数量',
    restrictionReason: '限售原因',

    tradeDetails: '交易详情',
    tradeDate: '交易日期',
    exchange: '交易所',
    buyer: '买方营业部',
    seller: '卖方营业部',
    price: '成交价格',
    vol: '成交量',
    amount: '成交金额',

    clickCount: '点击量',
    q: '问',
    a: '答',
    latestRating: '最新评级',
    previousRating: '上次评级：',
    institution: '机构',

    startDate: '开始日期',
    netProfit: '净利润',
    wy: '万元',
    totalAsset: '总资产',
    AttributableToOwnersOfParent: '股东权益（不含少数股东权益）',
    eps: '每股收益',
    roe: '净资产收益率',
    roeWeighted: '净资产收益率-加权',
    netEquityPerShare: '每股净资产',
    y: '元',

    ReportingType: '业绩类型',
    EarningsGuidance: '业绩预告内容',
    changeReason: '业绩变化原因',
    netProfLow: '净利润下限',
    netProfHigh: '净利润上限',
    netProfLowPct: '净利润增减幅下限',
    netProfHighPct: '净利润增减幅上限',

    stockIssuanceDetails: '股票发行详情',
    stockType: '股票类别',
    parValue: '每股面值',
    issueSize: '发行规模(万股)',
    issueObject: '发行对象',
    pricingMethod: '发行定价方式',
    expectedFundAmount: '预计募资金额(万元)',
    fundPurpose: '预计募资投向',
    planProgress: '方案进度',

    shResolutionDate: '股东决议公告日期',
    approvalDate: '增发获准公告日期',
    changeDescription: '变更说明',
    issuePrice: '发行价格',
    issueMethod: '发行方式',
    resolutionValidUntil: '股东决议有效期截止日',
    xplanStatusx: '方案状态',
    terminationDate: '终止公告日期',

    totalIssueVolume: '总发行数量',
    publicIssueVolume: '公开发行数量',
    issuePriceRmb: '发行价格(人民币)',
    issuePriceForeign: '发行价格（外币）',
    currency: '币种',
    upperBidPrice: '竞价上限',
    lowerBidPrice: '竞价下限',
    shareholderPlacementMethod: '老股东配售方式',
    shareholderPlacementPrice: '老股东配售价格',
    shareholderPlacementRatio: '老股东配售比例',
    weightedPeRatio: '加权发行市盈率',
    dilutedPeRatio: '摊薄发行市盈率',
    preIssueNaps: '发行前每股净资产',
    postIssueNaps: '发行后每股净资产',
    actualFundRaised: '实际募资总额',
    issueRegion: '发行地区',
    underwritingMethod: '承销方式',
    recordDate: '股权登记日',
    exRightDate: '除权日',

    DetailsOfUnlockingRestrictedShares: '解除限售详情',
    actualReleaseDate: '实际解除限售日',
    actualReleaseVol: '实际解除限售数量',
    actualReleaseRatio: '实际解除限售比例',
    actualFloatVol: '实际可流通数量',

    detailsOfFrozenShares: '股份冻结详情',
    holderId: '被冻结当事人ID',
    holderName: '被冻结当事人',
    freezeReason: '冻结事项',
    NatureOfFrozenShares: '被冻结股份性质',
    freezeStock: '冻结数量',
    freezePct: '占总股份比例',
    applicant: '冻结申请人',
    executioner: '冻结执行人',
    freezeStartDate: '冻结起始日',
    freezeEndDate: '冻结终止日',
    unfreezeDate: '解冻日期',
    cumulativeUnfreezeStock: '累计解冻数量',
    unfreezingSummary: '解冻处理说明',

    pledgeDetails: '质押详情',
    pledgorId: '出质人ID',
    pledgee: '质权人',
    pledgeReason: '质押事项',
    pledgedSharesType: '质押股份性质',
    pledgedVol: '质押数量',
    pledgedSharesRatio: '占总股本比例',
    pledgeStartDate: '质押起始日',
    pledgeEndDate: '质押终止日',
    pledgeReleaseDate: '质押解除日',
    pledgeReleaseVol: '质押解除数量',

    pledgeReleaseReason: '解除质押说明',
    isRepoTransaction: '是否质押式回购交易',
    yes: '是',
    no: '否',

    DividendDetails: '分红详情',
    divYear: '分红年度',
    boardMeetingDate: '董事会预案公告日期',
    boardMeetingDivPlan: '董事会预案分红说明',
    shareholderMeetingDate: '股东大会预案公告日期',
    shareholderMeetingDivPlan: '股东大会预案分红说明',
    divAnnDate: '实施方案公告日期',

    divPlanSummary: '实施方案分红说明',
    divBaseShare: '分配股本基数（实施）',
    baseYear: '股本基准年度',
    bonusShareRatio: '送股比例',
    transferRatio: '转增比例',
    divRatioRmb: '派息比例(人民币)',
    divRatioUsd: '派息比例（美元)',
    divRatioHkd: '派息比例（港币)',
    bonusShareCount: '送股数量',
    transferShareCount: '转增数量',
    divAmountRmb: '派息金额(人民币)',
    aShareRecordDate: 'A股股权登记日',

    bShareRecordDate: 'B股股权登记日',
    aShareExDate: 'A股除权日',
    bShareExDate: 'B股除权基准日',
    bShareLastTradeDate: 'B股最后交易日',
    aShareDivDate: '派息日(A)',
    bShareDivDate: '派息日(B)',
    aShareBonusShareDate: 'A股送红股到帐日',
    aShareListingDate: 'A股新增股份上市日',
    bShareListingDate: 'B股新增股份上市日',
    dividendCancelDate: '取消分红公告日期',
    aShareTransferShareDate: 'A股转赠股份到帐日',
    bShareTransferShareDate: 'B股转赠股份到帐日',
    bShareBonusShareDate: 'B股送红股到帐日',
    exchangeRate: '汇率',
    latestAnnDate: '最新公告日期',
    dividendType: '分红类型',
    debtRestructuringDetails: '债务重组详情',
    debtor: '债务人',
    creditor: '债权人',
    restructureMethod: '重组方式',
    restructureAmt: '重组金额',
    restructureIncome: '重组收益',
    contingentExpenditure: '或有支出',
    restructureBaseDate: '重组基准日',
    isRelatedTransaction: '是否关联交易',
    impactOnCompany: '对公司经营的影响',
    restructureDetails: '重组情况说明',
    progressStatus: '进展状态',

    patentDetails: '专利详情',
    patentName: '专利名称',
    applicationNum: '申请号',
    publicationNum: '申请公布号',
    classificationCode: '分类号',
    publicationDate: '申请公布日',
    applicationDate: '申请日期',
    patentType: '专利类型',
    inventor: '发明人',
    detailId: '专利详情查询ID',

    trademarkDetails: '商标详情',
    trademarkName: '商标名称',
    classificationType: '类别名称简化',
    applicationStatus: '流程状态',
    applicantName: '申请人',

    ResearchActivityDetails: '调研活动详情',
    researchTopic: '调研主题',
    participants: '参与者',
    penaltyDetails: '处罚信息详情',
    sanctionTypeCode: '处罚类型编码',
    sanctionType: '处罚类型',
    sanctionReason: '处罚原因',
    regulatoryBody: '处罚部门',
    sanctionObject: '处罚对象',
    sanctionDetails: '处罚内容',
    sanctionAmt: '处罚金额',

    guaranteeDetails: '担保信息详情',
    guarantor: '担保方',
    guaranteed: '被担保方',
    matterDetails: '担保事项',
    matterType: '担保类别',
    contractDate: '协议签署日期',
    relatedPartyTransaction: '是否关联交易',

    partyRelationship: '双方关联关系',
    guaranteedAmt: '担保金额',
    guaranteedPeriod: '担保期限',
    loanStartDate: '借款开始日期',
    loanEndDate: '借款结束日期',
    loanRate: '借款年利率',
    collateral: '抵押或质押物',
    debtHolder: '债权人',
    postPeriodMatters: '期后相关事项',
    guaranteeReleaseDate: '担保免除日期',

    progress: '担保进程',
    guaranteeStartDate: '担保开始日期',
    guaranteeEndDate: '担保截止日期',
    stkHolderMeeting: '是否经股东大会审议',
    stkHolderMeetingDate: '股东大会决议公告日',
    relatedPartyGuarantee: '是否为关联方担保',
    companyGuaranteeTotal: '公司及控股子公司对外担保总额',
    exchangeMarket: '交易市场',

    assetAcquisitionDetails: '资产收购详情',
    assetBuyer: '资产受让方',
    assetSeller: '资产出让方',
    assetType: '受让资产类型',
    assetDescription: '受让资产',
    transactionAmt: '成交金额',

    valuationDate: '资产评估基准日',
    bookValue: '资产账面值',
    assessedValue: '资产评估值',
    settlementMethod: '结算方式',
    financialAdvisorName: '独立财务顾问机构名称',
    isMajorAssetAcquisition: '是否重大资产收购',

    sellerRelationship: '出让方与公司关联关系',
    assetAcquisitionDescription: '资产受让情况说明',

    assetDisposalDetails: '资产出让详情',

    isMajorAssetSale: '是否重大资产出让',
    buyerRelationship: '受让方与公司关联关系',
    assetTransferDescription: '资产出让情况说明',

    assetSwapDetails: '资产置换详情',
    assetSwapOutParty: '资产置换方',
    assetSwapInParty: '资产置换协议方',
    assetSwapOutType: '置出资产类型',
    assetSwapOut: '置出资产',
    assetSwapOutAmt: '置出资产金额',
    assetSwapOutAssessedValue: '置出资产评估值',

    assetSwapOutBookValue: '置出资产账面值',
    assetSwapInType: '置入资产类型',
    assetSwapIn: '置入资产',
    assetSwapInAmt: '置入资产金额',
    assetSwapInAssessedValue: '置入资产评估值',

    assetSwapInBookValue: '置入资产账面值',
    swapBalance: '资产置换差额',
    balanceSettlementMethod: '差额结算方式',
    isMajorAssetSwap: '是否重大资产置换',
    relatedPartyRelation: '协议方与公司关联关系',
    assetSwapDescription: '资产置换情况说明',

    AssetFreezeDetails: '资产冻结详情',
    entityImpacted: '被冻结单位',
    assetFreezeTypeCode: '冻结资产类型编码',
    assetFreezeType: '冻结资产类型',
    assetValue: '冻结资产金额',
    enforcementAgency: '冻结单位',
    reason: '冻结原因',
    postMatters: '持限售(未流通)股数量',
    applicantParty: '持流通股数量',

    InvestmentDetails: '投资信息详情',
    entityInvesting: '投资主体',
    relationToListedEntity: '从属关系',
    investmentType: '投资类型',
    investmentProvince: '投资省份',
    investmentCity: '投资城市',
    investmentLocation: '投资位置',
    projectName: '项目名称/下属公司名称',
    totalProjectSize: '项目投资总额/下属公司注册资本',
    investmentAmt: '出资金额',
    currencyType: '币种编码',
    investmentPct: '出资比例',
    investmentDetail: '建设内容',
    investmentAim: '投资目的',
    effectSummary: '对公司的影响',
    annUrl: '公告网址',

    LitigationDetails: '诉讼详情',
    litigationSummary: '诉讼事项',
    legalBasis: '案由',
    amountInQuestion: '涉及金额',
    courtDate: '开庭日期',
    courtFirstInstance: '诉讼一审机构',
    courtSecondInstance: '诉讼二审机构',
    courtOfAppeal: '诉讼申诉机构',
    judgmentFirstInstance: '一审裁决情况',
    judgmentSecondInstance: '二审裁决情况',
    judgmentAppeal: '申诉情况',
    enforcementStatus: '判决执行情况',
    impactAssesment: '对本公司的影响',
    litigationCost: '诉讼费用',
    paymentAmount: '偿还金额',

    ArbitrationDetails: '仲裁详情',
    plaintiff: '原告',
    defendant: '被告',
    arbitrationSummary: '诉讼事项',
    companyPositionCode: '公司所处地位',
    companyPosition: '案由',
    subjectMatterCode: '涉及金额',
    subjectMatter: '币种',
    subjectAmt: '标的',
    currecyCode: '开庭日期',
    firstInstanceCourt: '诉讼一审机构',
    secondInstanceCourt: '诉讼二审机构',
    appealCourt: '诉讼申诉机构',
    firstInstanceRuling: '一审裁决情况',
    secondInstanceRuling: '二审裁决情况',
    judgmentEnforcementStatus: '判决执行情况',
    litigationCosts: '诉讼费用',
    repaymentAmount: '偿还金额',

    RightsOfferingDetails: '配股详情',
    declareDate: '公告日期',
    allotRatio: '配股比例',
    allotPrice: '配股价格',
    expAllotVol: '预计配股数量',
    expAllotAmt: '预计募集资金',
    expIssueCost: '预计发行费用',
    underwriteMethod: '承销方式',
    equityRecordDate: '股权登记日',
    exRightsDate: '除权基准日',
    paymentStartDate: '配股缴款起始日',
    paymentEndDate: '配股缴款截止日',
    allotQuantity: '实际配股数量',
    underwriteBalance: '承销余额',
    fundRaisedTotal: '实际募资总额',
    fundRaisedNet: '实际募资净额',
    totalIssueCost: '发行费用总额',
    underwritingCost: '承销费用',
    fundArrivalDate: '资金到账日',
    beforeShareTotal: '配股前总股本',
    afterShareTotal: '配股后总股本',
    beforeShareFloat: '配股前流通股本',
    afterShareFloat: '配股后流通股本',
    stateAllotVol: '国家股实配数量',
    corporateAllotVol: '法人股实配数量',
    employeeAllotVol: '职工股实配数量',
    transferredShareVol: '转配股实配数量',
    otherShareVol: '其他股份实配数量',
    publicShareVol: '公众股实配数量',
    mshSubscriVol: '大股东认购数量',
    mshSubscriMethod: '大股东认购方式',
    transferableShareVol: '可转配股数量',
    corporateTransferVol: '法人获转配数量',
    publicTransferVol: '公众获转配数量',
    transferFeePerShare: '每股配权转让费',
    publicSubscriCode: '公众配售代码',
    publicSubscriName: '公众配售简称',
    otherSubscriCode: '其他配售代码',
    otherSubscriAbbr: '其他配售简称',
    listingAnnDate: '上市公告日期',
    allotListingDate: '配股上市日',
    warrantTradeStartDate: '配股权证交易起始日',
    warrantTradeEndDate: '配股权证交易截止日',
    refundDate: '配股失败退还申购款日期',
    suspensionStartDate: '停牌起始日',
    suspensionEndDate: '停牌截止日',
    subscriptionObject: '配售对象',
    issueResultAnnDate: '配股发行结果公告日',
    entrustUnit: '委托单位',
    subId: '记录标识',
    publicSubscriAbbrEn1: '申购简称1（英文）',
    publicSubscriAbbrEn2: '申购简称2（英文）',
    couponRate: '票面股息率',
    capitalVerificationDate: '验资日',

      boardAllotDetail: '配股预案详情',
      stockTypeCode: '股票类别编码',
      boardMeetingContent: '董事会预案内容',
      shareholderMeetingContent: '股东大会预案内容',
      fundUseDetails: '资金占用详情',
      fundUseType: '资金占用类别',
      fundUser: '资金占用方名称',
      year: '年度',
      relationship: '关联关系',
      accountingTreatment: '会计科目',
      periodStartFund: '期初占用资金余额',
      periodAdditionFund: '年度占用累计发生金额',
      periodInterest: '年度资金占用利息',
      periodRepayment: '年度偿还累计发生金额',
      periodEndFund: '期末占用资金余额',
      fundUseReason: '占用形成原因',
      useNature: '占用性质',
      compAnnCode: '公告内部编码',
      copyrightDetails: '著作权详情',
      articleName: '作品名称',
      articleCategory: '作品类别',
      copyrightHolder: '著作权人',
      creationDate: '创作完成日期',
      regDate: '登记日期',
      regNumber: '登记号',
      websiteRegDetails: '网站备案详情',
      auditTime: '审核时间',
      websiteName: '网站名称',
      websiteLink: '网站链接',
      domain: '域名',
      websiteRegNum: '网站备案/许可证号',
      ratingDetailsTitle: '评级详情',
      ratingAgency: '评级机构',
      ratingLabel: '评级',
      researchReportDetails: '研报详情',
      reportTitle: '报告名称',
      author: '作者',
      auditDetails: '审计详情',
      isAudit: '是否经审计',
      onsFirmId: '境内会计师事务所ID',
      onsFirmName: '境内会计师事务所名称',
      onsRegAccName: '境内签名注册会计师',
      onsAuditOpinionCode: '境内审计意见编码',
      onsAuditOpinionType: '境内审计意见类型',
      onsAuditSupplementary: '境内非标说明',
      ofsFirmId: '境外会计师事务所ID',
      ofsFirmName: '境外会计师事务所名称',
      ofsRegAccName: '境外签名注册会计师',
      ofsAuditOpinionCode: '境外审计意见编码',
      ofsAuditOpinionType: '境外审计意见类型',
      ofsAuditSupplementary: '境外非标说明',
      boardComment: '董事会说明',
      csrcComment: '监事会/监管说明',
      endDate: '截止日期',
      snrMgmtName: '董监高姓名',
      snrMgmtRole: '董监高职务',
      relationType: '关系',
      holdingPeriodStart: '期初持股数量',
      holdingPeriodEnd: '期末持股数量',
      holdingChangeAmt: '变动数量',
      holdingChangePct: '变动比例',
      avgStockPrice: '成交均价',
      holdingValuePeriodEnd: '期末市值',
      dataSource: '数据来源',
      snrMgmtSalary: '年薪',
    boardAllotRatio: '配股比例（董）',
    shareholderAllotRatio: '配股比例',
    parValuePerShare: '每股面值',
    allotBaseShares: '配股基准股本',
    estAllotPriceUpper: '预计配股价格上限',
    estAllotPriceLower: '预计配股价格下限',
    allotPricingMethod: '配股价格确定方式',
    estAllotVol: '预计配股数量',
    estFundRaising: '预计募集资金',
    expUseOfFunds: '预计募资投向',
    shareholderResolutionDate: '股东决议公告日期',
    allotApprovalDate: '配股获准公告日期',
    fundUseDetails: '资金占用详情',
    fundUseType: '资金占用类别',
    fundUser: '资金占用方名称',
    year: '年度',
    relationship: '占用方与上市公司的关联关系',
    accountingTreatment: '上市公司核算的会计科目',
    periodStartFund: '期初占用资金余额',
    periodAdditionFund: '年度占用累计发生金额',
    periodInterest: '年度资金占用利息',
    periodRepayment: '年度偿还累计发生金额',
    periodEndFund: '期末占用资金余额',
    fundUseReason: '占用形成原因',
    useNature: '占用性质',
    compAnnCode: '公告内部编码',

    CopyrightDetails: '著作权详情',
    articleName: '作品名称',
    articleCategory: '作品类别',
    copyrightHolder: '著作权人',
    creationDate: '创作完成日期',
    regDate: '登记日期',
    regNumber: '登记号',

    websiteRegDetails: '网站备案详情',
    auditTime: '审核时间',
    websiteName: '网站名称',
    websiteLink: '网站链接',
    domain: '域名',
    websiteRegNum: '网站备案/许可证号',
    regNum: '备案号',

    ratingDetails: '评级详情',
    agency: '评级机构',
    rating: '评级',
    ResearchReportDetails: '研报详情',
    reportTitle: '报告名称',
    author: '作者',

    AuditDetails: '审计详情',
    endDate: '报告期',
    isAudit: '是否经审计',
    onsFirmId: '境内会计师事务所ID',
    onsFirmName: '境内会计师事务所名称',
    onsRegAccName: '境内会计师事务所签名注册会计师',
    onsAuditOpinionCode: '境内会计师事务所审计意见类型编码',
    onsAuditOpinionType: '境内会计师事务所审计意见类型',
    onsAuditSupplementary: '非标准审计意见的事项内容',
    ofsFirmId: '境外会计师事务所ID',
    ofsFirmName: '境外会计师事务所名称',
    ofsRegAccName: '境外会计师事务所签名注册会计师',
    ofsAuditOpinionCode: '境外审计报告会计师事务所审计意见类型编码',
    ofsAuditOpinionType: '境外审计报告会计师事务所审计意见类型',
    ofsAuditSupplementary: '境外审计意见非标准的事项说明',
    boardComment: '董事会对会计师事务所出具的有保留意见书、解释说明',
    csrcComment: '监事会对董事会就上述事项的说明所表示的意见',

    snrMgmtName: '董监高姓名',
    snrMgmtRole: '董监高职务',
    relationType: '变动人与董监高关系',
    holdingPeriodStart: '期初持股数量',
    holdingPeriodEnd: '期末持股数量',
    holdingChangeAmt: '变动数量',
    holdingChangePct: '变动比例(‰)',
    avgStockPrice: '成交均价',
    holdingValuePeriodEnd: '期末市值',
    dataSource: '数据来源',
    snrMgmtSalary: '年薪'

  },


  // selfGroupsTable.vue
  selfGroupsTable: {
    industry: '行业',
    stock: '个股',
    billion: '亿',
    deleteSuccess: '删除成功',
    deleteFailure: '删除失败',
    setSuccess: '设置成功',
    setFailure: '设置失败',
    name: '名称',
    attribute: '属性',
    levelOneIndustry: '一级行业',
    levelTwoIndustry: '二级行业',
    parentIndustry: '所属行业',
    realPrice: '价格',
    realPct: '涨跌',
    mv_total: '市值',
    turnover_rate_f: '换手率',
    dv_ratio: '股息收益率(div%)',
    dv_ttm: '股息收益率(ttm)',
    action: '操作',
    addToGroup: '加入到分组',
    ungrouped: '未分组',
    confirmRemove: '确定移出吗？',
    remove: '移除',
  },

  accountShow: {
    title: '大语言模型预测概率分析对比',
    selectDate: '选择日期',
    detailTitle: '预测详情',
    stockCount: '共{count}只股票',
    stockName: '股票名称',
    llmPrediction: '{llm} 预测',
    llmAccuracy: '{llm} 准确性',
    actualMovement: '实际涨跌',
    up: '涨',
    down: '跌',
  },

  // selfSelected.vue
  selfSelected: {
    industry: '行业',
    stock: '个股',
    all: '全部',
    ungrouped: '未分组',
    addWatchlist: '添加自选：',
    searchPlaceholder: '请输入股票名称或股票代码',
    add: '添加',
    alreadyAdded: '已经添加',
    addSuccess: '添加成功',
    addFailure: '添加失败',
    deleteSuccess: '删除成功',
    deleteFailure: '删除失败',
    setSuccess: '设置成功',
    rankUpdated: '排序已更新',
    addGroupSuccess: '添加分组成功',
    addGroupFailure: '添加分组失败',
    renameSuccess: '修改成功',
    renameFailure: '修改失败',
    selectStockFirst: '请先在表格左侧复选框添加股票',
    myWatchlist: '我的自选股',
    editGroups: '编辑分组',
    syncView: '分时同屏',
    emptyDescription: '暂无自选内容，可通过上方搜索添加股票或行业',
    editWatchlistGroups: '编辑自选股分组',
    addGroup: '添加分组',
    groupName: '分组名称',
    action: '操作',
    editName: '修改名称',
    confirmDeleteGroup: '确定删除吗？',
    delete: '删除',
    setGroupName: '设置分组名称',
    cancel: '取消',
    confirm: '确认',
  },

  // baseLineOverlay.vue

  baseLineOverlay: {
    selectOverlayIndicator: '选择叠加指标',
  },

  // fundCo.vue
  fundCo: {
    kpiTips1: '### 公司整体聚合回报 vs 波动率：\n  - 横轴：年化波动率。\n  - 纵轴：年化回报率。\n  - 数据点：公司整体基金规模加权的回报和波动率表现。\n - 展现公司在风险与收益上的整体表现。',
    kpiTips2: '### 在管基金类型占比：\n  - 基于基金类型（股票型、债券型、混合型等）的分布占比。\n  - 展现公司产品线的多样性及风格倾向。',
    kpiTips3: '### 公司在管规模走势：\n  - 展示公司管理的总资产规模的时间变化趋势。\n  - 数据来源于公司所管理基金的累计规模。\n  - 红线为市场均值。',
    kpiTips4: '### 公司在管规模排名走势：\n  - 对比公司与其他基金公司在管理规模上的排名变化。\n  - 横轴为时间，纵轴为公司排名的百分比变化，排名靠前的百分比占比小（如：第一名为0%）。',
    kpiTips5: '### 在管基金规模分布：\n  - 展示公司所有基金的规模分布情况。\n  - 按规模区间（如：0-10亿，10-50亿，50亿以上）划分基金数量。',
    kpiTips6: '### 在管基金规模Top10：\n  - 列出公司规模排名前10的基金。\n  - 显示每只基金的规模及占公司总规模的比例。',
    kpiTips7: '### 在管基金规模Top10集中度：\n  - 计算公司规模排名前10基金占总规模的百分比。\n  - 集中度越高，说明公司依赖大基金的程度越高。',
    kpiTips8: '### 基金经理管理年限分布：\n  - 展示公司旗下基金经理的管理年限分布情况。\n  - 横轴为管理年限，纵轴为基金经理数量。\n  - 红线为市场上基金经理对应管理年限人数的平均值。',
    billionUnit: '亿',
    currencyUnit: '元',
    aum: '规模',
    aumRank: '规模排名',
    other: '其他',
    managerCount: '经验人数',
    marketAvgManagerCount: '市场平均经验人数',
    fundUnit: '只',
    fundCountWithUnit: '只基金',
    fundCount: '基金数',
    marketAvgFundCount: '市场平均基金数',
    annualizedVolatility: '年化波动率',
    annualizedReturn: '年化收益率',
    managedAum: '在管规模',
    managedFunds: '在管基金',
    managedAumRank: '在管规模排名',
    fundManager: '基金经理',
    basicInfo: '基本信息',
    pastOneYear: '(过去1年)',
    inceptionDate: '成立日期',
    registeredCapital: '注册资本',
    legalRepresentative: '法人代表',
    officialWebsite: '官网',
    companyAddress: '公司地址',
    companyProfile: '公司介绍',
    aumTrend: '公司在管规模走势',
    aumRankTrend: '公司在管规模排名走势',
    vsOtherFirms: '(对比其他公司)',
    managerTenureDistribution: '基金经理管理年限分布',
    personCount: '(人数)',
    fundSizeDistribution: '在管基金规模分布',
    fundCountInParentheses: '(基金数)',
    fundTypeProportion: '在管基金类型占比',
    returnVsVolatility: '公司整体聚合回报vs波动率',
    lastOneYear: '(近1年)',
    top10ManagedFunds: '在管基金规模Top10',
    top10Concentration: '在管基金规模Top10集中度',
    shareholders: '公司股东',
    shareholderName: '股东名称',
    shareholdingRatio: '占比',

  },

  // fundCoFundList.vue
  fundCoFundList: {
    tips1: '### 目标价 \n - 展示过去一年内评级机构给出的目标价区间与股价的对比 \n - 目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
    fetchFundDataFailed: '获取基金数据失败',
    riskLevelHigh: '高',
    riskLevelMediumHigh: '中高',
    riskLevelMedium: '中',
    riskLevelMediumLow: '中低',
    riskLevelLow: '低',
    fundList: '基金列表',
    fundName: '基金名称',
    fundManager: '基金经理',
    maxTenure: '最大工作年限',
    institutionalHoldingRatio: '机构持仓占比',
    inceptionDate: '成立日期',
    benchmark: '业绩基准',
    nav: '单位净值',
    accumulatedNav: '累计净值',
    fundSize: '基金规模',
    riskRating: '风险等级',
    oneDay: '(1天)',
    returnLabel: '回报',
    annualizedReturn: '年化回报',
    oneYearAnnualized: '(1年年化)',
    periodReturn: '区间回报',
    lastOneWeek: '(近1周)',
    lastOneMonth: '(近1个月)',
    lastThreeMonths: '(近3个月)',
    lastSixMonths: '(近6个月)',
    lastThreeYears: '(近3年)'
  },

  // fundCoMagList.vue
  fundCoMagList: {
    tips1: '### 目标价 \n - 展示过去一年内评级机构给出的目标价区间与股价的对比 \n - 目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
    fundManagerList: '基金经理列表',
    managedFunds: '在管基金',
    managedFundAum: '在管基金规模',
    billionUnit: '亿',
    tenureStartDate: '任职开始时间',
    tenureYears: '任职年限',
    fundCompany: '基金公司',
    yearUnit: '年',
  },

  // fundComp.vue
  fundComp:{
    Tips1: '### 分类说明： \n   - 股票投资：投资于股票类资产。\n   - 基金投资：投资于其他基金。 \n   - 债券投资：投资于债券类资产。 \n   - 现金：现金及现金等价物。 \n   - 其他投资：包含衍生品、贵金属等其他类型资产。',
    Tips2: ' - 持仓股票对应申万 L1 行业的占比分析。',
    Tips3: '#### 机构持有者与个人持有者占比：\n - 按时间展示机构投资者与个人投资者的占比变。\n   - 基金投资：投资于其他基金',
    Tips4: ' - 前十大重仓股的市值占比之和，用于衡量持仓集中程度。',
    top10Concentration: 'Top10 集中度',
    other: '其他',
    holdingRatioPct: '占比 (%)',
    holderCount: '持有人户数',
    institutionalHoldingRatio: '机构持有占比',
    individualHoldingRatio: '个人持有占比',
    domestic: '国内',
    overseas: '国外',
    stockInvestment: '股票投资',
    fundInvestment: '基金投资',
    bondInvestment: '债券投资',
    warrantInvestment: '权证投资',
    absInvestment: '资产支持证券投资',
    cdInvestment: '银行存单',
    settlementReserve: '结算预报金',
    derivativeAssets: '衍生金融资产',
    preciousMetalsInvestment: '贵金属投资',
    otherInvestment: '其他投资',
    tenThousandUnit: '万元',
    noData: '暂无数据',
    constituentTop10: '成分 Top10',
    constituentTop10Concentration: '成分 Top10 集中度',
    fundConstituentsDetails: '基金成分详情',
    holderTop10: '持有人 Top10',
    holderStructure: '持有人结构',
    industryDistribution: '行业分布',
    domesticOverseasDistribution: '国内外分布',
    constituentName: '成分名称',
    holdingQuantity: '持股数量',
    holdingMarketValue: '持仓市值',
    holdingRatio: '占比'

  },

  // fundCompanyFilterTable.vue
  fundCompanyFilterTable: {
    fetchFundDataFailed: '获取基金数据失败',
    fundCompany: '基金公司',
    aum: '规模', // Assets Under Management
    fundCount: '基金数量',
    managerCount: '经理数量',
    aumRankPercentile: '在管规模排名百分位',
    inceptionDate: '成立时间',
    inceptionYears: '成立年限',
    yearUnit: '年'
  },

  // fundFilterTable.vue
  fundFilterTable: {
    fetchFundDataFailed: '获取基金数据失败',
    high: '高',
    mediumHigh: '中高',
    medium: '中',
    mediumLow: '中低',
    low: '低',
    fundName: '基金名称',
    fundSize: '基金规模', // 替代 "net_asset"，更常用
    inceptionDate: '成立日期',
    riskRating: '风险等级',
    institutionHoldingRatio: '机构持有比例',
    managerTenure: '基金经理从业年限',
    unitNav: '单位净值',
    accumNav: '累计净值',
    returnLabel: '回报',
    oneDay: '(1天)',
    annualized: '年化回报',
    periodReturn: '区间回报',
    lastOneWeek: '(近1周)',
    lastOneMonth: '(近1个月)',
    lastThreeMonths: '(近3个月)',
    lastSixMonths: '(近6个月)',
    lastThreeYears: '(近3年)',
    lastFiveYears: '(近5年)',
    yearToDate: '(今年以来)',
    sinceInception: '(成立以来)',
    volatility: '波动率',
    semiDevAnnlzd: '下行偏差',
    maxDrawdown: '最大回撤',
    periodMaxDrawdown: '区间最大回撤',
    oneYear: '(1年)',
    oneYearAnnlzd: '(1年年化)',
    sharpeRatio: '夏普比率',
    sortinoRatio: 'Sortino比率',
    calmarRatio: '卡玛比率',
    fundManager: '基金经理',
    maxTenure: '最大工作年限',
    institutionHoldingPct: '机构持仓占比',
    performanceBenchmark: '业绩基准',
    yearUnit: '年'
  },

  // fundManagerFilterTable.vue
  fundManagerFilterTable:{
    fetchFundDataFailed: '获取基金数据失败',
    fundHumanName: '基金经理',
    fundCompanyName: '基金公司',
    liveFundCount: '在管基金',
    liveNetAssetSum: '在管基金规模',
    liveFundInvestType: '在管基金类型',
    startTenure: '任职开始时间',
    maxTenure: '任职年限'

  },

  // fundMg.vue
  fundMg: {
    tips1: '### 基金经理综合评分 \n - 基金类型：股票型、债券型、混合型、货币型、封闭式、基金型、商品型、REITs型 \n - 综合评分：基于以下六项指标的平均分：\n 1. 综合业绩：近 5 年 Sharpe 值，根据分类规模占比加权平均。\n 2. 近期业绩：半年内 Sharpe 值，根据分类规模占比加权平均。\n 3. 业绩稳定性：近 1 至 5 年（以季度为单位）的业绩评分标准差。\n  4. 综合规模：基于规模排名，根据分类规模占比加权平均。\n 5. 综合经验：基于管理时间、在管基金数量、在管种类的加权平均。\n 6. 风格稳定性：全历史类型规模占比的变化程度。',
    tips2: '### 基金经理规模排名 \n - 当前时间的排名',
    tips3: '- 基于所管基金的统计',
    percentile: '百分位',
    overallPerformance: '综合业绩',
    recentPerformance: '近期业绩',
    performanceStability: '业绩稳定性',
    styleStability: '风格稳定性',
    overallExperience: '综合经验',
    overallScale: '综合规模',
    gapPeriod: '空档期',
    managedFunds: '在管基金',
    managedAum: '在管规模',
    managementExperience: '管理经验',
    careerStartDate: '从业开始时间',
    education: '学历',
    managedFundTypes: '在管基金类型',
    professionalCertifications: '专业证书',
    profile: '简介',
    viewMore: '查看更多>>',
    collapse: '收起<<',
    managerOverallScore: '基金经理综合评分',
    overallScore: '综合评分',
    radarChart: '雷达图',
    employmentHistory: '基金经理任职公司历史',
    tenureCompany: '任职公司',
    tenureStartDate: '任职开始时间',
    tenureEndDate: '任职结束时间',
    present: '至今',
    tenureDuration: '管理时间',
    scaleRank: '基金经理规模排名',
    fundType: '基金类型',
    all: '全部',
    rank: '排名',
    rankPercentile: '排名百分位',
    performanceRank: '基金经理业绩排名',
    annualizedReturn: '年化收益率',
    periodGrowthRate: '区间增长率'

  },

  // fundMgHolding.vue
  fundMgHolding: {
    tips: '- 类型说明：股票型、债券型、混合型、货币型、封闭式、基金型、商品型、REITs 型。\n - 分析方法：基于所管基金的所属类型，计算类型占比。',
    managedFundTypeProportion: '在管基金类型占比',
    managedFundTypeProportionTrend: '在管基金类型占比走势',
    top10ManagedFundSizeProportionHistory: '在管基金规模占比Top10历史'
  },

  // fundMgPerformance.vue
  fundMgPerformance: {
    tips1: '### 业绩 \n - 内容：基于规模加权平均业绩，展示所管理基金的整体增长率。\n - 聚合方式：将基金经理不同阶段管理的不同基金的业绩合并到一起。\n - 聚合方式：通过时间切片市值加权累加得出。\n - 切片时间回报 = $$r^t = (\\sum_{i}r_{i}^t*w_{i}^t)/\\sum_{i}w_{i}^t$$',
    tips4: '### 使用说明：\n   - 将基金经理在不同阶段管理的不同基金业绩归零，从管理起点重新计算。\n   - 单只基金表现：可单独查看每只基金的在管期间表现。\n   - 多只基金合并：点击左侧复选框，合并查看多只基金表现。',
    cumulativeGrowthRate: '累计增长率',
    cumulativeNav: '累计净值',
    tenureFundAggregatedPerformanceTrend: '任期基金聚合业绩历史走势',
    all: '全部',
    managedFundsHistorical: '管理过的基金',
    total: '共',
    fundUnit: '只',
    selectTop: '选前',
    itemsSelectedOrCancel: '个 / 取消',
    currentlyManaged: '在管',
    historical: '历史',
    to: '至',
    present: '今',
    tenureFundPerformanceTrend: '任期基金历史走势',
    switchFundTip: '(左侧可切换基金)'
  },

  // fundMgPerformanceAnalysis.vue
  fundMgPerformanceAnalysis: {
    tips3: '### 风险回报走势分析 \n - 分析范围：可自定义时间段，覆盖基金经理管理的全历史。\n - 聚合业绩与指数对比：经理业绩与同期各指数表现的对比分析。\n #### Sharpe 走势：\n - 正态化 Sharpe：时间窗口内 Sharpe 的正态化走势。\n - 均值 > 0：代表平均回报为正。\n #### Sharpe 排名走势：\n - 均值 > 0：代表 Sharpe 平均跑赢市场其他经理。',
    all: '全部',
    oneMonth: '1个月',
    threeMonths: '3个月',
    sharpe: 'Sharpe',
    meanLabel: '均值:',
    sharpeRank: 'sharpe排名',
    aggregatedPerformance: '业绩聚合',
    normalizedSharpe: '正态化sharpe',
    stdRank: 'std排名',
    managerRiskReturnTrend: '经理风险回报走势分析',
    periodReturn: '区间回报',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    selectOverlayIndicator: '选择叠加指标',
    sharpeRollingWindowLabel: 'sharpe滚动窗口：',
    selectRollingWindow: '选择滚动窗口',
    sharpeTypeLabel: 'sharpe类型：'

  },

  // fundMgScale.vue
  fundMgScale: {
    tips1: '- 基于所管基金的规模排名 \n - 排名越靠前：数值越接近 0% \n - 排名越靠后：数值越接近 100%',
    aum: '规模',
    rank: '排名',
    aumRank: '规模排名',
    aumAndRankTrend: '管理规模&排名走势',
    currencyUnit: '元',
    all: '全部'
  },

  // fundMgVolatilityPerformance.vue
  fundMgVolatilityPerformance: {
    tip2: '### 回报vs风险 \n - 时间窗口内，所有基金经理业绩回报与风险的分布情况 \n - 年化波动率 = 区间平均日波动率 * sqrt(242) \n - 年化收益率 = 1-（1+ 区间收益率 ) ^ （242/区间交易天数）\n - 横线价值：反映不同风险水平（波动率水平）对应的区间平均市场回报',
    lastThreeMonths: '近3个月',
    lastSixMonths: '近6个月',
    lastOneYear: '近1年',
    lastThreeYears: '近3年',
    lastFiveYears: '近5年',
    volatility: '波动率',
    returnRate: '收益率',
    annualizedVolatility: '年化波动率',
    annualizedReturn: '年化收益率',
    intercept: '截距',
    slope: '斜率',
    managerAggregatedReturnVsVolatility: '经理聚合回报vs波动率',
    allTypes: '全类型',
    selectTimeWindow: '选择时间窗口'
  },

  // fundRankBar.vue
  fundRankBar: {
  },

  // fundCompany.vue
  fundCompany: {
    fundCompany: '基金公司',
    managedFunds: '在管基金',
    fundManager: '基金经理'
  },

  // fundCompanyFilter.vue
  fundCompanyFilter:{
    aumBelow10B: '小于100亿',
    aum10BTo20B: '100~200亿',
    aum20BTo50B: '200~500亿',
    aum50BTo100B: '500~1000亿',
    aumAbove100B: '1000亿以上',

    tenureBelow5Years: '5年内',
    tenure5To10Years: '5~10年',
    tenure10To15Years: '10~15年',
    tenure15To20Years: '15~20年',
    tenureAbove20Years: '20年以上',

    companySizeLabel: '公司规模：',
    inceptionTimeLabel: '成立时间：',
    keywordLabel: '关键字：',
    placeholderKeyword: '请输入关键字',
    selectedTagsLabel: '已选标签：',
    clearAll: '清空',
    filterResults: '筛选结果',
    rollingWindowOneYear: '区间窗口：近一年'

  },

  // fundFilter.vue
  fundFilter: {
    pctChg: '收益率',
    pctChgAnnlzd: '年化收益率',
    volatility: '波动率',
    volatilityAnnlzd: '年化波动率',
    semiDev: '下行偏差',
    drawDownType2: '区间最大回撤',
    sharpe: '夏普比率',
    sortino: 'Sortino比率',
    calmarType2: '区间卡玛比率',
    fundSize: '基金规模',
    fundSize0To1B: '0~10亿',
    fundSize1BTo2B: '10~20亿',
    fundSize2BTo5B: '20~50亿',
    fundSizeAbove5B: '50亿以上',
    billionUnit: '亿',
    inceptionDate: '成立日期',
    tenureLast1Year: '近1年',
    tenure1To5Years: '1~5年',
    tenureAbove5Years: '5年以上',
    riskRating: '风险等级',
    riskLevelLow: '低',
    riskLevelMedium: '中',
    riskLevelHigh: '高',
    institutionalHoldingRatio: '机构持有比例',
    managerTenure: '基金经理从业年限',
    tenureBelow2Years: '小于2年',
    tenure2To4Years: '2~4年',
    tenure4To6Years: '4~6年',
    tenure6To8Years: '6~8年',
    tenure8To10Years: '8~10年',
    tenure10To15Years: '10~15年',
    tenure15To20Years: '15~20年',
    tenureAbove20Years: '20年以上',
    top20Percent: '前20%',
    bottom20Percent: '后20%',
    lastOneWeek: '近一周',
    fundTypeLabel: '基金类型：',
    investmentCategoryLabel: '投资分类：',
    noLimit: '不限',
    fundMetricLabel: '基金指标：',
    rankingStageLabel: '阶段排序：',
    keywordLabel: '关键字：',
    placeholderKeyword: '请输入关键字',
    selectedTagsLabel: '已选标签：',
    clearAll: '清空',
    filterResults: '筛选结果'
  },

  // fundManager.vue
  fundManager: {
    fundManager: '基金经理',
    historicalPerformance: '历史业绩',
    performanceAnalysis: '业绩分析',
    riskReturn: '风险回报',
    holdingAnalysis: '持仓分析',
    scaleAnalysis: '规模分析'

  },

  // fundManagerFilter.vue
  fundManagerFilter: {

    fundSizeBelow0_5B: '小于0.5亿',
    fundSize0_5BTo1B: '0.5~1亿',
    fundSize1BTo2B: '1~2亿',
    fundSize2BTo4B: '2~4亿',
    fundSize4BTo8B: '4~8亿',
    fundSize8BTo15B: '8~15亿',
    fundSize15BTo30B: '15~30亿',
    fundSize30BTo60B: '30~60亿',
    fundSize60BTo100B: '60~100亿',
    fundSize100BTo500B: '100~500亿',
    fundSizeAbove500B: '500亿以上',

    fundTypeLabel: '基金类型：',
    managedAumLabel: '在管规模：',
    billionUnit: '亿',
    keywordLabel: '关键字：',
    noLimit: '不限',
    placeholderKeyword: '请输入关键字',
    selectedTagsLabel: '已选标签：',
    clearAll: '清空',
    rollingWindowOneYear: '区间窗口：近一年'

  },

  // FundView.vue
  FundView:{
    tips1: '### 基金分类 \n - 普通股票型、增强指数型、中短期纯债型、长期纯债型、一级债基、二级债基、债券指数型、复制指数型、平衡混合型、偏股混合型、偏债混合型、保本型、货币型、短期理财债券型、基金型、贵金属商品、其他商品、基础设施。 \n ### 风格定义 \n #### 大小盘定义 \n - 大盘基金：主要投资于市值较大的股票。 \n - 小盘基金：主要投资于市值较小的股票。 \n #### 成长价值定义 \n - 成长型基金：注重企业增长潜力，偏好高收益高风险。 \n  - 价值型基金：关注企业当前估值，偏好稳定收益。\n  - 绿色点：代表当前基金。\n - 蓝色点：代表其他同类基金的分布。',
    tips2: '### 评分指标 \n  1. 收益率: 时间窗口内基于收益率的排名得分，得分越高，表示收益越高。 \n  2. 波动率: 时间窗口内基于波动率的排名得分，得分越高，表示波动越小。 \n 3. 最大回撤: 时间窗口内基于最大回撤的排名得分，得分越高，表示最大回撤越小。 \n  4. 超额收益: 时间窗口内基于超额收益的排名得分，得分越高，表示超额收益越高。  \n 5. 夏普比率: 时间窗口内基于夏普比率的排名得分，得分越高，表示夏普值越高',
    tenThousandUnit: '万元',
    billionUnit: '亿',

    open: '开',
    high: '高',
    low: '低',
    close: '收',
    price: '价格',
    predictedPrice: '预测价格',
    tradingAmount: '成交额',
    predictedTradingAmount: '预测成交额',
    predictionDate: '预测日',

    unitNav: '单位净值',
    unitNavLabel: '单位净值:',
    accumulatedNav: '累计净值',
    accumulatedNavLabel: '累计净值:',
    cumulativeGrowthRate: '累计增长率',
    returnRate: '收益率',
    annualizedReturn: '年化收益率',
    periodGrowthRate: '区间增长率',

    volatility: '波动率',
    maxDrawdown: '最大回撤',
    excessReturn: '超额收益',
    sharpe: '夏普',
    percentile: '百分位',
    performance: '业绩',
    style: '基金风格',

    value: '价值',
    balanced: '均衡',
    growth: '成长',
    smallCap: '小盘',
    midCap: '中盘',
    largeCap: '大盘',

    shortName: '简称',
    fundManager: '基金经理',
    fundCompany: '基金公司',
    inceptionDate: '成立日期',
    fundSize: '基金规模',
    tradingMarket: '交易市场',
    restructuredFund: '改制基金',
    custodianName: '基金托管人名称',
    custodyFeeRate: '托管费率',
    managementFeeRate: '管理费率',
    feeCalculationStandard: '费率提取标准',
    duration: '存续期限',
    durationStartDate: '存续期起始日',
    durationEndDate: '存续期终止日',
    rolloverMethod: '结转方式',
    riskReturnProfile: '风险收益特征',
    investmentObjective: '投资目标',
    investmentScope: '投资范围',

    collapseMore: '收起更多<<',
    viewMore: '查看更多>>',
    basicInfo: '基本信息',
    components: '成分',
    tracking: '跟踪',
    selectOverlayIndicator: '选择叠加指标',
    color: '颜色',
    logScale: '对数',
    fundRating: '基金评分',
    market: '行情',
    yes: '是',
    no: '否',

    lastOneWeek: '近1周',
    lastOneMonth: '近1月',
    lastThreeMonths: '近3月',
    lastOneYear: '近1年',
    lastThreeYears: '近3年',
    recent3m: '(近3月)',
    performanceStageRanking: '业绩阶段排名',
    rank: '排名',
    rankPercentile: '排名百分位',
    fundCount: '(共{count}只基金)'

  },
//
//
//   // BondView.vue
//   BondView: {
//     xx: '最多只能选择',
//     xx: '财富',
//     xx: '全价',
//     xx: '净价',
//     xx: '现券结算量(亿元)',
//     xx: '平均市值法-久期(年)',
//     xx: '平均现金流法-久期(年)',
//     xx: '平均市值法-凸性',
//     xx: '平均现金流法-凸性',
//     xx: '平均市值法-到期收益率(%)',
//     xx: '平均现金流法-到期收益率(%)',
//     xx: '平均基点价值(元)',
//     xx: '平均代偿期(年)',
//     xx: '平均派息率(%)',
//     xx: '指数上日总市值(亿元)',
//     xx: '财富指数涨跌幅(%)',
//     xx: '全价指数涨跌幅(%)',
//     xx: '净价指数涨跌幅(%)',
//     xx: '总值',
//     xx: '10年以上',
//     xx: '7-10年',
//     xx: '5-7年',
//     xx: '3-5年',
//     xx: '1-3年',
//     xx: '一年以下',
//     xx: '9-12个月',
//     xx: '6-9个月',
//     xx: '3-6个月',
//     xx: '0-3个月',
//     xx: '深交所',
//     xx: '银行间市场',
//     xx: '柜台',
//     xx: '离岸场外市场',
//     xx: '上交所',
//     xx: '单指数',
//     xx: '多指数对比',
//     xx: '债券指数：',
//     xx: '选择债券指数',
//     xx: '债券类型：',
//     xx: '请选择指数类型',
//     xx: '代偿期：',
//     xx: '请选择指数代偿期',
//     xx: '五年',
//     xx: '全部',
//     xx: '查询',
//     xx: '暂无所选数据',
//     xx: '利率走势',
//     xx: '暂无当日数据',
//
//   },
//
//   // commodityView.vue
//   commodityView: {
//     xx: '最多只能选择',
//     xx: '开',
//     xx: '高',
//     xx: '低',
//     xx: '收',
//     xx: '商品指数：',
//     xx: '选择债券指数',
//     xx: '五年',
//     xx: '全部',
//     xx: '查询',
//     xx: '暂无所选数据',
//   },
//
//
//   // HighChartStockTools.vue
//   HighChartStockTools: {
//     xx: '指标',
//     xx: '简单移动平均线',
//     xx: '指数移动平均线',
//     xx: '布林带',
//     xx: '周期',
//     xx: '添加',
//     xx: '颜色',
//     xx: '宽度',
//     xx: '保存',
//     xx: '指标',
//     xx: '形状',
//     xx: '标签',
//     xx: '圆形',
//     xx: '矩形',
//     xx: '椭圆',
//     xx: '线条',
//     xx: '线段',
//     xx: '箭头线段',
//     xx: '射线',
//     xx: '箭头射线',
//     xx: '直线',
//     xx: '箭头直线',
//     xx: '水平线',
//     xx: '垂直线',
//     xx: '曲线',
//     xx: '艾略特3',
//     xx: '艾略特5',
//     xx: '弯曲3',
//     xx: '弯曲5',
//     xx: '测量',
//     xx: '测量XY',
//     xx: '测量X',
//     xx: '测量Y',
//     xx: '高级',
//     xx: '斐波那契',
//     xx: '叉形线',
//     xx: '平行通道',
//     xx: '线类型',
//     xx: '线图',
//     xx: '蜡烛图',
//   },
//
//   // TickerValuation.vue
//   TickerValuation: {
//     Tips2: '### 估值 \n - 展示当前个股估值与所属一级行业和二级行业估值的对比 \n - 估值极值处理',
//     Tips3: '### 目标价 \n - 展示过去一年内评级机构给出的目标价区间与股价的对比 \n - 目标最低价、目标最高价、目标平均价，均为过去60个交易日的平均价',
//     xx: '亏损',
//     xx: '低',
//     xx: '25分位',
//     xx: '50分位',
//     xx: '75分位',
//     xx: '高',
//     xx: 'L2均值',
//     xx: '经营',
//     xx: '成长',
//     xx: '风险',
//     xx: 'L2估值',
//     xx: '能力详情',
//     xx: '运营',
//     xx: '成长',
//     xx: '投放金额',
//     xx: '还款金额',
//     xx: '风险',
//     xx: '估值',
//     xx: '(与所属行业比较)',
//     xx: '一级行业：',
//     xx: '二级行业：',
//     xx: '估值分析',
//     xx: '调整前',
//     xx: '(过去1年)',
//     xx: '(过去3个月)',
//     xx: '调整后',
//     xx: '企业价值',
//     xx: '估值分析2',
//     xx: '能力项',
//     xx: '能力',
//     xx: '能力趋势',
//     xx: '经营',
//     xx: '风险',
//     xx: '能力详情',
//   },
//
//   // selfSelected.vue
//   selfSelected: {
//     xx: '行业',
//     xx: '个股',
//     xx: '已经添加',
//     xx: '添加成功',
//     xx: '添加失败',
//     xx: '未分组',
//     xx: '删除成功',
//     xx: '删除失败',
//     xx: '修改成功',
//     xx: '添加失败',
//     xx: '排序已更新',
//     xx: '请先在表格左侧复选框添加股票',
//     xx: '全部',
//     xx: '添加自选：',
//     xx: '请输入股票名称或股票代码',
//     xx: '添加',
//     xx: '我的自选股',
//     xx: '编辑分组',
//     xx: '分时同屏',
//     xx: '全部',
//     xx: '编辑自选股分组',
//     xx: '分组名称',
//     xx: '操作',
//     xx: '修改名称',
//     xx: '确定删除吗？',
//     xx: '删除',
//     xx: '设置分组名称',
//     xx: '取消',
//     xx: '确认',
//
//   },
//
//   // SyncView.vue
//   SyncView: {
//     xx: '昨收',
//     xx: '价格',
//     xx: '开',
//     xx: '高',
//     xx: '低',
//     xx: '收',
//     xx: '成交额',
//   },
//
//   // sage: ProductPosition.vue
//   ProductPosition: {
//     xx: '金额',
//     xx: '元',
//     xx: '占比',
//     xx: '持仓比例',
//     xx: '股票',
//     xx: '债券',
//     xx: '逆回购',
//     xx: '基金',
//     xx: '现金',
//     xx: '持仓比例',
//     xx: '债券',
//     xx: '逆回购',
//     xx: '基金',
//     xx: '当前总持仓',
//     xx: '计划总持仓',
//     xx: '总持仓历史',
//     xx: '持仓比例',
//     xx: '持仓金额',
//     xx: '当前股票持仓行业分析',
//     xx: '持仓详情',
//     xx: '持仓数量',
//     xx: '持仓金额',
//     xx: '本金',
//     xx: '总盈亏',
//     xx: '当日盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//   },
//
//   // sage: ProductStrategy.vue
//   ProductStrategy:{
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '策略列表',
//     xx: '策略名称',
//     xx: '使用账户',
//     xx: '策略使用',
//     xx: '账户累计表现',
//     xx: '账户累计收益',
//     xx: '天',
//     xx: '元',
//     xx: '开始时间',
//     xx: '结束时间',
//     xx: '策略区间',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标'
//
//   },
//
//   // ProductTrade.vue
//   ProductTrade: {
//     xx: '交易账户列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '当前资产',
//     xx: '当前市值',
//     xx: '可用资金',
//     xx: '当日盈亏',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易量',
//     xx: '所属产品：',
//     xx: '创建时间：',
//     xx: '模拟盘',
//     xx: '实盘',
//   },
//
//   // SEAnalysis.vue
//   SEAnalysis: {
//     xx: '策略名称',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '跟踪误差',
//     xx: '评价：',
//     xx: '评估历史',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '次/年',
//     xx: '市场暴露度',
//     xx: '信息比率',
//     xx: '跟踪误差',
//     xx: '交易费用率',
//     xx: '评价',
//     xx: '仓位历史',
//     xx: '选择日期',
//     xx: '名称',
//     xx: '持仓数量',
//     xx: '持仓均价',
//     xx: '当前价格',
//     xx: '总市值',
//     xx: '可卖数量',
//     xx: '浮动盈亏',
//     xx: '累计盈亏',
//     xx: '当日盈亏',
//     xx: '当日买入数量',
//     xx: '当日卖出数量',
//     xx: '当日买入金额',
//     xx: '当日卖出金额',
//     xx: '当日佣金',
//     xx: '当日印花税',
//     xx: '当日过户费',
//     xx: '交易日期',
//     xx: '状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '元',
//   },
//
//   // SEBackTest.vue
//   SEBackTest: {
//     xx: '回测历史',
//     xx: '策略名称',
//     xx: '创建人',
//     xx: '开始时间',
//     xx: '结束时间',
//     xx: '操作',
//     xx: '查看',
//
//   },
//
//   // SEPosition.vue
//   SEPosition: {
//     xx: '策略名称',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '跟踪误差',
//     xx: '评价：',
//     xx: '评估历史',
//     xx: '评估日期',
//     xx: '年化回报率',
//     xx: '年化波动率',
//     xx: '夏普比率',
//     xx: '最大回撤',
//     xx: '胜率',
//     xx: '盈亏比',
//     xx: '换手率',
//     xx: '策略容量',
//     xx: '平均持仓时间',
//     xx: '交易频率',
//     xx: '市场暴露度',
//     xx: '超额收益',
//     xx: '贝塔值',
//     xx: '信息比率',
//     xx: '跟踪误差',
//     xx: '交易费用率',
//     xx: '评价',
//   },
//
//   // tradeExecution.vue
//   tradeExecution: {
//     xx: '调仓进度',
//     xx: '已完成',
//     xx: '未完成',
//     xx: '仓位',
//     xx: '当前资产分布',
//     xx: '股票',
//     xx: '基金',
//     xx: '债券',
//     xx: '回购',
//     xx: '现金',
//     xx: '目标资产分布',
//     xx: '调仓概述',
//     xx: '计划调整',
//     xx: '实际调整',
//     xx: '总买金额',
//     xx: '总卖金额',
//     xx: '总调整金额',
//     xx: '总买仓位',
//     xx: '总卖仓位',
//     xx: '总调整仓位',
//     xx: '滑点概述',
//     xx: '预算值',
//     xx: '实际值',
//     xx: '类型',
//     xx: '买入滑点(基点)',
//     xx: '卖出滑点(基点)',
//     xx: '总滑点(基点)',
//     xx: '调仓总进度',
//     xx: '当前持仓详情',
//     xx: '名称',
//     xx: '持仓数量',
//     xx: '持仓均价',
//     xx: '总市值',
//     xx: '浮动盈亏',
//     xx: '当前价格',
//     xx: '可卖数量',
//     xx: '建仓金额',
//     xx: '本金',
//     xx: '累计佣金',
//     xx: '累计印花税',
//     xx: '累计过户税',
//     xx: '当日佣金',
//     xx: '当日印花税',
//     xx: '当日过户税',
//     xx: '当日买入额',
//     xx: '当日卖出额',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '元',
//     xx: '股',
//   },
//
//   // TradeHistory.vue
//   TradeHistory: {
//     xx: '获取逐笔成交数据失败',
//     xx: '逐笔成交历史',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '名称',
//     xx: '方向',
//     xx: '买入',
//     xx: '卖出',
//     xx: '委托数量',
//     xx: '委托价格',
//     xx: '成交数量',
//     xx: '成交均价',
//     xx: '成交金额',
//     xx: '订单状态',
//     xx: '成交时间'
//
//   },
//
//   // TradeOrder.vue
//   TradeOrder: {
//     xx: '获取交易订单数据失败',
//     xx: '交易订单',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '名称',
//     xx: '订单号',
//     xx: '交易号',
//     xx: '方向',
//     xx: '买入',
//     xx: '卖出',
//     xx: '撤单',
//     xx: '订单状态',
//     xx: '全部成交',
//     xx: '部分成交',
//     xx: '未成交',
//     xx: '成交数量',
//     xx: '成交均价',
//     xx: '成交金额',
//     xx: '成交时间',
//     xx: '交易日期',
//   },
//
//   // ProductFilter.vue
//   ProductFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率:',
//     xx: '收益率:',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '产品列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '年化波动',
//     xx: '初始资产',
//     xx: '当前资产',
//     xx: '初始份额',
//     xx: '当前份额',
//     xx: '产品成立：',
//     xx: '风险回报',
//   },
//
//   // ProductView.vue
//   ProductView: {
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '单位净值:',
//     xx: '累计净值:',
//     xx: '跟踪:',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '总份额',
//     xx: '管理人',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '产品名称',
//     xx: '产品类型',
//     xx: '合作开始时间',
//     xx: '合作结束时间',
//     xx: '初始净值',
//     xx: '营业部名称',
//     xx: '资金账号',
//     xx: '币种',
//     xx: '托管费率',
//     xx: '管理费率',
//     xx: '运营服务费',
//     xx: '费率提取标准',
//     xx: '投资目标',
//     xx: '业绩比较基准',
//     xx: '产品托管人',
//     xx: '市场',
//     xx: '合同号',
//     xx: '状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '产品描述',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益率',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '(基准)',
//   },
//
  // sageIndex.vue
  sageIndex:{
    sageIndex1: '通用策略',
    sageIndex2: '定制策略',
    sageIndex3: '产品管理',
    sageIndex4: '交易管理',
    sageIndex5: '策略实验',
  },
  sageProductFilter: {
    unnamedPoint: '未命名点',
    jitai: '极态',
    volatilityLabel: '波动率',
    returnLabel: '收益率',
    annualizedVolatility: '年化波动率',
    annualizedReturn: '年化收益率',
    jitaiStrategy: '极态策略',
    intercept: '截距',
    slope: '斜率',
    allTypes: '全类型',
    equityType: '股票型',
    bondType: '债券型',
    mixedType: '混合型',
    all: '全部',
    past1Month: '近1个月',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past2Months: '近2个月',
    past4Months: '近4个月',
    past1Year: '近1年',
    productList: '产品列表',
    nav: '净值',
    cumulativeReturn: '累计收益',
    annualizedReturnShort: '年化收益',
    annualizedVolatilityShort: '年化波动',
    initialAssets: '初始资产',
    currentAssets: '当前资产',
    initialUnits: '初始份额',
    currentUnits: '当前份额',
    manager: '管理人',
    founded: '产品成立',
    riskReturn: '风险回报',
  },
  sageProductView: {
    all: '全部',
    past1Month: '近1个月',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past2Months: '近2个月',
    past4Months: '近4个月',
    past1Year: '近1年',
    performance: '业绩',
    strategyAnalysis: '策略分析',
    positionAnalysis: '持仓分析',
    tradeManagement: '交易管理',
    unitNav: '单位净值:',
    totalNav: '累计净值:',
    predictionDay: '预测日',
    benchmarkTrack: '跟踪',
    establishmentDate: '成立日期',
    scale: '规模',
    totalUnits: '总份额',
    manager: '管理人',
    collapseMore: '收起更多<<',
    viewMore: '查看更多>>',
    basicInfo: '基本信息',
    productName: '产品名称',
    productType: '产品类型',
    cooperationStart: '合作开始时间',
    cooperationEnd: '合作结束时间',
    initialNav: '初始净值',
    cumulativeGrowthRate: '累计增长率',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    selectOverlayIndicator: '选择叠加指标',
    performanceOverview: '业绩表现',
    cumulativeReturn: '累计收益',
    benchmark: '基准',
    annualizedReturn: '年化收益率',
    maxDrawdown: '最大回撤',
    annualizedVolatility: '年化波动率',
    logarithm: '对数',
    predictionDay: '预测日',
    branchName: '营业部名称',
    financialAccount: '资金账号',
    currency: '币种',
    custodyFeeRate: '托管费率',
    managementFeeRate: '管理费率',
    operationalFeeRate: '运营服务费',
    flatRateStandard: '费率提取标准',
    investmentTarget: '投资目标',
    performanceBenchmark: '业绩比较基准',
    custodian: '产品托管人',
    market: '市场',
    contractNo: '合同号',
    status: '状态',
    available: '可用',
    unavailable: '不可用',
    productDescription: '产品描述',
    benchmarkSuffix: '(基准)',
  },
  sageProductTrade: {
    accountList: '账户列表',
    nav: '净值',
    cumulativeReturn: '累计收益',
    currentAssets: '当前资产',
    currentMarketValue: '当前市值',
    availableCash: '可用现金',
    dailyPnl: '当日盈亏',
    dailyBuyQty: '当日买入量',
    dailySellQty: '当日卖出量',
    dailyTradeQty: '当日成交量',
    productBelonging: '所属产品: ',
    createdAt: '创建时间',
    simulated: '模拟',
    live: '实盘',
  },
  sageProductPosition: {
    amount: '金额',
    ratio: '占比',
    holdingRatio: '持仓比例',
    stock: '股票',
    bond: '债券',
    reverseRepo: '逆回购',
    fund: '基金',
    cash: '现金',
    currentTotalHolding: '当前总持仓',
    targetTotalHolding: '计划总持仓',
    totalHoldingHistory: '总持仓历史',
    currentStockIndustryAnalysis: '当前股票持仓行业分析',
    positionDetails: '持仓详情',
    name: '名称',
    positionQty: '持仓数量',
    positionAmount: '持仓金额',
    principal: '本金',
    totalPnl: '总盈亏',
    dailyPnl: '当日盈亏',
    totalCommission: '总佣金',
    totalStampDuty: '总印花税',
  },
  sageProductStrategy: {
    unitNav: '单位净值',
    totalNav: '累计净值',
    cumulativeGrowthRate: '累计增长率',
    strategyAccountSeparator: ' / ',
    strategyList: '策略列表',
    strategyName: '策略名称',
    accountName: '使用账户',
    strategyDays: '策略使用',
    accountPerformance: '账户累计表现',
    accountReturn: '账户累计收益',
    startTime: '开始时间',
    endTime: '结束时间',
    days: '天',
    strategyRange: '策略区间',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    selectOverlayIndicator: '选择叠加指标',
  },
  productManual: {
    nav: {
      what: '什么是极态 AI Copilot',
      value: '极态 AI 的价值',
      principles: '原理与优势',
      modules: '功能模块介绍',
      metrics: '核心指标与历史表现',
    },
    section1: {
      title: '什么是极态 AI Copilot？',
      intro: '极态 AI Copilot 是面向专业投资机构打造的端到端 AI 投研与决策辅助平台。',
      bullets: {
        fastMarketView: '帮助用户快速理解全市场的关键趋势、结构变化与未来方向。',
        findOpportunities: '帮助用户更快发现潜在的板块、行业和个股机会，并理解市场轮动。',
        optimizeStrategy: '诊断现有投资策略与组合的优势和短板，并给出优化思路。',
        xrayCompanies: '支持对上市公司进行长期横向和纵向分析，并提供短周期趋势预测。',
        explainRationale: '帮助用户快速理解趋势背后的依据与信号来源。',
      },
    },
    section2: {
      title: '极态 AI 的价值是什么？',
      p1: '第一，显著降低投研时间成本。系统可以统一汇集、整理、清洗、阅读并理解宏观、行业、公司、交易、舆情等多源信息，在此基础上输出可执行的预测与判断，提高决策效率。',
      p2: '第二，让投资决策更理性、更量化。平台中的评分、排序与预测建立在系统化算法与模型之上，不依赖人工主观录入，也不是简单拼接外部评级。',
      p3: '第三，帮助策略组合提升跨周期、跨行业、跨市场环境的适应能力，让用户更快获得底层规律与长期框架。',
    },
    section3: {
      title: '极态 AI 的原理和独特优势是什么？',
      p1: '第一，极态 AI Copilot 建立在自研基础模型之上，面向机构级投研场景做了完整应用化设计。',
      p2: '第二，不依赖手工堆砌因子和频繁调参，而是让模型在多源、跨时空的数据中自行学习底层经济与金融逻辑。',
      p3: '第三，从多个典型领域看，深度学习路线已经反复证明其在复杂问题上的上限与泛化能力。',
      p4: '趋势已经很明确，并不是传统方法完全无效，而是在更强的基础模型面前，人工堆叠规则的边际价值越来越有限。',
      p5: '真正难的不是做一个演示型应用，而是长期坚持原理驱动、自研架构、数据工程、模型训练和实盘验证的完整闭环。',
      examples: {
        stockfish: '国际象棋：Stockfish',
        alphazero: '围棋：AlphaZero',
        midjourney: '图像生成：Midjourney / Stable Diffusion',
        gpt: '语言理解与生成：GPT / Llama',
        whisper: '语音理解：Whisper',
        alphafold: '蛋白质结构预测：AlphaFold',
        alphastar: '实时策略游戏：AlphaStar',
        tesla: '自动驾驶：Tesla FSD',
      },
    },
    section4: {
      title: '极态 AI Copilot 功能模块介绍',
      intro: '当前 Copilot 主要覆盖全市场、行业与个股三个层面的投研分析与趋势预测。',
      module1: {
        title: '全市场（A 股）趋势预测模块',
      },
      module2: {
        title: '行业分析与趋势预测模块',
        sub1: '行业预测牌面与关系图',
        sub2: '行业历史趋势预测与量价图',
      },
      module3: {
        title: '个股分析与趋势预测模块',
      },
    },
    section5: {
      title: 'Copilot 核心指标介绍与历史表现评估',
      p1: '平台提供多个基于不同维度的 AI 指标，其中强弱度指标是最受关注的核心指标之一。下面展示的是历史实盘区间中的代表性表现。',
      p2: '从历史结果看，高分组与低分组之间存在明显的收益差异。无论是对冲策略、宏观配置、指数增强还是绝对收益策略，强弱度指标都能为客户的策略执行提供额外 alpha 参考。',
    },
  },
  versionHistory: {
    title: '产品更新日志',
    r3_1_0_1: {
      winRateOdds: '新增赢率和赔率计算指标',
      tradeRecordAdjust: '调整交易管理的交易记录模块',
      closedPosition: '新增清仓股票模块及每个清仓股票的全生命周期数据',
      dataDownload: '新增数据下载功能',
      strategyLab: '新增策略实验室模块',
    },
    r3_0_0: {
      customStrategy: '新增定制策略模块',
      financialProduct: '新增金融产品模块',
      tradeManagement: '新增交易管理模块',
      strategyLab: '新增策略实验室模块',
    },
    r2_0_3: {
      indexEnhanceBacktest: '新增300/500/1000/2000指数增强策略仿真',
    },
    r2_0_2: {
      multiAssetBacktest: '新增多只股债策略仿真',
      timeSelector: '个股K线走势添加时间选择器',
    },
    r2_0_1: {
      forex: '添加外汇模块',
    },
    r2_0_0: {
      sage: '添加 sage 模块',
    },
    r1_15_1: {
      commodityIndex: '添加商品指数模块',
    },
    r1_15_0: {
      bondIndex: '添加债券指数模块',
    },
    r1_14_2: {
      multiStockIntraday: '自选股添加多股分时同屏显示',
    },
    r1_14_1: {
      realtimePrice: '自选股添加实时价格显示',
    },
    r1_14_0: {
      permissionUpgrade: '权限系统升级',
      quote: '增加报价功能',
      searchHistory: '顶部搜索增加搜索历史记录功能',
      top20: '行业 Top10 增加至 Top20',
      industryFiveDays: '行业近3天涨跌幅改至5天',
    },
    r1_13_2: {
      majorIndexes: '增加国内主要指数实时量价',
      globalIndexes: '增加国际主要指数',
    },
    r1_13_1: {
      industryRealtime: '增加行业实时量价信息',
      industryIntraday: '增加行业实时分时 K 线图显示',
    },
    r1_13_0: {
      tickerRealtime: '增加个股实时量价信息',
      tickerIntraday: '增加个股实时分时 K 线图显示',
    },
    r1_12_2: {
      uiAndBugfix: '部分 UI 优化，申请试用等 bug 修复',
    },
    r1_12_1: {
      managerPerformance: '升级基金经理业绩分析',
    },
    r1_12_0: {
      managerDeepAnalysis: '深化基金经理深度分析',
    },
    r1_11_0: {
      managerFilter: '新增基金经理筛选页',
      companyFilter: '新增基金公司筛选页',
      managerDetail: '新增基金经理详情页',
      companyDetail: '新增基金公司详情页',
      companyFundList: '新增基金公司下的基金列表',
      companyManagerList: '新增基金公司下的基金经理列表',
    },
    r1_10_0: {
      tickerFilter: '新增个股筛选页',
      speed: '提升页面响应速度',
    },
    r1_9_0: {
      uiAndFundFilter: 'UI 整体优化，新增基金筛选页',
    },
    r1_8_0: {
      fundAnalysis: '新增基金分析模块',
    },
    r1_7_1: {
      balanceSheet: '个股财报模块新增资产负债表深度分析',
    },
    r1_7_0: {
      financialStatements: '新增个股财报模块，包含利润表与现金流表深度分析',
    },
    r1_6_2: {
      historyReview: '增加历史回顾功能（根据用户权限开放）',
      sortino: '全球表现、行业表现页新增 Sortino 表现',
    },
    r1_6_1: {
      eventRevamp: '个股事件模块改版，添加更多事件及分类，事件种类 30+',
      ratingDetail: '评级模块添加机构评级详情',
      shareholderDistribution: '股东模块添加股东分布图',
      scoreDelta: '预测评分增加相较前一天评分的变化值',
    },
    r1_6_0: {
      announcement: '新增个股公告事件查看模块',
      shareholderChange: '新增个股股东变化模块',
    },
    r1_5_0: {
      valuation: '新增个股估值分析模块',
      institutionRating: '新增个股机构评级分析模块',
      valuationMetric: '新增个股估值指标',
    },
    r1_4_0: {
      globalPerformance: '新增全球市场表现模块',
    },
    r1_3_0: {
      industryPerformance: '新增行业市场表现模块',
    },
    r1_2_1: {
      tickerOverlay: '个股叠加所属行业指数、市场大指数',
      indexColor: '大指叠加列表数增加颜色标识',
      adjustedPrice: '添加个股复权功能',
      industryOverlay: '行业叠加所属行业指数、市场大指数',
      industryL2: '行业预测增加 L1 相关 L2 查看列表',
      chartResponsive: '优化图表表现区域，支持自动调整',
      breadcrumbBugfix: '修复行业面包屑标签显示残留等若干 bug',
    },
    r1_2_0: {
      watchlist: '增加自选股模块',
      bugfix: '修复若干 bug',
    },
    r1_1_1: {
      hover: '行业地图更新 hover 显示内容',
      mfBugfix: '修复个股 mf 数据残留等若干 bug',
    },
    r1_1_0: {
      industryMap: '更新行业地图',
      marketOverlay: '添加全市场叠加区域开关',
      bugfix: '修复若干 bug',
    },
    r1_0_4: {
      helpMenu: '顶部导航添加帮助菜单',
      trialEnd: '个人信息添加试用结束时间',
      buttonStyle: '部分按钮样式调整',
      bugfix: '修复若干 bug',
    },
    r1_0_3: {
      keyboard: '登录、注册等模块增加键盘回车支持',
      color: '颜色调整',
      bugfix: '修复若干 bug',
    },
    r1_0_2: {
      versionHistory: '新增版本更新日志',
      industryStrength: '行业趋势预测新增强弱度、拥挤度排序图',
    },
    r1_0_1: {
      release: '极态 AI Copilot 发布',
    },
  },
  sageSeFilter: {
    unnamedPoint: '未命名点',
    jitai: '极态',
    benchmarkSuffix: '(基准)',
    intervalGrowthRate: '区间增长率',
    volatilityLabel: '波动率',
    returnLabel: '收益率',
    annualizedVolatility: '年化波动率',
    annualizedReturn: '年化收益率',
    jitaiStrategy: '极态策略',
    intercept: '截距',
    slope: '斜率',
    allTypes: '全类型',
    equityType: '股票型',
    mixedType: '混合型',
    all: '全部',
    past1Month: '近1个月',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past1Year: '近1年',
    customStrategyList: '定制策略列表',
    nav: '净值',
    cumulativeReturn: '累计收益',
    annualizedReturnShort: '年化收益',
    annualizedVolatilityShort: '年化波动',
    creator: '创建人',
    createdAt: '创建时间',
    riskReturn: '风险回报',
  },
  sageSeView: {
    performance: '业绩',
    backtest: '回测',
    strategyMonitoring: '策略监控',
    unitNav: '单位净值:',
    totalNav: '累计净值:',
    unitNavShort: '单位净值',
    totalNavShort: '累计净值',
    cumulativeGrowthRate: '累计增长率',
    benchmarkTrack: '跟踪',
    predictionDay: '预测日',
    strategyName: '策略名称',
    creator: '创建人',
    createdDate: '创建日期',
    establishmentDate: '成立日期',
    scale: '规模',
    jitaiStrategy: '极态策略',
    manager: '管理人',
    collapseMore: '收起更多<<',
    viewMore: '查看更多>>',
    basicInfo: '基本信息',
    name: '名称',
    productType: '产品类型',
    cooperationStart: '合作开始时间',
    cooperationEnd: '合作结束时间',
    custodyFeeRate: '托管费率',
    managementFeeRate: '管理费率',
    currency: '币种',
    investmentTarget: '投资目标',
    market: '市场',
    custodian: '产品托管人',
    strategyBoundaryConditions: '策略边际条件',
    strategyOptimizationObjectives: '策略优化目标',
    strategyOptimizerAttributes: '策略优化器属性',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    selectOverlayIndicator: '选择叠加指标',
    strategyTradingInfo: '策略交易信息',
    latestNav: '最新净值',
    dailyChangePct: '当日涨跌幅',
    dailyPnl: '当日盈亏',
    totalAssets: '总资产',
    availableCash: '可用资金',
    positionMarketValue: '持仓市值',
    dailyTurnoverAmount: '当日成交额',
    dailyTurnoverVolume: '当日成交量',
    turnoverRate: '换手率',
    totalPnl: '总盈亏',
    totalPnlRatio: '盈利总额比例',
    totalCommission: '总佣金',
    totalStampDuty: '总印花税',
    totalTransferFee: '总过户费',
    totalEquity: '累计权益类总计',
    totalFixedIncome: '累计固收类总计',
    totalManagementFee: '总管理费',
    totalCustodyFee: '总托管费',
    totalPerformanceReward: '总业绩报酬',
    stagePerformanceRanking: '业绩阶段排名',
    cumulativeReturn: '累计收益',
    annualizedReturn: '年化收益率',
    maxDrawdown: '最大回撤',
    annualizedVolatility: '年化波动率',
    benchmarkSuffix: '(基准)',
    oneWeek: '近1周',
    oneMonth: '近1月',
    threeMonths: '近3月',
    oneYear: '近1年',
    threeYears: '近3年',
    intervalGrowthRate: '区间增长率',
    rank: '排名',
    rankPercentile: '排名百分位',
    fundStyle: '基金风格',
    totalOpenSlip: '累计滑点（今开）',
    totalLastCloseSlip: '累计滑点（昨收）',
    dailyOpenSlip: '当日滑点（今开）',
    dailyLastCloseSlip: '当日滑点（昨收）',
    underlyingReturn: '标的收益',
    excessReturn: '超额收益',
    noData: '无数据',
  },
  sageStrategyFilter: {
    investmentPolicyList: '回测列表',
    policyAnalytics: '策略表现详情',
    policyNames: '策略名称',
    noPerformanceData: '暂无历史业绩数据',
    backtestList: '策略列表',
    performanceTrend: '业绩走势',
    strategyDetails: '策略表现分析',
    strategyCooperation: '策略合作',
    strategyCapacity: '策略容量',
    riskReturn: '风险回报',
    capacityTip: '### 策略容量\n- 基于策略特性和市场流动性，测算极态策略的容量。\n- 协助评估策略可执行性和扩展性。\n<br>',
    riskReturnTip: '### 风险回报\n- 对比极态策略的风险回报指标与不同类型公募基金经理的表现。\n- 通过定量化分析，展现策略在风险调整后的收益水平。\n<br>',
    periodOneYearShort: '近一年',
    scaleVsAlpha: '规模 VS Alpha',
    indexEnhance: '指数增强',
    industryRotation: '行业轮动',
    selectTopAndCancel: '选前{count}个 / 取消',
    totalCount: '(共{count}只)',
    searchByName: '输入名称快速定位',
    benchmarkPrefix: '基准：',
    cumulativeReturn: '累计收益',
    annualizedReturnShort: '年化收益',
    annualizedGrowthRate: '年化增长率',
    annualizedAlpha: '年化alpha',
    sharpeRatio: '夏普比率',
    maxDrawdown: '最大回撤',
    winRate: '赢率',
    payoffRatio: '赔率',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past1Year: '近1年',
    all: '全部',
    past1Month: '近1个月',
    past2Months: '近2个月',
    past4Months: '近4个月',
    unitYi: '亿',
  },
  sageStrategyView: {
    intro: '简介',
    strategyManager: '策略管理人',
    strategyTarget: '策略目标',
    strategyIntroduction: '策略简介',
    performanceTrend: '业绩走势',
    performanceOverview: '业绩表现',
    performanceOverviewTip: '全面展示策略在不同时间段的业绩表现，支持与基准的多维度对比。',
    antiFragilityStrategyAnalysis: '行业反脆弱策略分析',
    antiFragilityExAllAAnalysis: '行业去除全A影响的反脆弱分析',
    benchmarkPrefix: '基准：',
    mean: '均值',
    unitNav: '单位净值',
    accumulatedNav: '累计净值',
    cumulativeExcess: '累计超额',
    industryGrowthRate: '行业增长率',
    industryAntiFragilityGrowthRate: '行业反脆弱增长率',
    industryExMarketGrowthRate: '行业去除市场的增长率',
    industryExMarketAntiFragilityGrowthRate: '行业去除市场影响的反脆弱增长率',
    industryIndexGrowth: '行业指数增长',
    industryIndexExAllA: '行业指数-去除全A影响',
    industryAntiFragilityExAllA: '行业反脆弱-去除全A影响',
    industryAntiFragilityEnhancedExAllA: '行业反脆弱-增强-去除全A影响',
    industryAntiFragility: '行业反脆弱',
    industryAntiFragilityEnhanced: '行业反脆弱-增强',
    unnamedPoint: '未命名点',
    extremeStateKeyword: '极态',
    volatility: '波动率',
    returnRate: '收益率',
    intercept: '截距',
    slope: '斜率',
    all: '全部',
    past1Month: '近1个月',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past1Year: '近1年',
  },
//
//   // SEBackTestView.vue
//   SEBackTestView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '单位净值:',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '极态策略',
//     xx: '管理人',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '名称',
//     xx: '产品类型',
//     xx: '合作开始时间',
//     xx: '合作结束时间',
//     xx: '托管费率',
//     xx: '管理费率',
//     xx: '币种',
//     xx: '投资目标',
//     xx: '市场',
//     xx: '产品托管人',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '无数据',
//     xx: '业绩阶段排名',
//     xx: '近1周',
//     xx: '近1月',
//     xx: '近3月',
//     xx: '近1年',
//     xx: '近3年',
//     xx: '年化收益率',
//     xx: '区间增长率',
//     xx: '排名',
//     xx: '排名百分位',
//     xx: '基金风格',
//
//   },
//
//
//   // SEFilter.vue
//   SEFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '定制策略列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大波动',
//     xx: '创建人',
//     xx: '创建时间',
//     xx: '风险回报'
//   },
//
//   // SEView.vue
//   SEView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '业绩',
//     xx: '策略监控',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '跟踪',
//     xx: '策略名称',
//     xx: '创建人',
//     xx: '创建日期',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '策略边际条件',
//     xx: '策略优化目标',
//     xx: '策略优化器属性',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略交易信息',
//     xx: '最新净值',
//     xx: '累计净值',
//     xx: '当日涨跌幅',
//     xx: '当日盈亏',
//     xx: '总资产',
//     xx: '可用资金',
//     xx: '持仓市值',
//     xx: '当日成交额',
//     xx: '当日成交量',
//     xx: '换手率',
//     xx: '总盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//     xx: '总过户费',
//     xx: '业绩阶段排名',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益率',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '年化波动率',
//     xx: '(基准)'
//   },
//
//   // StrategyFilter.vue
//   StrategyFilter: {
//     tips1: '### 回测列表 \n - 按资产大类对回测结果进行分组，方便分类查看。\n - 提供不同预测时间窗口的切换功能，用以观察在不同时间窗口内的回测表现。 \n - 展示策略累计业绩表现，支持与基准的多维度对比。',
//     tips2: '### 回测走势 \n - 支持叠加不同指数进行对比，直观了解策略回测的相对表现。\n - 可视化展现回测期间的策略回报走势，便于分析趋势与波动。',
//     tips3: '### 策略详情 \n - 提供不同时间段内策略的收益和风险指标的详细信息。\n - 便于了解策略在各种市场环境下的表现特性。',
//     tips4: '### 策略容量 \n - 基于策略特性和市场流动性，测算极态策略的容量。 \n - 协助评估策略可执行性和扩展性。',
//     tips5: '### 风险回报 \n - 对比极态策略的风险回报指标与不同类型公募基金经理的表现 \n - 通过定量化分析，展现策略在风险调整后的收益水平。',
//     xx: '天',
//     xx: '累计增长率',
//     xx: '亿',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '极态',
//     xx: '未命名点',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '出错',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '回测列表',
//     xx: '股债平衡',
//     xx: '行业轮动',
//     xx: '指数增强',
//     xx: '选前',
//     xx: '个 / 取消',
//     xx: '共',
//     xx: '只',
//     xx: '输入名称快速定位',
//     xx: '基准',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '策略合作',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略表现详情',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '策略名称',
//     xx: '基准：',
//     xx: '区间增长率',
//     xx: '年化增长率',
//     xx: '年化alpha',
//     xx: '夏普比率',
//     xx: '年化波动率',
//     xx: '最大回撤',
//     xx: '策略容量',
//     xx: '风险回报',
//     xx: '(近一年)',
//
//   },
//
//   // StrategyPFilter.vue
//   StrategyPFilter: {
//     tips1: '### 回测列表 \n - 按资产大类对回测结果进行分组，方便分类查看。\n - 提供不同预测时间窗口的切换功能，用以观察在不同时间窗口内的回测表现。\n - 展示策略累计业绩表现，支持与基准的多维度对比。',
//     tips2: '### 回测走势 \n - 支持叠加不同指数进行对比，直观了解策略回测的相对表现。 \n - 可视化展现回测期间的策略回报走势，便于分析趋势与波动。',
//     tips3: '### 策略详情 \n - 提供不同时间段内策略的收益和风险指标的详细信息。 \n - 便于了解策略在各种市场环境下的表现特性。',
//     tips4: '### 策略容量 \n - 基于策略特性和市场流动性，测算极态策略的容量。\n - 协助评估策略可执行性和扩展性。',
//     tips5: '### 风险回报 \n - 对比极态策略的风险回报指标与不同类型公募基金经理的表现 \n - 通过定量化分析，展现策略在风险调整后的收益水平。',
//     xx: '累计增长率',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '截距',
//     xx: '斜率',
//     xx: '出错',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '回测列表',
//     xx: '选前',
//     xx: '个 / 取消',
//     xx: '共',
//     xx: '只',
//     xx: '输入名称快速定位',
//     xx: '基准',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '累计收益',
//     xx: '(基准)',
//     xx: '年化收益',
//     xx: '最大回撤',
//     xx: '策略合作',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '策略表现详情',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '策略名称',
//     xx: '基准',
//     xx: '区间增长率',
//     xx: '年化增长率',
//     xx: '年化alpha',
//     xx: '夏普比率',
//     xx: '年化波动率',
//     xx: '最大回撤',
//     xx: '策略容量',
//     xx: '风险回报',
//     xx: '(近一年)',
//   },
//
//   // strategyPView.vue
//   strategyPView: {
//     xx: '### 业绩表现 \n - 全面展示策略在不同时间段的业绩表现，支持与基准的多维度对比。',
//     xx: '均值',
//     xx: '换手率',
//     xx: '累计超额',
//     xx: '行业指数增长',
//     xx: '行业指数-去除全A影响',
//     xx: '行业反脆弱-去除全A影响',
//     xx: '行业反脆弱-增强-去除全A影响',
//     xx: '行业反脆弱',
//     xx: '行业反脆弱-增强',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '简介',
//     xx: '策略名称',
//     xx: '策略管理人',
//     xx: '策略简介',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '基准',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '无数据',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '年化波动率',
//     xx: '行业反脆弱策略分析',
//     xx: '行业去除全A影响的反脆弱分析',
//
//   },
//
//   // strategyView.vue
//   strategyView:{
//     tips6: '### 业绩表现 \n - 全面展示策略在不同时间段的业绩表现，支持与基准的多维度对比。',
//     xx: '均值',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '换手率',
//     xx: '累计超额',
//     xx: '行业增长率',
//     xx: '行业反脆弱增长率',
//     xx: '行业去除市场的增长率',
//     xx: '行业去除市场影响的反脆弱的增长率',
//     xx: '行业指数增长',
//     xx: '行业指数-去除全A影响',
//     xx: '行业反脆弱-去除全A影响',
//     xx: '行业反脆弱-增强-去除全A影响',
//     xx: '行业反脆弱',
//     xx: '行业反脆弱-增强',
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '截距',
//     xx: '斜率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '业绩',
//     xx: '简介',
//     xx: '策略名称',
//     xx: '策略管理人',
//     xx: '策略简介',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '业绩走势',
//     xx: '累计增长率',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '交易信息',
//     xx: '成交额',
//     xx: '换手率',
//     xx: '最新净值',
//     xx: '当日涨跌幅',
//     xx: '当日涨跌金额',
//     xx: '累计净值',
//     xx: '累计权益类总计',
//     xx: '累计固收类总计',
//     xx: '持有市值',
//     xx: '可用余额',
//     xx: '盈利总额',
//     xx: '盈利总额比例',
//     xx: '总交易佣金',
//     xx: '总印花税',
//     xx: '总管理费',
//     xx: '总托管费',
//     xx: '总业绩报酬',
//     xx: '累计滑点(今开)',
//     xx: '累计滑点(昨收)',
//     xx: '当日滑点(今开)',
//     xx: '当日滑点(昨收)',
//     xx: '标的收益',
//     xx: '超额收益',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '最大回撤',
//     xx: '(基准)',
//     xx: '年化波动率',
//     xx: '行业反脆弱策略分析',
//     xx: '行业去除全A影响的反脆弱分析',
//   },
//
//   // TradeFilter.vue
//   TradeFilter: {
//     xx: '未命名点',
//     xx: '极态',
//     xx: '波动率',
//     xx: '收益率',
//     xx: '年化波动率',
//     xx: '年化收益率',
//     xx: '极态策略',
//     xx: '全类型',
//     xx: '股票型',
//     xx: '混合型',
//     xx: '账户列表',
//     xx: '净值',
//     xx: '累计收益',
//     xx: '年化收益',
//     xx: '最大波动',
//     xx: '当前资产',
//     xx: '当前市值',
//     xx: '可用资金',
//     xx: '当日盈亏',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易量',
//     xx: '所属产品：',
//     xx: '创建时间：',
//     xx: '模拟盘',
//     xx: '实盘',
//     xx: '风险回报'
//   },
//
//   // TradeView.vue
//   TradeView: {
//     xx: '预测日',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '累计增长率',
//     xx: '全部',
//     xx: '近1个月',
//     xx: '近3个月',
//     xx: '近6个月',
//     xx: '近1年',
//     xx: '单位净值',
//     xx: '累计净值',
//     xx: '跟踪',
//     xx: '成立日期',
//     xx: '规模',
//     xx: '券商名称',
//     xx: '策略名称',
//     xx: '收起更多<<',
//     xx: '查看更多>>',
//     xx: '基本信息',
//     xx: '账户名称',
//     xx: '账户类型',
//     xx: '模拟',
//     xx: '实盘',
//     xx: '所属产品',
//     xx: '市场类型',
//     xx: '币种',
//     xx: '佣金税率',
//     xx: '印花税率',
//     xx: '过户税率',
//     xx: '账户状态',
//     xx: '可用',
//     xx: '不可用',
//     xx: '累计增长率',
//     xx: '累计净值',
//     xx: '单位净值',
//     xx: '至',
//     xx: '开始日期',
//     xx: '结束日期',
//     xx: '选择叠加指标',
//     xx: '账户交易信息',
//     xx: '总资产',
//     xx: '当前市值',
//     xx: '可用现金',
//     xx: '当日买入量',
//     xx: '当日卖出量',
//     xx: '当日交易额',
//     xx: '当日盈亏',
//     xx: '总盈亏',
//     xx: '总佣金',
//     xx: '总印花税',
//     xx: '最新净值',
//     xx: '累计净值',
//     xx: '业绩表现',
//     xx: '累计收益',
//     xx: '累计收益',
//     xx: '年化收益率',
//     xx: '(基准)',
//     xx: '最大回撤',
//     xx: '年化波动率',
//
//   },
//
//   // mainHeader.vue
//   mainHeader: {
//     xx: '请输入股票、行业、基金名称或代码',
//     xx: '搜索历史',
//     xx: '历史',
//     xx: '选择时间',
//     xx: '更新时间',
//     xx: '官网',
//     xx: '帮助',
//     xx: '报价',
//     xx: '',
//   },
//
//
//   // registerRaw.vue
//   registerRaw: {
//     tip1: `
// ## 北京极态科技有限公司风险提示和法律声明
// **风险提示：** 用户应充分了解金融投资风险，并认识到所有投资决策均需独立作出。我们的服务旨在提供参考信息，不构成任何形式的投资建议、买卖邀约或招揽。我们不负责审查或确认用户的具体投资目的、财务状况或需求。投资者应独立评估我们服务中的信息和建议，并根据自身情况作出投资决策。对于依据我们服务内容所做的任何投资决策及其产生的后果，公司不承担任何责任。
// **法律声明：** 北京极态科技有限公司（以下简称“我们”）为用户提供的软件产品或服务，是基于公开大数据并结合自身模型进行综合技术处理，从而进行系统的整理、加工、创新、运算和集成构建而成的模型、方法、推演或分析。旨在为投资者提供由行情数据、趋势分析、热点研判、选股模型、资讯解读或研报整理等具有高附加值的投资辅助系统产品或服务，以帮助用户在投资过程中进行理性投资、自主决策与风险控制。
// 我们通过认为可靠的公开资料获取信息，并基于现有技术进行数据加工和分析。尽管我们致力于提供准确和完整的信息，但我们不对所提供信息的准确性、时效性或完整性作出任何形式的保证或承诺。用户应明白所有预测和推荐均存在不确定性，过往表现不预示未来结果。服务可能因技术限制、数据源偏差、计算误差或市场极端情况等因素而受限。我们鼓励用户在使用我们的服务时保持谨慎，并自主进行决策且独立承担风险。
// 对于使用或依赖我们服务所造成的直接或间接损失，我们不承担任何法律责任。
// 请注意，使用我们的服务即表示您已阅读、理解并同意本免责声明的所有条款！本声明的解释权归北京极态科技有限公司所有。
// **联系方式：** 如有任何疑问或需要进一步信息，请通过inquiry@jitai.ai与我们联系。若发现任何个人或机构冒用我们名义提供服务，敬请向我们报告。
//     `,
//     tip2:  `
// ## 《北京极态科技隐私保护指引》
// 我们希望我们的AI模型了解的是整个世界，而不是个人隐私。我们不会积极寻找个人信息来训练我们的模型，也不会使用互联网上的公共信息来建立个人资料，更不会出售用户数据。我们努力做到减少我们训练数据集中的个人信息量；训练模型拒绝请求个人隐私信息的要求；最小化我们的模型可能生成包含私人个人信息的响应/报告的可能性。
//
// 引言
// 本隐私政策适用于北京极态科技（以下称“极态科技”或“我们”）平台各产品和服务及公司旗下所有产品和服务。如某款极态科技产品有单独的隐私政策则该产品的隐私政策将优先适用。该产品隐私政策未涵盖的内容，以本隐私政策内容为准，该产品隐私政策与本隐私政策有冲突的内容，以产品隐私政策为准。
//
// 本隐私政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。除非法律、行政法规另有规定，针对我们如何处理您的个人信息，您享有知情权和决定权，有权限制或者拒绝我们或其他方对您的个人信息进行处理；同时，您有权要求我们对我们向您提供的个人信息处理规则进行解释说明。
//
// 本隐私政策将帮助您了解以下内容：
// 一、 我们如何收集和使用您的个人信息
// 二、 我们如何使用 Cookie 和同类技术
// 三、 我们如何共享、转让、公开披露您的个人信息
// 四、 我们如何保存及保护您的个人信息
// 五、 您的权利
// 六、 第三方服务
// 七、 您的个人信息如何跨境转移
// 八、 国际用户
// 九、 本隐私政策的修订
// 十、 如何联系我们
//
//
// 一、我们如何收集和使用您的个人信息
// 我们会严格按照法律法规要求和我们向您提供的个人信息处理规则来处理您的个人信息。我们一般会基于以下目的收集和使用您的个人信息：
//
// 1. 为用户注册/登录所需的个人信息处理活动
// 极态科技平台产品和服务适用统一的账号体系，您注册账号时须至少向我们提供手机号。如果您仅需使用浏览、搜索等非登录状态可使用的基本服务，您有权选择不予注册成为我们的用户并不提供上述信息。
//
// 为符合现行法律法规的强制性要求或使用特定产品功能所必需，当您在使用某些我们特定的产品且需要填写手机号等账号注册时已经提供的信息时，为了方便您的使用，我们可能会默认显示您极态科技账号绑定的手机号等相关信息，您可以根据相应产品功能进行修改。为了您可基于同一账号在极态科技产品中享有一致性的体验，您在极态科技某一产品中账号关注及被关注记录可能会被记录在极态科技账号下，并在您登录其他相关产品时进行展示，此项服务基于“汇聚融合”条款实现，但并不视为极态科技公司的必然义务。
//
// 注册信息除了用于识别您的身份之外，我们也会将其用于其他与服务相关的功能场景中，例如我们会利用收集的信息（例如您的手机号码、电子邮件地址）直接与您沟通或互动；如果我们或使用极态科技账号体系的公司检测到可疑活动（例如尝试从不同于平常的位置登录您的极态科技账号）时，可能会向您发送通知；或者，我们或使用极态科技账号体系的公司可能会与您联系，让您了解为您提供的服务即将发生的变化或改进，邀请您参加新产品的体验等。
//
// 为了确保您的账号及财产安全，进行风险控制和防御，当您注册/登录账号时，我们会收集您的设备信息以及与注册/登录环境相关的信息(包括国际移动设备身份码IMEI、广告标识符IDFA、集成电路卡识别码ICCID、设备名称、设备型号、操作系统版本、WIFI信息BSSID、SSID、IP地址信息)。
// 通信信息：如果您与我们进行通信，我们将收集您的姓名、联系信息和您发送的任何消息的内容（“通信信息”）。 社交媒体信息：我们在社交媒体网站上拥有页面，如微信公众号或其他社交媒体。当您与我们的社交媒体页面互动时，我们将收集您选择向我们提供的个人信息，例如您的联系方式（统称为“社交信息”）。此外，托管我们社交媒体页面的公司可能会向我们提供有关我们社交媒体活动的汇总信息和分析信息。 您提供的其他信息：我们收集您可能向我们提供的其他信息，例如当您参加我们的活动或调查，或向我们提供信息以建立您的身份时（统称为“您提供的其他信息”）。从您使用服务中自动收到的个人信息：当您访问、使用或与服务进行交互时，我们将收到以下关于您的访问、使用或交互的信息（“技术信息”）。
//
// 为了满足法律法规的强制性要求、出于提供产品或服务所必需或者基于您对增强账号保护级别的需求，在您使用某些服务时或您有进一步需求时，您需提供您的真实姓名、身份证号、人脸信息完成账号实名认证。如您不进行实名认证，可能会影响到您使用需要经过实名认证才能使用的业务功能。为了验证您提供信息的准确性和完整性，或保障您的账号安全，我们可能会将您向极态科技提供的实名信息与法律法规允许的机构或政府机关授权的机构所保存的您的对应信息进行比对核验。为了保障您的账号安全，确保账号实名一致性同时为您提供便捷的服务，您在极态科技账号完成实名认证后，上述实名信息将作为该账号在所有接入极态科技账号服务的产品中的通用认证信息，为了保障您的个人信息安全，请勿将您的账号转让、租借他人使用。如果超出上述处理范围，除法律法规另有规定外，个人信息处理者将按照法律法规的要求另行征得您的同意。
//
// 2. 为提供服务所需的个人信息处理活动
// 基于您选择的不同服务内容，在提供服务过程中，我们可能会收集关于您使用产品和/或服务（包括使用方式）过程中的相关个人信息以达到服务目的。其中，当部分服务为极态科技及第三方共同为您提供时，出于为您提供服务所必需，我们和第三方可能会共同处理您的个人信息。为提供服务所需的个人信息的类别和内容具体以您所启用的服务内容和功能为准，一般包括：
//
// 产品使用信息
// 我们可能会记录您在使用我们的产品和/或服务时主动提供、留存的信息。例如您主动发布、反馈、评论、上传的文字图片、音视频、金融账户信息、持仓信息、投资策略信息等，您参与其他产品运营活动时提交的联系方式信息。
//
// 设备信息
// 可能包括您终端设备的设备属性信息（例如最终用户的硬件型号，操作系统版本，设备配置，国际移动设备身份码IMEI、国际移动用户识别码IMSI、网络设备硬件地址MAC、广告标识符IDFA、供应商标识符IDFV、移动设备识别码MEID、匿名设备标识符OAID 、集成电路卡识别码ICCID 、Android ID、硬件序列号等设备标识符）、设备连接信息（例如浏览器的类型、电信运营商、使用的语言、WIFI信息）以及设备状态信息（例如设备应用安装列表、设备传感器信息）。
//
// 日志信息
// 当您使用极态科技平台产品和服务时，我们的服务器会自动记录一些信息，例如您对我们的产品和/或服务的使用情况、IP地址、所访问服务的URL、浏览器的类型和使用的语言、下载、安装或使用移动应用和软件的信息、与通讯软件通讯的信息以及访问服务的日期、时间、时长等。
//
// 3. 为了实现自动化决策和个性化推荐所需的个人信息处理活动
//
// 汇聚融合
// 在极态科技平台产品和服务中，在确保个人信息均处于同一业务实体的控制之下且不改变数据安全保障能力和管理水平的情况下，您同意我们将通过我们自身或受托方技术对您在极态科技平台产品和服务中主动或被动提供的个人信息进行汇聚融合、识别分析、数据画像或进一步加工，并形成能够反映您的投资行为习惯、经济状况、信用状况、投资偏好等身份特征的标签信息（以下简称“标签信息”），我们会将标签信息用于具体的场景和目的中进行自动化决策，向您推送个性化展示的信息和/或商业营销信息，我们会保障信息在汇聚融合后的安全处理。为了能给您提供一致的服务，我们可能会在取得您的授权后将您的设备信息或电话号码与您的极态科技账号相关联，对于同一账号在不同设备上主动或被动提供的个人信息进行关联和汇聚。
//
// 个性化推荐
// 我们可能基于设备信息、日志信息、标签信息、位置信息等要素通过计算机算法模型自动计算、综合分析、预测您可能感兴趣的信息内容或功能服务，以进行个性化推荐活动。在个性化推荐服务中，我们将同时向您提供便捷的拒绝方式等以便您进行控制。不同产品或服务的个性化推荐服务应用场景、运行机制以及实现控制的方式可能不同，具体请见具体产品或服务的隐私政策相关描述。
//
// 自动化决策
// 自动化决策活动同样依赖于我们对标签信息的处理。自动化决策可能用于不同的具体场景，部分以自动化决策方式作出的决定可能对您的权益产生显著影响；在此情况下，您有权通过具体产品或服务的隐私政策描述的联系方式要求我们做出说明，您也有权拒绝仅以自动化决策的方式作出的决定。我们将提供适当的救济方式保障您的合法权利，例如向您说明自动化决策的逻辑及对您产生的相关影响，或引入人工审核复核自动化决策结果的正确性。
//
// 信息搜索
// 为了持续优化提升信息搜索结果及效果以满足您的搜索需求，当您输入搜索词后，我们会从相关性、时效性、权威性、过往搜索历史、现有资产配置、策略信息和质量等维度寻找更匹配您需求的搜索结果集合，并在搜索结果页向您进行排序展示。
//
// 4. 为您提供安全保障
// 为提高您使用我们与极态科技关联方、合作方提供的产品和服务的安全性，我们可能使用您的信息用于身份验证、客户服务、安全防范、诈骗监测等，以预防、发现和/或调查欺诈、危害安全及其它非法或违反与我们的协议、政策或规则的行为，以保护您、我们的其他用户、我们或极态科技关联方、合作方及社会公众的合法权益。为了防范和抵制违法信息及不良信息的发布及传播，保障您使用我们的产品和服务时的内容安全，我们通过计算机算法模型自动计算、综合分析网络信息内容，如发现网络信息内容包含违法信息及不良信息，则立即停止传输并采取处置措施。
//
// 5. 改善我们的产品和服务，并开展内部审计、数据分析和研究
// 我们可能会使用收集的信息来改进我们的产品和服务，并进行必要的业务运营和分析研究，例如运营产品或提供服务，评估、维护和改进产品和服务的性能，开发新的产品和服务、提供客户支持等。
//
// 为改进我们及极态科技关联方、合作方的产品和服务，我们也可能会对产品使用情况进行统计和分析。同时，极态科技可能会与公众共享这些统计信息，以展示我们服务的整体使用趋势，但这些统计信息将不会包含您的任何身份识别信息。
//
// 6. 改进产品服务安全性和个性化程度
// 为改进产品服务的安全性和个性化程度等合理需要，我们可能按照法律法规的规定或基于您的有效授权从极态科技平台各产品和服务提供方、极态科技关联方、合作方、合作伙伴、其他受信任的第三方供应商处接收您的个人信息及其他信息，并可能对相关信息进行加工使用。我们将事先要求个人信息提供方说明个人信息来源，并对其个人信息来源的合法性进行确认，并确保我们处理您的个人信息有足够的合法性基础，例如，如果我们基于同意处理您的个人信息，而开展业务所需进行的个人信息处理活动超出已获得的授权同意范围的，我们将在获取个人信息后的合理期限内或处理个人信息前，征得您的同意，或通过个人信息提供方征得您的同意。
//
// 7. 极态科技深度学习大模型的训练和研发
// 为了更好的向您提供服务和精准的预测结果，我们将对于您在使用产品过程中产生的大数据做个人信息脱敏处理，并在脱敏后统一用于训练极态科技一个或多个大模型。除非获得您的单独授权之外，您的个人隐私信息（例如手机号码、姓名、住所等标识类信息）将通过技术手段脱敏，确保在训练过程中您的个人隐私信息不会被模型“明码学习”。为确保我们的产品可以更好的服务最多的用户，极态科技大模型在训练过程中不会针对特定对象、个人或组织进行针对性的策略训练，并尽可能减少训练中的歧视和偏差问题。
//
// 8. 其他处理目的
// 我们可能出于提供不同产品或服务所需，为实现其他特定处理目的而开展个人信息处理活动，您可以参考具体极态科技产品的隐私政策，或者联系我们为您说明。
//
// 二、我们如何使用 Cookie 和同类技术
// 为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。Cookie主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。
//
// 当您使用极态科技的产品和服务时，我们会向您的设备发送一个或多个Cookie或匿名标识符。当您与我们提供给合作伙伴的服务（例如广告和/或推广服务，以及可能显示在其他网站上的由极态科技提供的服务功能）进行交互时，我们允许Cookie（或者其他匿名标识符）将您访问、使用产品或服务的相关信息发送给极态科技的服务器。
//
// 我们不会将 Cookie 用于本隐私政策或具体产品隐私政策所述目的之外的用途。您可根据自己的偏好管理或删除 Cookie。您可以通过根据具体产品隐私政策的说明限制极态科技公司对Cookie的使用。
//
// 我们可能会出于以下目的使用个人信息
// 提供、管理、维护和/或分析服务； 改进我们的服务并进行研究； 与您沟通；包括向您发送有关我们的服务和活动的信息； 开发新的计划和服务； 防止欺诈、犯罪活动或滥用我们的服务，并保护我们的IT系统、架构和网络的安全； 进行业务转让； 遵守法律义务和法律程序，并保护我们的权利、隐私、安全或财产，以及我们的关联公司、您或其他第三方的权利、隐私、安全或财产。
//
// 聚合或去标识化信息。我们可能会聚合或去标识化个人信息，以使其不再用于识别您，并使用此类信息来分析我们服务的有效性，改进和增加我们服务的功能，进行研究和进行其他类似的目的。此外，我们可能会不时分析我们服务的用户的一般行为和特征，并与第三方分享一般用户统计信息，发布此类聚合信息或使此类聚合信息普遍可用。我们可能会通过服务、通过cookie以及通过本隐私政策中描述的其他方式收集聚合信息。我们将以匿名或去标识化形式维护和使用去标识化信息，并不会试图重新识别信息，除非法律要求。
//
// 如上所述，我们可能会使用您提供给我们的内容来改进我们的服务，例如训练支持极态科技的大经济模型。
//
// 三、我们如何共享、转让、公开披露您的个人信息
// 1. 共享
// 我们会以高度的勤勉义务对待您的信息。除法律法规明确规定的其他情形外，未经您单独同意，我们不会向除极态科技外的任何公司、组织和个人共享您的信息。我们的某些服务由授权合作伙伴提供，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享与第三方提供服务相关的个人信息。除另行获得您的授权或法律法规另有规定，我们的合作伙伴无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会签署严格的协议，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理共享的个人信息。
//
// 在某些情况下，除非法律要求，否则我们可能会向第三方提供您的个人信息，而无需进一步通知您。
//
// 供应商和服务提供商
// 为了帮助我们满足业务运营需求并执行某些服务和功能，我们可能会向供应商和服务提供商提供个人信息，包括提供托管服务、客户服务供应商、云服务、电子邮件通信软件、网络分析服务和其他信息技术提供商等。根据我们的指示，这些方将仅在履行其对我们的职责过程中访问、处理或存储个人信息。
//
// 关联方或同一账号体系使用方
// 我们与我们的关联方或同一账号体系使用方之间具备高度一致的数据安全保障措施和管理水平。为提高您使用产品的安全性和便利性，并具备一致性的服务体验，在遵循法律要求的前提下，我们会在关联方或同一账号体系使用方之间共享您的个人信息。
//
// 关联公司
// 我们可能会向我们的关联公司披露个人信息，即控制极态科技的实体、受极态科技控制的实体，或与极态科技共同受控制的实体。我们的关联公司可能会以与本隐私政策一致的方式使用我们分享的个人信息。
//
// 2. 委托处理与共同处理
// 为了更好地为您提供服务，我们可能委托第三方合作伙伴处理您的个人信息。我们仅会出于合法、正当、必要、特定、明确的目的委托第三方合作伙伴处理您的信息。我们会严格限制受托方的信息处理目的并要求受托方采取充分的数据安全保障手段。如果第三方合作伙伴将您的信息用于我们未委托的用途，其将另行征得您的同意。未经您有效授权，我们不会将可以直接识别您个人身份的信息委托第三方合作伙伴处理。如您主动为特定第三方合作伙伴留下您的联系方式、地址信息等个人信息以供其与您取得联系，其将直接处理您的个人信息。
// 在共同处理场景下，我们同样会按照法律法规要求与合作方签署符合法律法规要求的相关协议，并履行相关个人信息保护义务。
//
// 3. 转让
// 我们不会将您的个人信息转让给除极态科技及其关联公司外的任何公司、组织和个人，但以下情形除外：
// （1）事先获得您的明确授权或同意；
// （2）满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；
// （3）如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性、向您告知接收方的名称或姓名和联系方式，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
//
// 4. 公开披露
// 我们仅会在以下情形下，公开披露您的个人信息：
// （1） 获得您的单独同意；
// （2） 基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。
//
// 5. 共享、转让、公开披露个人信息时事先征得授权同意的例外
// 在以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
// （1） 为履行法定职责或者法定义务所必需（例如与国家安全、国防安全、刑事侦查、起诉、审判和判决执行等直接相关的法定义务）；
// （2） 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
// （3） 在合理的范围内处理您自行公开或者其他已经合法公开的您的个人信息（如合法的新闻报道、政府信息公开等渠道）；
// （4） 根据个人信息主体要求签订和履行合同所必需的；
// （5） 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
// （6） 法律法规及国家标准规定的其他情形。
//
// 根据法律规定，共享、转让经匿名化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
//
// 6.业务转让
// 如果我们涉及战略交易、重组、破产、接管或将服务转移到另一提供商（统称为“交易”），则您的个人信息和其他信息可能会在与交易有关的尽职调查过程中向交易对方和协助交易的其他人员披露，并作为交易的一部分与其他资产一起转移到继任者或关联公司。
//
// 7.法律要求
// 我们可能会与政府机关、行业同行或其他第三方分享您的个人信息，包括您与我们服务的互动信息，（i）如果法律要求我们这样做，或者在诚信相信这样的行动是必要的，以遵守法律义务，（ii）为了保护和捍卫我们的权利或财产，（iii）如果我们确定，凭我们的唯一判断，存在违反我们的条款、政策或法律的行为；（iv）检测或预防欺诈或其他非法活动；（v）保护我们产品、员工或用户，或公众的安全、安全性和完整性，或（vi）保护免受法律责任。
//
// 8.业务帐户管理员
// 当您申请加入极态科技商业帐户时，该帐户的管理员可能会访问和管理您的极态科技帐户。此外，如果您使用属于您的雇主或其他组织的电子邮件地址创建帐户，我们可能会与您的雇主或组织共享您拥有极态科技帐户的事实以及某些帐户信息，例如您的电子邮件地址，以便使您能够添加到他们的商业帐户。
//
// 四、我们如何保存及保护您的个人信息
// 1. 保存期限
// 我们将在提供服务所需的期限内保存您的个人信息，但法律法规对保存期限另有规定、您同意留存更长的期限、保证服务的安全与质量、实现争议解决目的、技术上难以实现等情况下，在前述保存期限到期后，我们将依法、依约或在合理范围内延长保存期限。在超出保存期限后，我们将根据法律规定删除您的个人信息或进行匿名化处理。
//
// 2. 保存地域
// 您的个人信息一般储存于中华人民共和国境内。如因部分产品或服务涉及跨境等原因，我们需要向境外提供您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
//
// 3. 安全措施
// （1） 我们会以业界成熟的安全标准和规范收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。
// （2） 我们非常重视信息安全。我们成立了专责团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
// （3） 我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们部署了访问控制机制，对处理个人信息的员工进行身份认证及权限控制，并会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。
// （4） 我们提醒您注意，互联网并非绝对安全的环境，当您通过电子邮件、短信等与其他用户交互信息时，不确定第三方软件对信息的传递是否完全加密，请注意确保您个人信息的安全，我们建议您不要通过此类方式发送个人信息，以免个人信息泄露。请您使用复杂密码，并不要随意将您的极态科技账号和密码提供给他人，以协助我们保证您的账号以及个人信息安全。
//
// 4. 安全事件通知
// （1） 我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。
// （2） 个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由安全部、政府关系部、法务部等多个部门组成应急响应小组，在最短时间内追溯原因并减少损失。
// （3） 在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
//
// 五、您的权利
// 按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
//
// 1. 查阅和复制您的个人信息
//
// 您有权访问和复制您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问和复制您的个人信息：
//
// 账号信息：您可以随时登录www.jitai.info ，访问或编辑您的账户中的个人资料信息、更改您的密码、进行账号关联或身份认证等。如果您无法通过上述链接访问该等个人信息，您可以通过个人信息保护问题反馈，随时与我们联系。
//
// 对于您在使用我们的产品和服务过程中产生的其他个人信息，如果您想行使查阅权、复制权，可参考具体产品隐私政策或通过个人信息保护问题反馈与我们联系。为保障安全，我们可能在您行使查阅权、复制权前对您的身份进行验证。
//
// 2. 更正或补充您的个人信息
// 您发现我们处理的关于您的个人信息有不准确或不完整时，您有权对不准确或不完整的信息作出更正或补充，您可以参考具体产品隐私政策或通过个人信息保护问题反馈随时与我们联系。为保障安全，我们可能在您行使更正权、补充权前对您的身份进行验证。
//
// 3. 删除您的个人信息
// 在以下情形中，您可以通过具体产品隐私政策的说明或通过个人信息保护问题反馈随时与我们联系，向我们提出删除个人信息的请求：
// （1） 处理目的已实现、无法实现或者为实现处理目的不再必要；
// （2） 我们停止提供产品或者服务，或者保存期限已届满；
// （3） 您撤回同意；
// （4） 我们违反法律、行政法规或者违反约定处理个人信息；
// （5） 法律、行政法规规定的其他情形。
// 当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
//
// 我们在产品设计的过程中及最终的呈现和用户体验环节，将尽可能地为您控制个人信息提供更为便捷的方式。由于不同产品的功能服务不同，因此为您提供的个人信息控制方式及设计可能不同，请您在使用具体产品时阅读相关产品隐私政策进一步了解。
//
// 4. 撤回同意
// 每个业务功能需要一些基本的个人信息才能得以完成。对于我们基于您的同意处理的个人信息，您可以随时给予或收回您的授权同意。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
//
// 5. 注销您的账号
// 您随时可注销此前注册的账号。您可以通过联系inquiry@jitai.ai申请注销您的极态科技账号。一旦您注销极态科技账号，将无法使用极态科技全线用户产品和服务（部分无需注册/登录机台账号即可使用的服务功能除外），因此请您谨慎操作。我们为了保护您或他人的合法权益会结合您对极态科技各产品和服务的使用情况判断是否支持您的注销请求。例如您的网盘中还存有资料，则我们不会立即支持您的请求。
//
// 6. 提前获知产品和服务停止运营
// 极态科技愿一直陪伴您，若因特殊原因导致极态科技平台产品和服务被迫停止运营，我们将按照法律法规要求在产品和/或服务的主页面或站内信或向您发送电子邮件或其他合适的能触达您的方式通知您，并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。
//
// 7. 个人信息可携权
// 在符合国家相关法律法规及网信部门规定的条件下，如您请求将个人信息转移至其指定的个人信息处理者，我们将按照相关规定的要求提供转移的途径。
//
// 8. 响应您的上述请求
// 为保障安全，您行使您的上述权利需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
//
// 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
// 在以下情形中，按照法律法规要求，我们将无法响应您的上述请求：
// （1） 与国家安全、国防安全直接相关的；
// （2） 与公共安全、公共卫生、重大公共利益直接相关的；
// （3） 与刑事侦查、起诉、审判和执行判决等直接相关的；
// （4） 我们有充分证据表明您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；
// （5） 响应个人信息主体的请求将导致您或其他个人、组织的合法权益受到严重损害的；
// （6） 涉及商业秘密的；
// （7） 与我们履行法律法规规定的义务相关的；
// （8） 法律法规规定的其他情形。
//
// 我们采取商业上合理的技术、管理和组织措施，保护个人信息在在线和离线环境中免受丢失、滥用和未经授权的访问、披露、更改或销毁。然而，没有任何互联网或电子邮件传输是完全安全或无误的。特别是，发送给我们或由我们发送的电子邮件可能不安全。因此，您在决定通过服务或电子邮件向我们发送什么信息时应特别小心。此外，我们不对绕过服务或第三方网站上包含的任何隐私设置或安全措施负责。
//
// 我们将仅保留您的个人信息，以满足向您提供我们的服务的需要，或出于其他合法的业务目的，例如解决争端、安全和保障原因，或遵守我们的法律义务。我们保留个人信息的时间将取决于多种因素，例如信息的数量、性质和敏感性，未经授权使用或披露可能导致的潜在风险，我们处理信息的目的，以及任何法律要求。
//
// 六、第三方服务
// 极态科技服务可能接入或链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：
// 2. 这些功能可能会收集您的信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；
//
// 3. 我们通过广告或我们服务的其他方式向您提供链接，使您可以链接至第三方的服务或网站；
//
// 3、其他接入第三方服务的情形。例如，为实现本政策中声明的目的，我们可能会接入第三方服务商提供的SDK或其他类似的应用程序（如以嵌入代码、插件等形式），以便向您提供更好的客户服务和用户体验。目前，我们接入的第三方服务商主要包括以下几种类型：
// （1）用于广告相关服务，包括广告展示、广告数据监测/统计等；
// （2）用于消息推送功能，包括手机厂商Push推送、特定事件提醒、个性化内容推荐等；
// （3）用于支付相关服务，包括订单支付、交易行为核验、收入结算、支付信息汇总统计等；
// （4）用于在您同意的情况下获取设备位置权限、搜集设备信息和日志信息等；
// （5）用于第三方授权服务，包括第三方账号登陆、将有关内容分享至第三方产品等；
// （6）用于支持产品功能模块，包括在线直播、视频播放、语音识别、AR、智能客服、弹幕播放、内容存储等；
// （7）用于优化产品性能，包括提高硬件配网能力、降低服务器成本、功能热修复等；
// （8）用于账号安全、产品加固相关服务，包括网络监测、域名解析、防劫持、反垃圾反作弊、加解密服务等。
//
// 我们接入的部分第三方SDK或类似应用程序可能会收集您的个人信息，如您在我们的服务中使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。我们会评估这类第三方服务收集个人信息的合法性、正当性、必要性，要求该等第三方对您的个人信息采取保护措施，并严格遵守相关法律法规与监管要求。您也可以选择通过本政策“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快为您作出解答。
//
// 以上第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则。如您发现这些第三方社交媒体或其他服务存在风险时，建议您终止相关操作以保护您的合法权益并及时与我们取得联系。
//
// 我们可能向您发送的信息
//  信息通知
// 您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。如特定的产品和服务存在个性化推送的信息，请您查阅该产品和服务具体的隐私保护指引获取更能多的信息、或关闭个性化推荐。
//
//  与服务有关的公告
// 我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。
//
// 信息安全
// 我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。
// 我们严格遵守法律法规保护用户的通信秘密。
// 我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。
// 我们建立专门的管理制度、流程和组织确保信息安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。
// 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
//
// 七、您的个人信息如何进行跨境转移
// 原则上，我们在中国境内收集和产生的个人信息，将存储在中国境内。如因部分产品或服务涉及跨境等原因，我们需要向境外提供您的个人信息，我们会严格按照法律法规的规定执行，并保证您的个人信息安全。
//
// 八.   国际用户
// 通过使用我们的服务，您理解并承认您的个人信息将在我们位于中国的设施和服务器中进行处理和存储，并可能披露给我们在其他司法管辖区的服务提供商和关联公司。
//
// 处理的法律依据。我们处理您的个人信息的法律依据包括：
// 与您签订的合同的履行，当我们提供和维护我们的服务时。当我们仅为了向您提供我们的服务而处理帐户信息、内容和技术信息时，这些信息是必要的以便能够向您提供我们的服务。如果您不提供这些信息，我们可能无法向您提供我们的服务。我们的合法利益在于保护我们的服务免受滥用、欺诈或安全风险的侵害，包括在开发、改进、推广我们的服务和训练我们的大经济模型时。这可能包括处理帐户信息、内容、社交信息和技术信息。在我们要求您同意为我们向您传达的特定目的处理您的个人信息时的您的同意。您有权随时撤回您的同意。 遵守我们的法律义务，当我们使用您的个人信息遵守适用法律或保护我们或我们的关联公司、用户或第三方的权利、安全和财产时。
//
// 数据传输：在必要时，我们将使用适当的保障措施将个人信息转移至某些国家之外。我们只会根据法律有效的转移机制转移个人信息。
//
// 九、隐私政策的修订
// 我们可能适时修订本隐私政策内容。如该等变更会导致您在本隐私政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。我们会在本页面上发布对本隐私政策所做的任何变更。
//
// 若您不同意该等变更可以停止使用极态科技平台产品和服务。
//
// 本隐私政策所指的重大变更包括但不限于：
// （1） 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
// （2） 个人信息共享、转让或公开披露的主要对象发生变化；
// （3） 您参与个人信息处理方面的权利及其行使方式发生重大变化；
// （4） 其他可能对您的个人信息权益产生重大影响的变化时。
//
// 十、如何联系我们
// 如您对本隐私政策有任何意见或建议，可通过inquiry@jitai.ai联系我们。为保障我们高效处理您的问题并及时向您反馈，需要您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。一般情况下，我们将在15个工作日内回复。
//
// 如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向北京极态科技有限公司住所地有管辖权的法院提起诉讼。
//
//
// 附录1：定义
// 本隐私政策中使用的特定词语，具有如下含义：
// 1. “我们”或“极态科技”，指北京极态科技有限公司。
// 2. “您”，指使用我们的产品和服务的用户以及收费服务的购买方。
// 3. “极态科技关联方、合作方”，指我们的关联公司、投资公司、联盟成员、合作伙伴及其他受信任的第三方供应商、服务商及代理商。
// 4. “我们的产品和服务”或“极态科技平台产品和服务”，指极态科技旗下各项服务（包括但不限于极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾、极态科技手机助手等网站、程序、服务、工具及客户端；具体可参考www.jitai.info）。
// 5. “个人信息”，指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于敏感个人信息。
// 6. “个人信息主体”，指个人信息所标识的自然人。
// 7. “敏感个人信息”，指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
// 8. “去标识化”，指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
// 9. “匿名化”，指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
//     `,
//     tip3:  `
// ## 北京极态科技用户服务协议
// 欢迎您使用北京极态科技提供的服务！
// 一、服务条款的确认和接纳
// 1. 《北京极态科技用户服务协议》（以下简称“本协议”）是用户（以下或称“您”）与北京极态科技有限公司（以下称“极态科技”或“我们”）之间签署的具有法律约束力的协议。本协议适用于极态科技移动客户端（“APP”）、 PC端、WEB端、WAP端等产品及软件著作权归属于极态科技的产品（以下可称“本产品”），如极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾等。您注册极态科技账号和/或使用极态科技提供的任何服务均受本协议之约束。
// 2. 除非您已经充分阅读、完全理解并接受本协议的各项条款，否则您无法使用极态科技提供的产品和服务。如果您在产品相关页面点击接受本协议、或在注册、登录的过程中作出同意本协议的意思表示、或在极态科技向您展示、推送本协议或本协议的更新版本后仍继续使用极态科技提供的服务、或您以其他方式作出同意本协议的意思表示，均代表您完全理解并同意本协议的全部条款。
// 二、协议的范围
// 1. 本协议除正文外，还包含《北京极态科技隐私保护指引》和《北京极态科技风险提示和法律声明》。
// 2. 您在使用极态科技提供的特定服务时，相关特定服务可能涉及单独适用的协议、政策、规则、规范或指引，该等涉及相关特定服务的协议等文件将构成本协议的有效补充，与本协议有同等的法律效力。
// 三、服务内容
// 1. 极态科技向用户提供的服务（以下可称“本服务”）包括但不限于：（1）极态AI Copilot：提供全市场、行业、概念，以及多维度个股的AI分析、推演和预测；（2）极态AI组合优化器：深度分析现有仓位风险暴露、合规隐患，当下优化程度，和AI建议组合优化方案；（3）极态AI策略实验室：提供高仿真的历史回溯实验室，深度分析和对比不同策略的历史表现；（4）极态AI全域风险管理：捕捉市场风险因子，结合市场动态分析和预判，降低事前风险暴露水平，提升事中管控能力，事后深度总结；（5）极态AI投顾：根据客户核心投资需求，利用AI技术匹配多个可选资产配置方案，深度分析不同方案的相对优劣条件，自动完成客户选择方案。定期提供最新配置分析和资产配置方案更新。
// 2. 极态科技的服务是以收费的方式提供的，您可以自行决定付费购买极态科技提供的决策工具权益，具体收费标准可以参考 [www.jitai.info](http://www.jitai.info) 官网上的产品服务模块。“7天无理由退货”不适用于本服务协议。
// 3. 您应当理解，您使用极态科技提供的服务时需自备设备（包括电脑、移动终端等），并承担所需的费用（如上网费等费用），同时，您使用本服务时需耗用终端设备和宽带等资源。
// 4. 您同意极态科技保留在任何时候对本产品进行升级或修改的权利，以及保留针对修改或升级的产品收取费用的权利。
// 5. 您理解并同意，极态科技基于经营策略调整等方面的需要，可能会对服务内容进行变更，也可能中断、中止或终止服务，上述操作均无需经过您的同意或向您发送通知。
// 6. 如果您在使用极态科技的服务时存在以下任意一种情形（或极态科技有合理的理由认为您存在或者可能存在下列任意一种情形），极态科技有权在不经通知且不征求您的同意的情况下，随时中断或终止向您提供部分或全部的服务（包括收费服务和免费服务），而无需对您或任何第三方承担任何责任，由此造成的损失完全由您自行承担：
//   - （1）您向极态科技提供的个人信息或资料不真实；
//   - （2）您违反法律法规、监管要求、公序良俗或本协议的规定；
//   - （3）您在使用极态科技提供的收费服务时未按规定支付相应的服务费用；
//   - （4）您侵犯或涉嫌侵权他人的知识产权、姓名权、名称权、名誉权、荣誉权、肖像权、隐私权、商业秘密等合法权益的；
//   - （5）极态科技按照法律法规的规定，或按照司法机关或监管机构的要求采取中断或终止服务的措施的；
//   - （6）极态科技有其他合理理由认为需要中断或终止向您提供服务的。
// 7. 极态科技提醒您，您有责任自行备份存储在本服务中的与您相关的信息和数据。如果您的服务被终止，极态科技有权从服务器上永久地删除您的信息和数据，法律法规另有规定的除外，极态科技没有义务向您提供或返还任何信息或数据。
// 8. 如您对本指引存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过客服电子邮箱inquiry@jitai.ai联系我们，客服部门将会同相关部门及时答复您。为保障您的信息安全，我们需要先验证您的身份和凭证资料。我们已经建立客户投诉管理机制，包括跟踪流程。一般来说，我们将在验证通过后的5个工作日内处理完成，特殊情形下最长将在不超过15天或法律法规规定期限内作出答复。如您不满意我们的答复，您还可以向消费者权益保护部门投诉或向有管辖权的法院提起诉讼。
// 四、账户注册和认证
// 1. 您在使用极态科技提供的服务前需要注册一个用户账户（以下或称“账户”）。根据《中华人民共和国网络安全法》及《移动互联网应用程序信息服务管理规定》等的实名制的要求，您在注册账户时需要提供您的手机号码，以便完成账户注册并正常使用我们的相关服务。
// 2. 您应保证您在注册账户时所提供的个人信息和资料的真实性、完整性和准确性。您在完善和设置信息时应当确保相关信息的内容和形式符合法律法规、监管要求、本协议的约定以及社会公序良俗，不得侵犯任何主体的合法权益。
// 3. 账户可以用于极态科技旗下的各项产品，包括极态极态AI Copilot、极态AI组合优化器、极态AI策略实验室、极态AI全域风险管理、极态AI投顾等互联网账户的登录。另外，部分数据有区域使用限制、产品使用限制或禁止多终端同时登录使用等限制。
// 4. 极态科技特别提醒您妥善保管您的账户和密码。当您使用完毕后，您应当及时安全退出。因您保管不善导致您的账户被盗用或者密码失窃，相关责任由您自行承担。极态科技明确表示不提供任何类型的担保，不论是明确的或隐含的。账户的使用权不得馈赠、出借、租用、转让或售卖。用户同意保障和维护极态科技全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用，其它人使用用户的电脑、帐号和其它知识产权的追索费。
// 5. 极态科技会采取并不断更新技术措施，努力保护您的账户安全。当您发现账号疑似被盗，建议您尽快修改密码保证账号的安全性。若您遗忘密码，您可以通过手机号验证方式找回密码。若仍无法解决，您可通过客服电子邮箱inquiry@jitai.ai提供证明材料后处理。
// 6. 极态科技分配给您的账户属于极态科技的财产。您的账户被终止或停用后，极态科技可以收回该账户。
// 7. 您有权注销您的账户。您可以通过inquiry@jitai.ai与极态科技的客服取得联系。在您注销账号之后，极态科技将停止为您提供服务，并根据法律法规的规定删除您的个人信息，法律法规另有规定的除外。请您知悉，注销账号是不可逆的行为，一旦您注销账户，您使用极态科技服务的权利马上中止。从那时起，极态科技不再对用户承担任何义务。我们建议您审慎考虑，并在申请注销账户前自行备份与账户相关的个人、自选股、组合、策略等其他信息和数据。
// 五、个人信息的保护
// 1. 极态科技将按照《北京极态科技隐私保护指引》（下称“隐私指引”）收集、使用、存储和分享用户的个人信息。我们非常重视您的隐私保护，在您使用极态科技的服务时，我们将通过隐私指引告知您我们如何收集、使用、存储和共享您的个人信息，以及您如何访问、更新、控制和保护您的个人信息，并说明您享有的权利。
// 2. 用户主动填写的注册信息为北京极态科技有限公司及其子公司所有，北京极态科技有限公司及其子公司可据此为用户提供服务。极态科技一定不会公开、编辑或透露用户的注册资料及保存在极态科技各项服务中的非公开内容，除非极态科技在诚信的基础上认为透露这些信息在以下几种情况是必要的：
//   - （1）遵守有关法律规定，包括在国家有关机关查询时，提供用户在极态科技的网页上发布的信息内容及其发布时间、互联网地址或者域名。
//   - （2）遵从极态科技产品服务程序。
//   - （3）保持维护极态科技的商标所有权。
//   - （4）在紧急情况下竭力维护用户个人和社会大众的隐私安全。
//   - （5）根据第七条的规定或者极态科技认为必要的其他情况下。
// 3. 用户在此授权极态科技可以向其电子邮箱发送商业信息并同意向其预留的电话号码拨打回访电话。用户在享用极态科技各项服务的同时，同意接收极态科技发出的各类信息。
// 4. 我们的业务面向十八周岁以上公民和具有独立法律人格的公司。
// 六、知识产权条款
// 1. 极态科技在产品和服务中所提供的内容（包括但不限于网页、界面设计、设计要素、产品流程设计、版面框架、文字、图片、视频、音频等）所涉及的知识产权归极态科技或相关权利人所有。未经极态科技或相关权利人事先书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
// 2. 极态科技在产品中提供的行情展示、行情分析报告、行情统计、舆情分析、AI模型预测、AI资产评分、AI研报、资产相关性分析、AI组合评分及优化建议、AI投资策略分析、AI生成的投资策略组合等相关数据均为极态科技数据资产。未经事先书面同意，您不得对以上数据进行复制或向任何机构或个人提供全部或部分数据，不得将全部或部分数据用于开发衍生品。您不得以任何方式将全部或部分行情数据用于任何非法目的。
// 七、用户行为规范及法律责任
// 1. 您在使用极态科技提供的服务时必须遵守法律法规、监管要求及社会公共秩序和道德风尚，不得制作、复制、发表、传播、储存存在下列任何一项情形的内容或信息：
//   - （1）违反宪法基本原则的；
//   - （2）违反法律、行政法规、监管要求的；
//   - （3）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
//   - （4）煽动民族仇恨、民族歧视，破坏民族团结的；
//   - （5）破坏国家宗教政策、宣扬邪教和封建迷信的；
//   - （6）散布谣言或虚假信息，扰乱社会秩序，破坏社会稳定的；
//   - （7）有损社会主义道德风尚或违背社会公序良俗的；
//   - （8）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
//   - （9）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
//   - （10）侵害他人知识产权、姓名权、名誉权、荣誉权、肖像权、隐私权、商业秘密等合法权益的；
//   - （11）涉及他人隐私、个人信息或资料，或涉及他人商业秘密的；
//   - （12）包含骚扰信息、垃圾信息、广告信息的；
//   - （13）侮辱或者诽谤他人的；
//   - （14）存在其他法律或行政法规禁止的内容。
// 2. 除非得到极态科技的事先书面许可，您不得从事以下任何一项行为：
//   - （1）删除本产品所有关于版权的信息和内容；
//   - （2）对本产品进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本产品的源代码；
//   - （3）采用任何方式（包括但不限于使用第三方软件、插件、外挂、系统、设备等）对本产品的功能和运行效果进行干扰、破坏、修改或施加其他影响。
// 3. 极态科技如发现或收到他人投诉您存在违反本协议约定、法律法规、监管要求或社会公序良俗的行为时，或极态科技有合理的理由认为您可能存在上述情况时，将会通过技术等手段采取必要措施，相关必要措施包括但不限于对您的账户采取临时或永久功能限制，或终止向您提供服务等，且极态科技有权依据中国法律法规之规定保存有关信息并向相关政府部门进行报告。极态科技可能会根据司法或监管机关的要求，或者在诉讼等法律程序中向相关有权机关提供案件所涉用户的注册信息、身份信息（如有）和联系方式。
// 4. 如您违反本协议约定、法律法规及监管要求导致第三方主张赔偿的，您应当独立承担责任，因此给极态科技造成损失的，您应承担全部的赔偿责任。
// 八、不可抗力及免责声明
// 1. 您理解并同意，您在使用极态科技的产品或服务的过程中可能遭受不可抗力，极态科技将努力配合相关单位或部门进行处理，但在法律允许的范围内对您或第三方遭受的损失免责。
// 2. 您理解并同意，对于极态科技所提供的任何信息、数据和分析结果，极态科技均不保证真实性、完整性和准确性，且相关信息和数据不作为任何投资建议或其他实际操作的建议，用户据此进行市场类、交易类或其它衍生商业决策以及操作所产生的后果由用户自行承担，具体提示请阅读《北京极态科技风险提示和法律声明》。
// 3. 除极态科技与用户签订独立的《用户等级协议》并明确相关服务等级条款的之外，极态科技不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、连续性、安全性、出错发生都不作担保。极态科技拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。用户理解并接受下载或通过极态科技产品服务取得的任何信息资料取决于用户自己，并由其承担系统受损或资料丢失的所有风险和责任。极态科技对在极态科技上得到的任何商品购物服务或交易进程，都不作担保。用户不会从极态科技收到口头或书面的意见或信息，极态科技也不会在这里作明确担保。在法律允许的范围内，极态科技对以下风险不向用户或者任何第三方承担责任：
//   - （1）计算机病毒、木马或其他恶意程序黑客攻击导致的风险；
//   - （2）用户的电脑软件、系统、硬件和通信线路出现故障导致的服务终端、数据丢失或损毁等风险；
//   - （3）网络信号不稳定导致的登录失败、服务中断、资料数据丢失等风险；
//   - （4）用户发布的内容被他人转发和分享的风险；
//   - （5）用户收到来自他人误导、欺骗、威胁或诽谤等非法或不良内容的风险；
//   - （6）用户操作不当或通过非极态科技授权的方式使用服务所导致的风险；
//   - （7）其他极态科技无法合理预见或控制的情形所导致的风险。
// 4. 您理解并同意极态科技对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用产品服务，非法使用服务或用户传送的信息有所变动。这些损害会导致公司形象受损，所以极态科技早已提出这种损害的可能性。
// 5. 您理解并同意，极态科技依据本协议约定获得处理违法违规内容的权利，但该权利不构成极态科技的任何承诺或义务，极态科技不保证能及时发现用户在使用极态科技的产品或服务时存在的违法违规行为，也不保证会对相关违法违规行为进行相应处理。
// 6. 您理解并同意，极态科技保留根据业务需求在不经通知的情况下单方面变更、暂停、终止全部或部分服务内容的权利。您接受极态科技行使变更或中断服务的权利，极态科技不需对用户或第三方负责。
// 7. 您理解并同意，极态科技保留对违反法律法规、监管要求、本协议规定或极态科技发布的其他可适用的规则、政策、指引等的用户暂停或终止向其提供服务的权利。
// 九、通知和送达
// 1. 极态科技可能会通过包括但不限于软件页面提示、网站公告、系统通知、官方管理账号通知（公开或者私下）、手机短信、三方推送、站内消息等通知方式中的一种或多种向您送达相关通知、提示等信息。通知成功发出时，即被视为已送达您。
// 2. 由于用户提供的手机等信息有误或因为其他不可归咎于极态科技的原因，导致用户未收到通知，不影响通知对该用户的效力。
// 3. 极态科技可能通过您的手机号、APP账号等发产品更新，功能更新，产品活动，营销以及其它提示性信息。
// 十、适用法律和争议解决方式
// 1. 本协议的成立、生效、履行、解释和争议解决适用中华人民共和国的法律（不包含港澳台地区法律），并且排除一切冲突法规定的适用。
// 2. 如出现任何争议和纠纷，极态科技将与用户友好协商处理；协商不成时，用户和极态科技一致同意有关本协议以及使用极态科技的服务产生的争议交由仲裁解决，但是极态科技有权选择采取诉讼方式，并有权选择受理该诉讼的有管辖权的法院。若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响。
// 十一、其他
// 1. 您使用极态科技提供的产品或服务视为您已经阅读并接受本协议全部条款的约束。您如果对本协议持有任何异议，应立即停止使用极态科技提供的产品和服务。
// 2. 极态科技有权在必要时修改本协议条款，您可以在相关服务页面查阅最新版本的协议条款。本协议变更后，您继续使用极态科技的产品和/或服务的，视为接受变更后的协议的约束。
// 3. 本协议条款的标题仅为阅读方便，本身无实际含义，不作为本协议涵义解释的依据。
// 4. 本协议条款部分无效或不可执行，其余条款仍有效，对双方具有约束力。
//     `,
//   },
//
//
//   // ProductManual.vue
//   ProductManual: {
//     xx: '极态AI Copilot 是什么',
//     xx: '极态AI的价值是什么',
//     xx: '极态AI的原理和独特优势是什么',
//     xx: '极态AI Copilot 功能模块介绍',
//     xx: 'Copilot 核心指标介绍/历史表现评估',
//
//     xx: '极态AI Copilot 是什么？',
//     xx: '极态AI Copilot是第一款为专业投资机构打造的端到端AI决策辅助平台。',
//     xx: '帮助用户快速掌握全市场的核心趋势动态和未来走势',
//     xx: '让用户抢先挖掘到潜在机会板块/行业机会，并更好的理解市场轮动周期',
//     xx: '诊断现有投资策略组合的优劣程度，提供优化方案',
//     xx: '帮助用户X-Ray每家上市公司的全历史并提供未来2周的走势预测',
//     xx: '帮助用户快速理解趋势背后的依据',
//
//     xx: '极态AI的价值是什么？',
//     xx: '1）极态AI将大量降低用户的投研时间。当下大部分金融机构的主要人力开支在搜集数据/整理数据/理解数据上。极态AI Copilot系统一站式搜集、归类、清洗、阅读并理解每天最新的宏观经济/金融环境，横跨130个L2行业、5000+全A上市公司的数亿笔交易，每天数千个公司动态事件，每天上万份研报/媒体报告和每天数百万的社交媒体互动。在其基础之上，提供可执行的预测结果。让用户从大量的投研工作中解放出来，从而提高决策效率。',
//     xx: '2）极态AI让投资决策更加理性、更具备量化基础。极态AI Copilot 所有的评分机制是基于系统算法计算，没有任何人工输入，更不是简单基于不同机构评分的加权平均，AI的预测输出完全依赖于深度学习寻找底层市场规律。',
//     xx: '3）极态AI让投资策略组合具备穿越牛熊市、大周期和不同行业周期的抗风险能力。正如股神巴菲特99%的财富是在50岁以后积累的。人类积累经验、总结、学习、认知、进化是一个漫长的且艰难的过程，”股神“也需要几十年的时间，在飞速发展的AI时代，我们又有几个几十年可以等待！极态AI第8代原生基座大经济模型的基础汇总了中国以及海外部分市场20年以上的详细宏观微观经济金融大数据，模型自我推导得出所有自然经济/金融规律作为我们预判未来的基准。让用户通过点几下鼠标就能获取N个经济周期、上百个行业、上千家公司的兴盛与衰败的底层规律和市场表现逻辑。新旧工具的更替短期内在行为习惯上是有适应成本的，但是当传统资管方法（基本面、量化）等策略在变幻莫测和充满诸多挑战的残酷市场环境下普遍失效并且出现严重亏损的局面下，即使克隆巴菲特，历史也无法重演。',
//
//     xx: '极态AI的原理和独特优势是什么？',
//     xx: '1）极态AI Copilot 产品，是基于我们第8代基座模型而打造的机构级应用产品。',
//     xx: '2）区别于其它利用机器学习模型的组织或机构，极态AI不堆PHD编辑“特征”，不做特征集的筛选，更不做每天或每周的平凡”模型调优“。我们认为一个足够强大的基座认知模型可以贯穿不同来源、串联不同时空的信息，在金融世界中自我寻求底层逻辑，这就是极态AI的核心工作原理。',
//     xx: '3）所以一个大模型相对传统N个小模型/堆因子的做法有什么优势？我们回顾一下在当下（2024年）人类堆因子 vs 深度学习在N个领域的结果比较一下哪个方式更优：',
//
//     xx: '象棋：StockFish（深度学习）',
//     xx: '围棋：AlphaZero（深度学习）',
//     xx: '画图：Midjourney/Stable diffusion（深度学习）',
//     xx: '语言理解/处理：GPT4/LLAMA3（深度学习）',
//     xx: '语音：Whisper（深度学习）',
//     xx: '蛋白质：AlphaFold（深度学习）',
//     xx: '实时策略游戏：AlphaStar（深度学习）',
//     xx: '自动驾驶：Tesla FSD（深度学习）',
//
//     xx: '趋势应该非常明显了，不是说堆因子一点用也没有，只是在深度学习面前完全是小巫见大巫。',
//     xx: '4）为什么市场上没有更多的公司做这件事情？',
//     xx: '首先，需要独立的基于第一原理重新架构一整套AI模型+配套工程体系的能力。这是一件极其高难度的事情，且非常耗时间。科研容不得半点马虎，更容不得包装。研发需要一个严谨的态度+持久的耐力和韧性。这次因素不代表你会成功，但是必备的基础。拿来注意在短期内看似解决了问题，赚了快钱，没有真正的看家本事，经不起外部力量的较量，迟早是要被卡脖子的。首先，这是极态AI的态度，所以极态AI完全是自研原生AI大经济模型，拥有完整且独立的知识产权。原始架构代码始于2019年，目前已迭代至第8代。在2023年是大模型元年，2024年是应用元年的时候，截止到2024年3月末，极态AI已经完成了3年的实盘数据验证，更是创造了碾压式的天花板业绩。',
//     xx: '极态科技作为一个创新创业型公司，架构出了极态AI这样复杂的原生基座大经济模型，与其独特的创始人背景息息相关。反之，这也是为什么目前国内很多大厂还未能实现的原因。',
//     xx: '王力的背景在海归里面算比较独特的，也许正是因为他的独特，才能研发出来了极态AI，也许正是因为他独特的经历，极态AI才能开辟一条通往AGI-通用人工智能的蹊径。王力出身于一个科学世家，3岁出国，小时候的课外活动是学习如何造原子弹，母语是英语，王力先生读大学期间，他学习的专业是应用数学和法律并修，研究课题是AI对于复杂系统的预测。早在2010年（人工智能寒冬期）就开始专注于AI、混沌论的研究和实践并深耕至今。１５岁参与中国A股市场，他对于金融的理解不是停留经济学课本上，而是把学费交在了实践市场的大课堂上，也正是因此，我们坚信通过博弈机制而迭代进化的大经济模型，是走向通用人工智能（A G I）的蹊径。',
//
//     xx: '极态AI Copilot 功能模块介绍：',
//     xx: '极态AI Copilot 投研助理目前包括三大模块：（全市场，行业，个股分析 ）',
//     xx: '全市场（A股）趋势预测模块：',
//     xx: '行业分析/趋势预测模块',
//     xx: '1）行业预测相图',
//     xx: '2）行业地图（treemap）',
//     xx: '3）行业历史+趋势预测和量价图',
//     xx: '个股分析/趋势预测模块',
//
//     xx: 'Copilot 核心指标介绍/历史表现评估：',
//     xx: '极态AI将提供多个基于不同维度的AI预测，最受关注的是强弱度指数。以下是强弱度指数从20230401 - 20240531 之间的实盘表现。',
//     xx: '最高分段 vs 最低分段的年化回报差距>30%年化。无论是对冲策略、宏观配置策略、指数增强策略或绝对收益策略，极态AI强弱度指数都能帮助客户的策略释放出巨大Alpha。',
//   },




  sageTradeView: {
    performance: '业绩',
    tradeExecution: '交易执行',
    tradeRecord: '交易记录',
    unitNav: '单位净值:',
    totalNav: '累计净值:',
    benchmarkTrack: '跟踪：',
    establishmentDate: '成立日期',
    scale: '规模',
    brokerName: '券商名称',
    strategyName: '策略名称',
    collapseMore: '收起更多<<',
    viewMore: '查看更多>>',
    basicInfo: '基本信息',
    accountName: '账户名称',
    accountType: '账户类型',
    simulated: '模拟',
    live: '实盘',
    productBelonging: '所属产品',
    marketType: '市场类型',
    currency: '币种',
    commissionRate: '佣金税率',
    stampDutyRate: '印花税率',
    transferFeeRate: '过户税率',
    accountStatus: '账户状态',
    available: '可用',
    unavailable: '不可用',
    cumulativeGrowthRate: '累计增长率',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    selectOverlayIndicator: '选择叠加指标',
    logarithm: '对数',
    accountTradingInfo: '账户交易信息',
    totalAssets: '总资产',
    currentMarketValue: '当前市值',
    availableCash: '可用现金',
    dailyBuyQty: '当日买入量',
    dailySellQty: '当日卖出量',
    dailyTradeAmount: '当日交易额',
    dailyPnl: '当日盈亏',
    totalPnl: '总盈亏',
    totalCommission: '总佣金',
    totalStampDuty: '总印花税',
    latestNav: '最新净值',
    performanceOverview: '业绩表现',
    cumulativeReturn: '累计收益',
    annualizedReturn: '年化收益率',
    maxDrawdown: '最大回撤',
    annualizedVolatility: '年化波动率',
    benchmarkSuffix: '(基准)',
    all: '全部',
    past3Months: '近3个月',
    past6Months: '近6个月',
    past2Months: '近2个月',
    past4Months: '近4个月',
    past1Year: '近1年',
  },
  sageTradeExecution: {
    selectDate: '请选择日期',
    rebalancingOverview: '调仓概述',
    type: '类型',
    plannedAdjustment: '计划调整',
    actualAdjustment: '实际调整',
    totalBuyAmount: '总买金额',
    totalSellAmount: '总卖金额',
    totalAdjustedAmount: '总调整金额',
    totalBuyPosition: '总买仓位',
    totalSellPosition: '总卖仓位',
    totalAdjustedPosition: '总调整仓位',
    slippageOverview: '滑点概述',
    budgetValue: '预算值',
    actualValue: '实际值',
    buySlippageBp: '买入滑点(基点)',
    sellSlippageBp: '卖出滑点(基点)',
    totalSlippageBp: '总滑点(基点)',
    rebalancingProgress: '调仓总进度',
    completed: '已完成',
    remaining: '未完成',
    position: '仓位',
    positionAdjustment: '仓位调整',
    currentAssetDistribution: '当前资产分布',
    targetAssetDistribution: '目标资产分布',
    stock: '股票',
    fund: '基金',
    bond: '债券',
    repo: '回购',
    cash: '现金',
  },
  sageTradeList: {
    titleOrder: '交易订单',
    titleHistory: '逐笔成交历史',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    name: '名称',
    orderNo: '订单号',
    tradeNo: '交易号',
    direction: '方向',
    buy: '买入',
    sell: '卖出',
    cancel: '撤单',
    orderStatus: '订单状态',
    filled: '全部成交',
    partialFilled: '部分成交',
    unfilled: '未成交',
    tradeQty: '成交数量',
    tradeAvgPrice: '成交均价',
    tradeAmount: '成交金额',
    tradeTime: '成交时间',
    tradeDate: '交易日期',
    targetQty: '委托数量',
    targetPrice: '委托价格',
    yuan: '元',
  },
  sageTradeRecord: {
    total: '总计',
    positionDetail: '持仓详情',
    currentPositionDetail: '当前持仓详情',
    rebalancePlan: '调仓计划',
    orderHistory: '下单历史',
    tradeHistory: '成交历史',
    liquidatedStock: '清仓股票',
    startDate: '开始日期',
    endDate: '结束日期',
    tradeDate: '交易日期',
    selectDate: '请选择日期',
    dataDownload: '数据下载',
    name: '名称',
    positionQty: '持仓数量(股)',
    positionQtyShort: '持仓(股)',
    positionAvgPrice: '持仓均价(元)',
    totalMarketValue: '总市值(元)',
    dailyPnl: '今日盈亏(元)',
    floatPnl: '浮动盈亏(元)',
    currentPrice: '当前价格(元)',
    restSellQty: '可卖数量(股)',
    positionBuildAmount: '建仓金额(元)',
    principal: '本金(元)',
    totalCommission: '累计佣金(元)',
    totalStampDuty: '累计印花税(元)',
    totalTransferFee: '累计过户税(元)',
    dailyCommission: '当日佣金(元)',
    dailyStampDuty: '当日印花税(元)',
    dailyTransferFee: '当日过户税(元)',
    dailyBuyAmount: '当日买入额(元)',
    dailySellAmount: '当日卖出额(元)',
    dailyBuyQty: '当日买入量(股)',
    dailySellQty: '当日卖出量(股)',
    positionDate: '持仓日期',
    prevClosePrice: '昨日收盘价(元)',
    cost: '成本(元)',
    marketValue: '市值(元)',
    currentWeight: '当前权重',
    rebalanceDate: '调仓日期',
    targetWeight: '目标权重',
    weightDelta: '权重偏离',
    tradeDirection: '成交方向',
    buy: '买入',
    sell: '卖出',
    unchanged: '不变',
    orderNo: '订单号',
    tradeNo: '交易号',
    direction: '方向',
    orderStatus: '订单状态',
    filled: '成交',
    partialFilled: '部分成交',
    unfilled: '未成交',
    tradeQty: '成交数量(股)',
    tradeAvgPrice: '成交均价(元)',
    tradeAmount: '成交金额(元)',
    targetQty: '委托数量(股)',
    targetPrice: '委托价格(元)',
    winRate: '赢率',
    payoffRatio: '赔率',
    securityName: '证券名称',
    liquidatedDate: '清仓日期',
    holdingDays: '持股天数',
    totalPnl: '总盈亏(元)',
    holdingStartDate: '持仓开始时间',
    holdingEndDate: '持仓结束时间',
    tradingFee: '交易费用(元)',
    detail: '详情',
    viewDetail: '查看详情',
    tradeDetail: '交易详情',
    action: '操作',
    tradePrice: '成交价(元)',
    commission: '佣金(元)',
    stampDuty: '印花税(元)',
    transferFee: '交易费(元)',
    totalTradeFee: '总交易费(元)',
    close: '关闭',
    buildPosition: '建仓',
  },
  sageBacktestList: {
    title: '回测历史',
    strategyName: '策略名称',
    creator: '创建人',
    startTime: '开始时间',
    endTime: '结束时间',
    action: '操作',
    view: '查看',
  },
  sageEvaluation: {
    strategyName: '策略名称',
    evaluationDate: '评估日期',
    annualizedReturn: '年化回报率',
    annualizedVolatility: '年化波动率',
    sharpeRatio: '夏普比率',
    maxDrawdown: '最大回撤',
    winRate: '胜率',
    profitLossRatio: '盈亏比',
    turnoverRate: '换手率',
    capacity: '策略容量',
    avgHoldingPeriod: '平均持仓时间',
    tradeFrequency: '交易频率',
    exposure: '市场暴露度',
    trackingError: '跟踪误差',
    evaluation: '评价：',
    evaluationHistory: '评估历史',
    alpha: '超额收益',
    beta: '贝塔值',
    informationRatio: '信息比率',
    turnoverCostRate: '交易费用率',
    positionHistory: '持仓历史',
    selectDate: '选择日期',
    name: '名称',
    positionQty: '持仓数量',
    positionAvgPrice: '持仓均价',
    currentPrice: '当前价格',
    totalMarketValue: '总市值',
    restSellQty: '可卖数量',
    floatPnl: '浮动盈亏',
    totalPnl: '累计盈亏',
    dailyPnl: '当日盈亏',
    dailyBuyQty: '当日买入量',
    dailySellQty: '当日卖出量',
    dailyBuyAmount: '当日买入额',
    dailySellAmount: '当日卖出额',
    dailyCommission: '当日佣金',
    dailyStampDuty: '当日印花税',
    dailyTransferFee: '当日过户费',
    tradeDate: '交易日期',
    status: '状态',
    available: '可用',
    unavailable: '不可用',
    shareUnit: '股',
    yuanUnit: '元',
    dayUnit: '天',
    timesPerYear: '次/年',
  },
};


